import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: string;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
};

/** Autogenerated input type of AddAngelInvestmentInvitation */
export type AddAngelInvestmentInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddAngelInvitation */
export type AddAngelInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資先企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddCompanyInvestment */
export type AddCompanyInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  investingCompanyId: Scalars['ID'];
};

/** Autogenerated input type of AddCompanyMember */
export type AddCompanyMemberInputBase = {
  attributes: CompanyMemberInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddCompanyReference */
export type AddCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  slug: Scalars['ID'];
};

/** Autogenerated input type of AddExperience */
export type AddExperienceInputBase = {
  attributes: ExperienceInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddFootprintToJob */
export type AddFootprintToJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of AddInvestor */
export type AddInvestorInputBase = {
  attributes: InvestorInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddMemberInvitation */
export type AddMemberInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** メンバーになる企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddMyInvestment */
export type AddMyInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddMyJobBookmark */
export type AddMyJobBookmarkInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of AddProduct */
export type AddProductInputBase = {
  attributes: ProductInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of AddToken */
export type AddTokenInputBase = {
  attributes: TokenInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddTokenTransaction */
export type AddTokenTransactionInputBase = {
  answerId?: InputMaybe<Scalars['ID']>;
  articleId?: InputMaybe<Scalars['ID']>;
  attributes: TokenTransactionInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of AddUserAttachment */
export type AddUserAttachmentInputBase = {
  attributes: UserAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of AddUserInvitation */
export type AddUserInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddUserReference */
export type AddUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  username: Scalars['ID'];
};

/** Autogenerated input type of AddVcInvestmentInvitation */
export type AddVcInvestmentInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資元企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of AddVcInvitation */
export type AddVcInvitationInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** 投資先企業の ID */
  companyId: Scalars['ID'];
  /** 失効期限 */
  days: Scalars['Int'];
  /** 招待メール先アドレス */
  emails?: InputMaybe<Array<Scalars['String']>>;
};

export type AnswerBase = {
  __typename?: 'Answer';
  amount?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  childReplies?: Maybe<Array<AnswerBase>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  parentReply?: Maybe<AnswerBase>;
  question?: Maybe<QuestionBase>;
  repliesCount?: Maybe<Scalars['Int']>;
  respondent?: Maybe<UserBase>;
  rootQuestion?: Maybe<QuestionBase>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<AnswerStatusBase>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for Answer. */
export type AnswerConnection = {
  __typename?: 'AnswerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AnswerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AnswerBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AnswerEdge = {
  __typename?: 'AnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AnswerBase>;
};

export type AnswerNotificationBase = {
  __typename?: 'AnswerNotification';
  answer: AnswerBase;
  id: Scalars['ID'];
};

export enum AnswerStatusBase {
  BEST = 'BEST',
  HIDDEN = 'HIDDEN',
  SHOWN = 'SHOWN'
}

/** Autogenerated input type of ApplyForJob */
export type ApplyForJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
  message: Scalars['String'];
};

export type ArticleBase = {
  __typename?: 'Article';
  category?: Maybe<CategoryBase>;
  company?: Maybe<CompanyBase>;
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  fundraisingManualFields?: Maybe<FundraisingManualBase>;
  id?: Maybe<Scalars['ID']>;
  isLiked?: Maybe<Scalars['Boolean']>;
  likedUsersCount?: Maybe<Scalars['Int']>;
  ogImage?: Maybe<Scalars['String']>;
  opinionsUser?: Maybe<UserBase>;
  originalArticleUrl?: Maybe<Scalars['String']>;
  originalSiteName?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
  status: ArticleStatus;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  topics?: Maybe<Array<TopicBase>>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ArticleAttachmentBase = {
  __typename?: 'ArticleAttachment';
  id: Scalars['ID'];
  image: Scalars['String'];
};

/** 記事の添付画像作成用の属性 */
export type ArticleAttachmentInputBase = {
  /** 画像 */
  image: Scalars['String'];
};

/** The connection type for Article. */
export type ArticleConnection = {
  __typename?: 'ArticleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ArticleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ArticleBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ArticleEdge = {
  __typename?: 'ArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ArticleBase>;
};

/** 記事作成用の属性 */
export type ArticleInputBase = {
  /** 記事の内容 */
  content?: InputMaybe<Scalars['String']>;
  /** 記事のディスクリプション */
  description?: InputMaybe<Scalars['String']>;
  /** 記事のOGイメージ */
  ogImage?: InputMaybe<Scalars['String']>;
  /** 記事のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 記事の公開ステータス */
  status: ArticleStatus;
  /** 記事のサムネイル */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** 記事のタイトル */
  title: Scalars['String'];
};

export enum ArticleStatus {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type BlockchainBase = {
  __typename?: 'Blockchain';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['ID']>;
};

/** The connection type for Blockchain. */
export type BlockchainConnection = {
  __typename?: 'BlockchainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BlockchainEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BlockchainBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BlockchainEdge = {
  __typename?: 'BlockchainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<BlockchainBase>;
};

export type CategoryBase = {
  __typename?: 'Category';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ChangeSoldOut */
export type ChangeSoldOutInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  listingAddress: Scalars['String'];
};

export type ChoiceBase = {
  __typename?: 'Choice';
  id: Scalars['ID'];
  name: Scalars['String'];
  question?: Maybe<QuestionBase>;
  votes: Scalars['Int'];
};

/** 選択肢作成用の属性 */
export type ChoiceInputBase = {
  /** 選択肢名 */
  name: Scalars['String'];
};

export enum CommenterTypeBase {
  INVESTOR = 'INVESTOR',
  STARTUP = 'STARTUP'
}

export type CompanyBase = {
  __typename?: 'Company';
  aboutUs?: Maybe<Scalars['String']>;
  articles?: Maybe<ArticleConnection>;
  blockchains?: Maybe<Array<BlockchainBase>>;
  companyMembers?: Maybe<Array<CompanyMemberBase>>;
  companyReferences?: Maybe<CompanyReferenceConnection>;
  companySize?: Maybe<CompanySize>;
  conceptPitch?: Maybe<Scalars['String']>;
  currencyUnit?: Maybe<CurrencyUnit>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  discordUrl?: Maybe<Scalars['String']>;
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  facebookUrl?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  hasInvestmentsWithJobs?: Maybe<Scalars['Boolean']>;
  headerImage?: Maybe<Scalars['String']>;
  highlightedJobListings?: Maybe<JobConnection>;
  id?: Maybe<Scalars['ID']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  investments?: Maybe<Array<InvestmentBase>>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isVc?: Maybe<Scalars['Boolean']>;
  jobs?: Maybe<JobConnection>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  logo?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<MarketBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<Array<CompanyNotificationBase>>;
  openseaUrl?: Maybe<Scalars['String']>;
  products?: Maybe<Array<ProductBase>>;
  receivedInvestments?: Maybe<Array<InvestmentBase>>;
  round?: Maybe<RoundBase>;
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  telegramUrl?: Maybe<Scalars['String']>;
  totalFundingAmount?: Maybe<Scalars['BigInt']>;
  twitterUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


export type CompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyCompanyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyHighlightedJobListingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyBase>;
};

/** 会社作成用の属性 */
export type CompanyInputBase = {
  /** 会社の詳細な説明 */
  aboutUs?: InputMaybe<Scalars['String']>;
  /** 従業員の概数 */
  companySize?: InputMaybe<CompanySize>;
  /** 会社を一文で表す文言 */
  conceptPitch?: InputMaybe<Scalars['String']>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** メッセージを受け付けるか */
  denyNewContact?: InputMaybe<Scalars['Boolean']>;
  /** DiscordのURL */
  discordUrl?: InputMaybe<Scalars['String']>;
  /** 一覧表示させるかの判定 */
  excludeFromSearch?: InputMaybe<Scalars['Boolean']>;
  /** FacebookのURL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** ヘッダー画像 */
  headerImage?: InputMaybe<Scalars['String']>;
  /** InstagramのURL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 投資対象領域のID配列 */
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 投資対象ラウンドのID配列 */
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  /** VCかどうかの判定 */
  isVc?: InputMaybe<Scalars['Boolean']>;
  /** LinkedInのURL */
  linkedinUrl?: InputMaybe<Scalars['String']>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 会社のロゴ */
  logo?: InputMaybe<Scalars['String']>;
  /** マーケットのID配列 */
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大投資金額 */
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 最小投資金額 */
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 本名 */
  name: Scalars['String'];
  /** OpenSeaのURL */
  openseaUrl?: InputMaybe<Scalars['String']>;
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** 会社のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 公開・非公開 */
  status?: InputMaybe<Scalars['String']>;
  /** TelegramのURL */
  telegramUrl?: InputMaybe<Scalars['String']>;
  /** 合計資金調達金額 */
  totalFundingAmount?: InputMaybe<Scalars['BigInt']>;
  /** TwitterのURL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** コーポレートサイトのURL */
  url?: InputMaybe<Scalars['String']>;
  /** YoutubeのURL */
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type CompanyMemberBase = {
  __typename?: 'CompanyMember';
  company?: Maybe<CompanyBase>;
  id?: Maybe<Scalars['ID']>;
  user?: Maybe<UserBase>;
};

/** 会社員追加・更新用の属性 */
export type CompanyMemberInputBase = {
  /** 所属の会社 */
  companyId: Scalars['ID'];
  /** 会社員の役割 */
  role: CompanyMemberRole;
  /** 会社員のユーザーアカウント */
  userId: Scalars['ID'];
};

export enum CompanyMemberRole {
  EDITOR = 'EDITOR',
  OWNER = 'OWNER',
  RECRUITER = 'RECRUITER'
}

export type CompanyNotificationBase = {
  __typename?: 'CompanyNotification';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** 会社の並び順 */
export type CompanyOrderBase = {
  /** ソートする会社のフィールド */
  companyOrderField: CompanyOrderFieldBase;
  /** 昇順・降順 */
  direction: OrderDirection;
};

export enum CompanyOrderFieldBase {
  CREATED_AT = 'CREATED_AT',
  GENERAL_SCORE = 'GENERAL_SCORE',
  STARTUP_SCORE = 'STARTUP_SCORE',
  VC_SCORE = 'VC_SCORE'
}

export type CompanyReferenceBase = {
  __typename?: 'CompanyReference';
  comment: Scalars['String'];
  commenter?: Maybe<UserBase>;
  id: Scalars['ID'];
  status: CompanyReferenceStatus;
};

/** The connection type for CompanyReference. */
export type CompanyReferenceConnection = {
  __typename?: 'CompanyReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyReferenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyReferenceBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyReferenceEdge = {
  __typename?: 'CompanyReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyReferenceBase>;
};

export enum CompanyReferenceStatus {
  HIDDEN = 'HIDDEN',
  SHOWN = 'SHOWN'
}

export enum CompanySize {
  FROM_1_TO_10 = 'FROM_1_TO_10',
  FROM_11_TO_50 = 'FROM_11_TO_50',
  FROM_51_TO_200 = 'FROM_51_TO_200',
  FROM_201_TO_500 = 'FROM_201_TO_500',
  FROM_501_TO_1000 = 'FROM_501_TO_1000',
  FROM_1001_TO_5000 = 'FROM_1001_TO_5000',
  OVER_5000 = 'OVER_5000',
  UNKNOWN = 'UNKNOWN'
}

/** Autogenerated input type of CreateArticleAttachment */
export type CreateArticleAttachmentInputBase = {
  attributes: ArticleAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateCompanyArticle */
export type CreateCompanyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateCompany */
export type CreateCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateJobAttachment */
export type CreateJobAttachmentInputBase = {
  attributes: JobAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateJob */
export type CreateJobInputBase = {
  attributes: JobInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of CreateMessageThread */
export type CreateMessageThreadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

/** Autogenerated input type of CreateMyAnswer */
export type CreateMyAnswerInputBase = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of CreateMyArticle */
export type CreateMyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyCompany */
export type CreateMyCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyOffer */
export type CreateMyOfferInputBase = {
  attributes: OfferInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyQuestion */
export type CreateMyQuestionInputBase = {
  attributes: QuestionInputBase;
  choices?: InputMaybe<Array<ChoiceInputBase>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateMyReply */
export type CreateMyReplyInputBase = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of CreateSkill */
export type CreateSkillInputBase = {
  attributes: SkillInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export enum CurrencyUnit {
  JPY = 'JPY',
  USD = 'USD'
}

/** Autogenerated input type of DeleteArticle */
export type DeleteArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteCompanyArticle */
export type DeleteCompanyArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteJob */
export type DeleteJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteMyAnswer */
export type DeleteMyAnswerInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteMyArticle */
export type DeleteMyArticleInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteMyOffer */
export type DeleteMyOfferInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteMyQuestion */
export type DeleteMyQuestionInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DeleteUserAttachment */
export type DeleteUserAttachmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DuplicateJob */
export type DuplicateJobInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ExperienceBase = {
  __typename?: 'Experience';
  addedByUser: UserBase;
  company: CompanyBase;
  current: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/** 職歴作成用の属性 */
export type ExperienceInputBase = {
  /** 職歴の会社 */
  companyId: Scalars['ID'];
  /** 現在も所属しているか */
  current?: InputMaybe<Scalars['Boolean']>;
  /** 職歴についての説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 職歴の終わった日時 */
  endedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 職歴の始まった日時 */
  startedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 追加の可否 */
  status?: InputMaybe<Scalars['String']>;
  /** 役職 */
  title: Scalars['String'];
  /** 対象ユーザー */
  userId: Scalars['ID'];
};

export type FollowableEntityBase = {
  __typename?: 'FollowableEntity';
  category: FollowableEntityCategory;
  description?: Maybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  image?: Maybe<Scalars['String']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  isVerifiedAccount?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
};

export enum FollowableEntityCategory {
  ANGEL = 'ANGEL',
  STARTUP = 'STARTUP',
  USER = 'USER',
  VC = 'VC'
}

/** The connection type for FollowableEntity. */
export type FollowableEntityConnection = {
  __typename?: 'FollowableEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FollowableEntityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<FollowableEntityBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FollowableEntityEdge = {
  __typename?: 'FollowableEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<FollowableEntityBase>;
};

export enum FollowableEntityEntityType {
  COMPANY = 'COMPANY',
  USER = 'USER'
}

export type FundraisingManualBase = {
  __typename?: 'FundraisingManual';
  id: Scalars['ID'];
  step: Scalars['Int'];
  subcategory: FundraisingManualSubcategory;
};

export enum FundraisingManualSubcategory {
  PRACTICES = 'PRACTICES',
  THEORIES = 'THEORIES'
}

export type InvestmentBase = {
  __typename?: 'Investment';
  angel?: Maybe<UserBase>;
  company?: Maybe<CompanyBase>;
  companyInvestedFrom?: Maybe<CompanyBase>;
  id: Scalars['ID'];
  investedAt?: Maybe<Scalars['ISO8601DateTime']>;
  investorComment?: Maybe<InvestmentCommentBase>;
  isLeadInvestor?: Maybe<Scalars['Boolean']>;
  referenceUrl?: Maybe<Scalars['String']>;
  round?: Maybe<RoundBase>;
  startupComment?: Maybe<InvestmentCommentBase>;
  tokens?: Maybe<Array<TokenBase>>;
};

export type InvestmentCommentBase = {
  __typename?: 'InvestmentComment';
  comment: Scalars['String'];
  commenter: UserBase;
  commenterType: CommenterTypeBase;
};

/** インベストメント作成・更新用の属性 */
export type InvestmentInputBase = {
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 投資先会社 */
  companyId: Scalars['ID'];
  /** 投資した日時 */
  investedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** リードで出資したか */
  isLeadInvestor?: InputMaybe<Scalars['Boolean']>;
  /** 参照データ用のURL */
  referenceUrl?: InputMaybe<Scalars['String']>;
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** トークンのID配列 */
  tokenIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** 投資先会社（自社）によるインベストメント作成・更新用の属性 */
export type InvestorInputBase = {
  /** 投資元エンジェル投資家 */
  angelUserId?: InputMaybe<Scalars['ID']>;
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 投資先会社（自社） */
  companyId: Scalars['ID'];
  /** 投資した日時 */
  investedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** リードで出資したか */
  isLeadInvestor?: InputMaybe<Scalars['Boolean']>;
  /** 参照データ用のURL */
  referenceUrl?: InputMaybe<Scalars['String']>;
  /** 投資のラウンド */
  roundId?: InputMaybe<Scalars['ID']>;
  /** 投資元VC */
  vcCompanyId?: InputMaybe<Scalars['ID']>;
};

export type InvitationBase = {
  __typename?: 'Invitation';
  invitationOf: InvitationOfBase;
  isValid: Scalars['Boolean'];
};

export type InvitationLinkBase = {
  __typename?: 'InvitationLink';
  url: Scalars['String'];
};

export enum InvitationOfBase {
  ANGEL = 'ANGEL',
  ANGEL_INVESTMENT = 'ANGEL_INVESTMENT',
  MEMBER = 'MEMBER',
  USER = 'USER',
  VC = 'VC',
  VC_INVESTMENT = 'VC_INVESTMENT'
}

export type JobBase = {
  __typename?: 'Job';
  address?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  company?: Maybe<CompanyBase>;
  createdAt: Scalars['ISO8601DateTime'];
  currencyUnit: CurrencyUnit;
  equityGrant: Scalars['Boolean'];
  id: Scalars['ID'];
  jobCategories: Array<JobCategoryBase>;
  jobTags: Array<JobTagBase>;
  locations?: Maybe<Array<LocationBase>>;
  maxMonthlySalary: Scalars['BigInt'];
  minMonthlySalary: Scalars['BigInt'];
  primaryJobCategory?: Maybe<JobCategoryBase>;
  primaryRecruitingContact?: Maybe<UserBase>;
  skills: Array<SkillBase>;
  slug: Scalars['ID'];
  status: JobStatus;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  tokenGrant: Scalars['Boolean'];
  typeOfPosition: JobTypeOfPosition;
  updatedAt: Scalars['ISO8601DateTime'];
  workExperience: JobWorkExperience;
  workingForm: JobWorkingForm;
};

export type JobApplicationBase = {
  __typename?: 'JobApplication';
  id: Scalars['ID'];
  job: JobBase;
  messageThread: MessageThreadBase;
  user: UserBase;
};

/** The connection type for JobApplication. */
export type JobApplicationConnection = {
  __typename?: 'JobApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobApplicationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobApplicationEdge = {
  __typename?: 'JobApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobApplicationBase>;
};

export type JobAttachmentBase = {
  __typename?: 'JobAttachment';
  id: Scalars['ID'];
  image: Scalars['String'];
};

/** 募集の添付画像作成用の属性 */
export type JobAttachmentInputBase = {
  /** 画像 */
  image: Scalars['String'];
};

export type JobBookmarkBase = {
  __typename?: 'JobBookmark';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  job: JobBase;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<UserBase>;
};

/** The connection type for JobBookmark. */
export type JobBookmarkConnection = {
  __typename?: 'JobBookmarkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobBookmarkEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobBookmarkBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobBookmarkEdge = {
  __typename?: 'JobBookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobBookmarkBase>;
};

export type JobCategoryBase = {
  __typename?: 'JobCategory';
  id: Scalars['ID'];
  jobCategoryType: JobCategoryType;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum JobCategoryType {
  DESIGNER = 'DESIGNER',
  ENGINEERING = 'ENGINEERING',
  MANAGEMENT = 'MANAGEMENT',
  MARKETING = 'MARKETING',
  OPERATIONS = 'OPERATIONS',
  OTHER = 'OTHER',
  PRODUCT = 'PRODUCT',
  SALES = 'SALES',
  UNKNOWN = 'UNKNOWN'
}

/** The connection type for Job. */
export type JobConnection = {
  __typename?: 'JobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobEdge = {
  __typename?: 'JobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobBase>;
};

export type JobFootprintBase = {
  __typename?: 'JobFootprint';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  job?: Maybe<JobBase>;
  referer?: Maybe<Scalars['String']>;
  user?: Maybe<UserBase>;
};

/** The connection type for JobFootprint. */
export type JobFootprintConnection = {
  __typename?: 'JobFootprintConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobFootprintEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobFootprintBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobFootprintEdge = {
  __typename?: 'JobFootprintEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobFootprintBase>;
};

/** 募集作成用の属性 */
export type JobInputBase = {
  /** 住所 */
  address?: InputMaybe<Scalars['String']>;
  /** 募集内容 */
  body?: InputMaybe<Scalars['String']>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** SO含む株式の付与があるかどうか */
  equityGrant?: InputMaybe<Scalars['Boolean']>;
  /** 募集カテゴリーのID配列 */
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 特徴のID配列 */
  jobTagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大給与額 */
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  /** 最小給与額 */
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  /** 採用担当者 */
  primaryRecruitingContactId: Scalars['ID'];
  /** スキルのID配列 */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 募集のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 募集の公開ステータス */
  status?: InputMaybe<JobStatus>;
  /** 募集のサムネイル */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** 募集のタイトル */
  title: Scalars['String'];
  /** トークンの付与があるかどうか */
  tokenGrant?: InputMaybe<Scalars['Boolean']>;
  /** 募集形態 */
  typeOfPosition?: InputMaybe<JobTypeOfPosition>;
  /** 経験年数 */
  workExperience?: InputMaybe<JobWorkExperience>;
  /** 勤務形態 */
  workingForm?: InputMaybe<JobWorkingForm>;
};

export type JobSeekingStatusUpdatedNotificationBase = {
  __typename?: 'JobSeekingStatusUpdatedNotification';
  id: Scalars['ID'];
  user: UserBase;
};

export enum JobStatus {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type JobTagBase = {
  __typename?: 'JobTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum JobTypeOfPosition {
  COFOUNDER = 'COFOUNDER',
  CONTRACTOR = 'CONTRACTOR',
  FREELANCER = 'FREELANCER',
  FULL_TIME_EMPLOYEE = 'FULL_TIME_EMPLOYEE',
  INTERN = 'INTERN',
  NEW_GRADUATE = 'NEW_GRADUATE',
  PART_TIMER = 'PART_TIMER'
}

export enum JobWorkExperience {
  EIGHT_YEARS_OR_MORE = 'EIGHT_YEARS_OR_MORE',
  FIVE_YEARS_OR_MORE = 'FIVE_YEARS_OR_MORE',
  FOUR_YEARS_OR_MORE = 'FOUR_YEARS_OR_MORE',
  NINE_YEARS_OR_MORE = 'NINE_YEARS_OR_MORE',
  NOT_REQUIRED = 'NOT_REQUIRED',
  ONE_YEAR_OR_MORE = 'ONE_YEAR_OR_MORE',
  SEVEN_YEARS_OR_MORE = 'SEVEN_YEARS_OR_MORE',
  SIX_YEARS_OR_MORE = 'SIX_YEARS_OR_MORE',
  TEN_YEARS_OR_MORE = 'TEN_YEARS_OR_MORE',
  THREE_YEARS_OR_MORE = 'THREE_YEARS_OR_MORE',
  TWO_YEARS_OR_MORE = 'TWO_YEARS_OR_MORE',
  ZERO_YEAR_OR_MORE = 'ZERO_YEAR_OR_MORE'
}

export enum JobWorkingForm {
  IN_OFFICE_ONLY = 'IN_OFFICE_ONLY',
  REMOTE_ACCEPTED = 'REMOTE_ACCEPTED',
  REMOTE_ONLY = 'REMOTE_ONLY'
}

/** Autogenerated input type of LeaveService */
export type LeaveServiceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ListingBase = {
  __typename?: 'Listing';
  id?: Maybe<Scalars['ID']>;
  isSold?: Maybe<Scalars['Boolean']>;
  listingAddress?: Maybe<Scalars['String']>;
  listingAddressSol?: Maybe<Scalars['String']>;
  listingAmount?: Maybe<Scalars['String']>;
  listingAmountSol?: Maybe<Scalars['String']>;
};

export type LocationBase = {
  __typename?: 'Location';
  id: Scalars['ID'];
  locationType: LocationCategory;
  name: Scalars['String'];
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
};

export enum LocationCategory {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  STATE = 'STATE'
}

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LocationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<LocationBase>;
};

/** Autogenerated input type of MarkAllMessagesAsRead */
export type MarkAllMessagesAsReadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated return type of MarkAllMessagesAsRead */
export type MarkAllMessagesAsReadPayload = {
  __typename?: 'MarkAllMessagesAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of MarkNotificationsAsRead */
export type MarkNotificationsAsReadInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of MarkNotificationsAsRead */
export type MarkNotificationsAsReadPayload = {
  __typename?: 'MarkNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasUnreadNotifications?: Maybe<Scalars['Boolean']>;
  notifications?: Maybe<Array<NotificationBase>>;
};

export type MarketBase = {
  __typename?: 'Market';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type MeBase = {
  __typename?: 'Me';
  companyMembers?: Maybe<Array<MyCompanyMemberBase>>;
  email: Scalars['String'];
  experiences?: Maybe<Array<ExperienceBase>>;
  hasUnreadNotifications?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  investments?: Maybe<Array<InvestmentBase>>;
  invitationOf?: Maybe<InvitationOfBase>;
  isFirstSignIn?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notifications?: Maybe<NotificationConnection>;
  profile?: Maybe<UserProfileBase>;
  status?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  userAttachments?: Maybe<Array<UserAttachmentBase>>;
  username: Scalars['String'];
};


export type MeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MessageBase = {
  __typename?: 'Message';
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  messageAttachments?: Maybe<Array<MessageAttachmentBase>>;
  messageThread?: Maybe<MessageThreadBase>;
  readers?: Maybe<Array<UserBase>>;
  updatedAt: Scalars['ISO8601DateTime'];
  user: UserBase;
};

export type MessageAttachmentBase = {
  __typename?: 'MessageAttachment';
  file: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  mimeType: Scalars['String'];
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MessageBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MessageBase>;
};

export type MessageThreadBase = {
  __typename?: 'MessageThread';
  id?: Maybe<Scalars['ID']>;
  jobApplication?: Maybe<JobApplicationBase>;
  messageThreadType: MessageThreadType;
  messages?: Maybe<MessageConnection>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['ID'];
  users?: Maybe<Array<UserBase>>;
};


export type MessageThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum MessageThreadType {
  GENERAL = 'GENERAL',
  RECRUITING = 'RECRUITING'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** エンジェル投資家の投資先の招待リンク発行 */
  addAngelInvestmentInvitation?: Maybe<InvitationLinkBase>;
  /** エンジェル投資家の招待リンク発行 */
  addAngelInvitation?: Maybe<InvitationLinkBase>;
  /** 投資元会社が投資先会社を追加する */
  addCompanyInvestment?: Maybe<InvestmentBase>;
  /** 会社員を追加する */
  addCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** 会社のリファレンスを追加する */
  addCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を追加する */
  addExperience?: Maybe<ExperienceBase>;
  /** 募集に足跡をつける */
  addFootprintToJob?: Maybe<JobBase>;
  /** 自社（スタートアップ）が投資元を追加する */
  addInvestor?: Maybe<InvestmentBase>;
  /** メンバーの招待リンク発行 */
  addMemberInvitation?: Maybe<InvitationLinkBase>;
  /** ログインユーザー（エンジェル投資家）が自分の投資先を追加する */
  addMyInvestment?: Maybe<InvestmentBase>;
  /** 求人ブックマークを追加する */
  addMyJobBookmark?: Maybe<JobBookmarkBase>;
  /** プロダクトを追加する */
  addProduct?: Maybe<ProductBase>;
  /** トークンを追加する */
  addToken?: Maybe<TokenBase>;
  /** トークン送信に関するトランザクションを追加 */
  addTokenTransaction?: Maybe<TokenTransactionBase>;
  /** ユーザーの添付資料を作成する */
  addUserAttachment?: Maybe<UserAttachmentBase>;
  /** 一般ユーザーの招待リンク発行 */
  addUserInvitation?: Maybe<InvitationLinkBase>;
  /** ユーザーのリファレンスを追加する */
  addUserReference?: Maybe<UserReferenceBase>;
  /** VC の投資先の招待リンク発行 */
  addVcInvestmentInvitation?: Maybe<InvitationLinkBase>;
  /** VCの招待リンク発行 */
  addVcInvitation?: Maybe<InvitationLinkBase>;
  /** 応募を申請する */
  applyForJob?: Maybe<JobApplicationBase>;
  /** is_sold カラムを true に変更 */
  changeSoldOut?: Maybe<ListingBase>;
  /** 記事の添付画像を作成する */
  createArticleAttachment?: Maybe<ArticleAttachmentBase>;
  /** 会社を作成する */
  createCompany?: Maybe<CompanyBase>;
  /** 会社の記事を作成する */
  createCompanyArticle?: Maybe<ArticleBase>;
  /** 募集を作成する */
  createJob?: Maybe<JobBase>;
  /** 募集の添付画像を作成する */
  createJobAttachment?: Maybe<JobAttachmentBase>;
  /** スレッドを作成する */
  createMessageThread?: Maybe<MessageThreadBase>;
  /** ユーザーの回答を作成する */
  createMyAnswer?: Maybe<AnswerBase>;
  /** ユーザーの記事を作成する */
  createMyArticle?: Maybe<ArticleBase>;
  /** 自分の会社を作成する */
  createMyCompany?: Maybe<MyCompanyBase>;
  /** ユーザーのオファーを作成する */
  createMyOffer?: Maybe<OfferBase>;
  /** ユーザーの質問を作成する */
  createMyQuestion?: Maybe<QuestionBase>;
  /** ユーザーのリプライを作成する */
  createMyReply?: Maybe<AnswerBase>;
  /** スキルを作成する */
  createSkill?: Maybe<SkillBase>;
  /** 記事を削除する */
  deleteArticle?: Maybe<ArticleBase>;
  /** 会社記事を削除する */
  deleteCompanyArticle?: Maybe<ArticleBase>;
  /** 募集を削除する */
  deleteJob?: Maybe<JobBase>;
  /** ユーザーの回答を削除する */
  deleteMyAnswer?: Maybe<AnswerBase>;
  /** ユーザーの記事を削除する */
  deleteMyArticle?: Maybe<ArticleBase>;
  /** ユーザーのオファーを削除する */
  deleteMyOffer?: Maybe<OfferBase>;
  /** ユーザーの質問を削除する */
  deleteMyQuestion?: Maybe<QuestionBase>;
  /** ユーザーの添付資料を削除する */
  deleteUserAttachment?: Maybe<UserAttachmentBase>;
  /** 募集のコピーを作成する */
  duplicateJob?: Maybe<JobBase>;
  /** 現在のログインユーザーを退会済みにする */
  leaveService?: Maybe<MeBase>;
  /** スレッドの未読メッセージを既読にする */
  markAllMessagesAsRead?: Maybe<MarkAllMessagesAsReadPayload>;
  /** 通知を既読にする */
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadPayload>;
  /** 会社員を削除する */
  removeCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** 会社のリファレンスを削除する */
  removeCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を削除する */
  removeExperience?: Maybe<ExperienceBase>;
  /** インベストメントを削除する */
  removeInvestment?: Maybe<InvestmentBase>;
  /** 投資先会社（自社）によるインベストメントを削除する */
  removeInvestor?: Maybe<InvestmentBase>;
  /** 求人ブックマークを削除する */
  removeMyJobBookmark?: Maybe<JobBookmarkBase>;
  /** プロダクトを削除する */
  removeProduct?: Maybe<ProductBase>;
  /** ユーザーのリファレンスを削除する */
  removeUserReference?: Maybe<UserReferenceBase>;
  /** いいねの着脱 */
  toggleArticleLikedState?: Maybe<ArticleBase>;
  /** 会社のフォロー・フォロー解除 */
  toggleFollowCompany?: Maybe<CompanyBase>;
  /** ユーザーのフォロー・フォロー解除 */
  toggleFollowUser?: Maybe<UserBase>;
  /** 会社を更新する */
  updateCompany?: Maybe<MyCompanyBase>;
  /** 会社の記事を更新する */
  updateCompanyArticle?: Maybe<ArticleBase>;
  /** 会社員の role を更新する */
  updateCompanyMember?: Maybe<MyCompanyMemberBase>;
  /** フォローしている会社の通知受け取り設定 */
  updateCompanyNotificationSettings?: Maybe<CompanyBase>;
  /** 会社のリファレンスを更新する */
  updateCompanyReference?: Maybe<CompanyReferenceBase>;
  /** 職歴を更新する */
  updateExperience?: Maybe<ExperienceBase>;
  /** インベストメントを更新する */
  updateInvestment?: Maybe<InvestmentBase>;
  /** 投資先会社（自社）によるインベストメントを更新する */
  updateInvestor?: Maybe<InvestmentBase>;
  /** 募集を更新する */
  updateJob?: Maybe<JobBase>;
  /** 現在のログインユーザーの情報を更新する */
  updateMe?: Maybe<MeBase>;
  /** ユーザーの回答を更新する */
  updateMyAnswer?: Maybe<AnswerBase>;
  /** ユーザーの記事を更新する */
  updateMyArticle?: Maybe<ArticleBase>;
  /** 自分の会社についたリファレンスのステータスを更新する */
  updateMyCompanyReference?: Maybe<CompanyReferenceBase>;
  /** ユーザーのオファーを更新する */
  updateMyOffer?: Maybe<OfferBase>;
  /** 現在のログインユーザーのプロフィール情報を更新する */
  updateMyProfile?: Maybe<UserProfileBase>;
  /** ユーザーの質問を更新する */
  updateMyQuestion?: Maybe<QuestionBase>;
  /** 自分についたリファレンスのステータスを更新する */
  updateMyReference?: Maybe<UserReferenceBase>;
  /** プロダクトを更新する */
  updateProduct?: Maybe<ProductBase>;
  /** 資金調達クラウドのピッチ添付資料を更新する */
  updateUserAttachment?: Maybe<UserAttachmentBase>;
  /** フォローしているユーザーの通知受け取り設定 */
  updateUserNotificationSettings?: Maybe<UserBase>;
  /** ユーザーのリファレンスを更新する */
  updateUserReference?: Maybe<UserReferenceBase>;
  /** ユーザーのアンケートに投票する */
  voteForChoice?: Maybe<ChoiceBase>;
};


export type MutationAddAngelInvestmentInvitationArgs = {
  input: AddAngelInvestmentInvitationInputBase;
};


export type MutationAddAngelInvitationArgs = {
  input: AddAngelInvitationInputBase;
};


export type MutationAddCompanyInvestmentArgs = {
  input: AddCompanyInvestmentInputBase;
};


export type MutationAddCompanyMemberArgs = {
  input: AddCompanyMemberInputBase;
};


export type MutationAddCompanyReferenceArgs = {
  input: AddCompanyReferenceInputBase;
};


export type MutationAddExperienceArgs = {
  input: AddExperienceInputBase;
};


export type MutationAddFootprintToJobArgs = {
  input: AddFootprintToJobInputBase;
};


export type MutationAddInvestorArgs = {
  input: AddInvestorInputBase;
};


export type MutationAddMemberInvitationArgs = {
  input: AddMemberInvitationInputBase;
};


export type MutationAddMyInvestmentArgs = {
  input: AddMyInvestmentInputBase;
};


export type MutationAddMyJobBookmarkArgs = {
  input: AddMyJobBookmarkInputBase;
};


export type MutationAddProductArgs = {
  input: AddProductInputBase;
};


export type MutationAddTokenArgs = {
  input: AddTokenInputBase;
};


export type MutationAddTokenTransactionArgs = {
  input: AddTokenTransactionInputBase;
};


export type MutationAddUserAttachmentArgs = {
  input: AddUserAttachmentInputBase;
};


export type MutationAddUserInvitationArgs = {
  input: AddUserInvitationInputBase;
};


export type MutationAddUserReferenceArgs = {
  input: AddUserReferenceInputBase;
};


export type MutationAddVcInvestmentInvitationArgs = {
  input: AddVcInvestmentInvitationInputBase;
};


export type MutationAddVcInvitationArgs = {
  input: AddVcInvitationInputBase;
};


export type MutationApplyForJobArgs = {
  input: ApplyForJobInputBase;
};


export type MutationChangeSoldOutArgs = {
  input: ChangeSoldOutInputBase;
};


export type MutationCreateArticleAttachmentArgs = {
  input: CreateArticleAttachmentInputBase;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInputBase;
};


export type MutationCreateCompanyArticleArgs = {
  input: CreateCompanyArticleInputBase;
};


export type MutationCreateJobArgs = {
  input: CreateJobInputBase;
};


export type MutationCreateJobAttachmentArgs = {
  input: CreateJobAttachmentInputBase;
};


export type MutationCreateMessageThreadArgs = {
  input: CreateMessageThreadInputBase;
};


export type MutationCreateMyAnswerArgs = {
  input: CreateMyAnswerInputBase;
};


export type MutationCreateMyArticleArgs = {
  input: CreateMyArticleInputBase;
};


export type MutationCreateMyCompanyArgs = {
  input: CreateMyCompanyInputBase;
};


export type MutationCreateMyOfferArgs = {
  input: CreateMyOfferInputBase;
};


export type MutationCreateMyQuestionArgs = {
  input: CreateMyQuestionInputBase;
};


export type MutationCreateMyReplyArgs = {
  input: CreateMyReplyInputBase;
};


export type MutationCreateSkillArgs = {
  input: CreateSkillInputBase;
};


export type MutationDeleteArticleArgs = {
  input: DeleteArticleInputBase;
};


export type MutationDeleteCompanyArticleArgs = {
  input: DeleteCompanyArticleInputBase;
};


export type MutationDeleteJobArgs = {
  input: DeleteJobInputBase;
};


export type MutationDeleteMyAnswerArgs = {
  input: DeleteMyAnswerInputBase;
};


export type MutationDeleteMyArticleArgs = {
  input: DeleteMyArticleInputBase;
};


export type MutationDeleteMyOfferArgs = {
  input: DeleteMyOfferInputBase;
};


export type MutationDeleteMyQuestionArgs = {
  input: DeleteMyQuestionInputBase;
};


export type MutationDeleteUserAttachmentArgs = {
  input: DeleteUserAttachmentInputBase;
};


export type MutationDuplicateJobArgs = {
  input: DuplicateJobInputBase;
};


export type MutationLeaveServiceArgs = {
  input: LeaveServiceInputBase;
};


export type MutationMarkAllMessagesAsReadArgs = {
  input: MarkAllMessagesAsReadInputBase;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInputBase;
};


export type MutationRemoveCompanyMemberArgs = {
  input: RemoveCompanyMemberInputBase;
};


export type MutationRemoveCompanyReferenceArgs = {
  input: RemoveCompanyReferenceInputBase;
};


export type MutationRemoveExperienceArgs = {
  input: RemoveExperienceInputBase;
};


export type MutationRemoveInvestmentArgs = {
  input: RemoveInvestmentInputBase;
};


export type MutationRemoveInvestorArgs = {
  input: RemoveInvestorInputBase;
};


export type MutationRemoveMyJobBookmarkArgs = {
  input: RemoveMyJobBookmarkInputBase;
};


export type MutationRemoveProductArgs = {
  input: RemoveProductInputBase;
};


export type MutationRemoveUserReferenceArgs = {
  input: RemoveUserReferenceInputBase;
};


export type MutationToggleArticleLikedStateArgs = {
  input: ToggleArticleLikedStateInputBase;
};


export type MutationToggleFollowCompanyArgs = {
  input: ToggleFollowCompanyInputBase;
};


export type MutationToggleFollowUserArgs = {
  input: ToggleFollowUserInputBase;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInputBase;
};


export type MutationUpdateCompanyArticleArgs = {
  input: UpdateCompanyArticleInputBase;
};


export type MutationUpdateCompanyMemberArgs = {
  input: UpdateCompanyMemberInputBase;
};


export type MutationUpdateCompanyNotificationSettingsArgs = {
  input: UpdateCompanyNotificationSettingsInputBase;
};


export type MutationUpdateCompanyReferenceArgs = {
  input: UpdateCompanyReferenceInputBase;
};


export type MutationUpdateExperienceArgs = {
  input: UpdateExperienceInputBase;
};


export type MutationUpdateInvestmentArgs = {
  input: UpdateInvestmentInputBase;
};


export type MutationUpdateInvestorArgs = {
  input: UpdateInvestorInputBase;
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInputBase;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInputBase;
};


export type MutationUpdateMyAnswerArgs = {
  input: UpdateMyAnswerInputBase;
};


export type MutationUpdateMyArticleArgs = {
  input: UpdateMyArticleInputBase;
};


export type MutationUpdateMyCompanyReferenceArgs = {
  input: UpdateMyCompanyReferenceInputBase;
};


export type MutationUpdateMyOfferArgs = {
  input: UpdateMyOfferInputBase;
};


export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInputBase;
};


export type MutationUpdateMyQuestionArgs = {
  input: UpdateMyQuestionInputBase;
};


export type MutationUpdateMyReferenceArgs = {
  input: UpdateMyReferenceInputBase;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInputBase;
};


export type MutationUpdateUserAttachmentArgs = {
  input: UpdateUserAttachmentInputBase;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UpdateUserNotificationSettingsInputBase;
};


export type MutationUpdateUserReferenceArgs = {
  input: UpdateUserReferenceInputBase;
};


export type MutationVoteForChoiceArgs = {
  input: VoteForChoiceInputBase;
};

export type MyCompanyBase = {
  __typename?: 'MyCompany';
  aboutUs?: Maybe<Scalars['String']>;
  articles?: Maybe<ArticleConnection>;
  companyMembers?: Maybe<Array<MyCompanyMemberBase>>;
  companySize?: Maybe<CompanySize>;
  conceptPitch?: Maybe<Scalars['String']>;
  currencyUnit?: Maybe<CurrencyUnit>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  discordUrl?: Maybe<Scalars['String']>;
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  facebookUrl?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  highlightedJobListings?: Maybe<JobConnection>;
  id?: Maybe<Scalars['ID']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  investments?: Maybe<Array<InvestmentBase>>;
  isVc?: Maybe<Scalars['Boolean']>;
  jobApplicationsCount?: Maybe<Scalars['Int']>;
  jobBookmarksCount?: Maybe<Scalars['Int']>;
  jobFootprintsCount?: Maybe<Scalars['Int']>;
  jobs?: Maybe<JobConnection>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  logo?: Maybe<Scalars['String']>;
  markets?: Maybe<Array<MarketBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  openseaUrl?: Maybe<Scalars['String']>;
  products?: Maybe<Array<ProductBase>>;
  receivedInvestments?: Maybe<Array<InvestmentBase>>;
  round?: Maybe<RoundBase>;
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  telegramUrl?: Maybe<Scalars['String']>;
  totalFundingAmount?: Maybe<Scalars['BigInt']>;
  twitterUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};


export type MyCompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MyCompanyHighlightedJobListingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MyCompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MyCompanyMemberBase = {
  __typename?: 'MyCompanyMember';
  company?: Maybe<MyCompanyBase>;
  id?: Maybe<Scalars['ID']>;
  invitedByUser?: Maybe<UserBase>;
  role: CompanyMemberRole;
  user?: Maybe<UserBase>;
};

export type NewJobOpeningNotificationBase = {
  __typename?: 'NewJobOpeningNotification';
  company: CompanyBase;
  id: Scalars['ID'];
};

export type NewMessageNotificationBase = {
  __typename?: 'NewMessageNotification';
  id: Scalars['ID'];
  message: MessageBase;
};

export type NewRecruitingMessageNotificationBase = {
  __typename?: 'NewRecruitingMessageNotification';
  company: CompanyBase;
  id: Scalars['ID'];
  message: MessageBase;
};

export type NewUserFollowerNotificationBase = {
  __typename?: 'NewUserFollowerNotification';
  id: Scalars['ID'];
  user: UserBase;
};

export type NftBase = {
  __typename?: 'Nft';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  listing?: Maybe<ListingBase>;
  mintAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nftAttributes?: Maybe<Array<NftAttributeBase>>;
};

export type NftAttributeBase = {
  __typename?: 'NftAttribute';
  id?: Maybe<Scalars['ID']>;
  nftAttributeTrait?: Maybe<NftAttributeTraitBase>;
  value?: Maybe<Scalars['String']>;
};

export type NftAttributeTraitBase = {
  __typename?: 'NftAttributeTrait';
  id?: Maybe<Scalars['ID']>;
  traitType?: Maybe<Scalars['String']>;
};

/** The connection type for Nft. */
export type NftConnection = {
  __typename?: 'NftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NftEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NftBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NftEdge = {
  __typename?: 'NftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NftBase>;
};

export type NftsCountBase = {
  __typename?: 'NftsCount';
  count?: Maybe<Scalars['Int']>;
};

export type NotificationBase = {
  __typename?: 'Notification';
  answerNotification?: Maybe<AnswerNotificationBase>;
  category: NotificationCategory;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  jobSeekingStatusUpdatedNotification?: Maybe<JobSeekingStatusUpdatedNotificationBase>;
  newJobOpeningNotification?: Maybe<NewJobOpeningNotificationBase>;
  newMessageNotification?: Maybe<NewMessageNotificationBase>;
  newRecruitingMessageNotification?: Maybe<NewRecruitingMessageNotificationBase>;
  newUserFollowerNotification?: Maybe<NewUserFollowerNotificationBase>;
  tokenTransactionNotification?: Maybe<TokenTransactionNotificationBase>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum NotificationCategory {
  ANSWER = 'ANSWER',
  JOB_SEEKING_STATUS_UPDATED = 'JOB_SEEKING_STATUS_UPDATED',
  MESSAGE = 'MESSAGE',
  NEWS = 'NEWS',
  NEW_JOB_OPENING = 'NEW_JOB_OPENING',
  RECRUITING = 'RECRUITING',
  TOKEN_TRANSACTION = 'TOKEN_TRANSACTION',
  USER_FOLLOWED = 'USER_FOLLOWED'
}

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NotificationBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationBase>;
};

export type OfferBase = {
  __typename?: 'Offer';
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currencyUnit: CurrencyUnit;
  id: Scalars['ID'];
  jobCategory: JobCategoryBase;
  jobType: OfferJobTypeBase;
  locations?: Maybe<Array<LocationBase>>;
  salary: Scalars['BigInt'];
  slug: Scalars['ID'];
  status: OfferStatusBase;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  user?: Maybe<UserBase>;
  workingForm: OfferWorkingFormBase;
};

/** The connection type for Offer. */
export type OfferConnection = {
  __typename?: 'OfferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfferEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OfferBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: 'OfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OfferBase>;
};

/** オファー作成用の属性 */
export type OfferInputBase = {
  /** オファー内容 */
  body?: InputMaybe<Scalars['String']>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** ジョブカテゴリーのID */
  jobCategoryId?: InputMaybe<Scalars['ID']>;
  /** 雇用形態 */
  jobType?: InputMaybe<OfferJobTypeBase>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 希望給与 */
  salary?: InputMaybe<Scalars['BigInt']>;
  /** オファーのスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** オファーの公開ステータス */
  status?: InputMaybe<OfferStatusBase>;
  /** オファーのサムネイル */
  thumbnail?: InputMaybe<Scalars['String']>;
  /** オファーのタイトル */
  title: Scalars['String'];
  /** 勤務形態 */
  workingForm?: InputMaybe<OfferWorkingFormBase>;
};

export enum OfferJobTypeBase {
  COFOUNDER = 'COFOUNDER',
  CONTRACT = 'CONTRACT',
  FREELANCE = 'FREELANCE',
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME'
}

export enum OfferStatusBase {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum OfferWorkingFormBase {
  HYBRID = 'HYBRID',
  ON_SITE = 'ON_SITE',
  REMOTE = 'REMOTE'
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type ProductBase = {
  __typename?: 'Product';
  blockchains?: Maybe<Array<BlockchainBase>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<TokenBase>>;
  url?: Maybe<Scalars['String']>;
};

/** プロダクト作成・更新用の属性 */
export type ProductInputBase = {
  /** ブロックチェーンのID配列 */
  blockchainIds?: InputMaybe<Array<Scalars['ID']>>;
  /** プロダクトの説明 */
  description?: InputMaybe<Scalars['String']>;
  /** プロダクトの画像のURL */
  image?: InputMaybe<Scalars['String']>;
  /** プロダクトの名前 */
  name?: InputMaybe<Scalars['String']>;
  /** トークンのID配列 */
  tokenIds?: InputMaybe<Array<Scalars['ID']>>;
  /** プロダクトのURL */
  url?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** キーワード検索して該当のエンジェル投資家を返す */
  angels: UserConnection;
  /** 指定された質問の回答を返す */
  answers: AnswerConnection;
  /** 指定された記事を返す */
  article?: Maybe<ArticleBase>;
  /** 記事の一覧を返す */
  articles: ArticleConnection;
  /** キーワードを検索してブロックチェーンを返す */
  blockchains: BlockchainConnection;
  /** キーワード検索して該当の会社を返す */
  companies: CompanyConnection;
  /** キーワード検索して該当の求人を持つ会社を返す */
  companiesWithJobs: CompanyConnection;
  /** スラッグを指定された会社情報を返す */
  company?: Maybe<CompanyBase>;
  /** 会社記事の一覧を返す */
  companyArticles: ArticleConnection;
  /** 指定した会社の募集一覧を返す */
  companyJobs: JobConnection;
  /** 国を返す */
  countries: Array<LocationBase>;
  /** 重み付けの数値が大きい順にエンジェル投資家一覧を返す */
  featuredAngels: Array<UserBase>;
  /** 重み付けの数値が大きい順に求人掲載企業一覧を返す */
  featuredCompaniesWithJobs: Array<CompanyBase>;
  /** 重み付けの数値が大きい順に募集一覧を返す */
  featuredJobs: Array<JobBase>;
  /** 重み付けの数値が大きい順にスタートアップ一覧を返す */
  featuredStartups: Array<CompanyBase>;
  /** 重み付けの数値が大きい順にストーリー一覧を返す */
  featuredStories: Array<ArticleBase>;
  /** 重み付けの数値が大きい順にVC一覧を返す */
  featuredVentureCapitals: Array<CompanyBase>;
  /** フォロワー一覧を返す */
  followers: UserConnection;
  /** フォロー一覧を返す */
  following: FollowableEntityConnection;
  /** 指定された募集を返す */
  job: JobBase;
  /** 該当の会社の応募一覧を返す */
  jobApplications: JobApplicationConnection;
  /** 会社の求人がブックマークされた一覧を返す */
  jobBookmarks: JobBookmarkConnection;
  /** 職種の一覧を返す */
  jobCategories: Array<JobCategoryBase>;
  /** 指定した募集の足跡一覧を返す */
  jobFootprints: JobFootprintConnection;
  /** キーワード検索して該当の求職者を返す */
  jobSeekers: UserConnection;
  /** 特徴の一覧を返す */
  jobTags: Array<JobTagBase>;
  /** 募集の一覧を返す */
  jobs: JobConnection;
  /** キーワード検索して地域を返す */
  locations: LocationConnection;
  /** マーケットの一覧を返す */
  markets: Array<MarketBase>;
  /** ログイン中の現在のユーザーを返す */
  me?: Maybe<MeBase>;
  /** 指定されたスレッドを返す */
  messageThread: MessageThreadBase;
  /** ログインユーザーが所属するスレッド一覧を返す */
  messageThreads: Array<MessageThreadBase>;
  /** ユーザー記事の一覧を返す */
  myArticles: ArticleConnection;
  /** スラッグを指定された自社情報を返す */
  myCompany?: Maybe<MyCompanyBase>;
  /** 設定画面で使用し自身の会社のリファレンスを一覧で返す */
  myCompanyReferences: CompanyReferenceConnection;
  /** 保存した求人一覧を返す */
  myJobBookmarks: JobBookmarkConnection;
  /** 設定画面で使用し募集の一覧を返す */
  myJobs: JobConnection;
  /** 設定画面で使用するオファーの一覧を返す */
  myOffers: OfferConnection;
  /** 設定画面で使用し自身のリファレンスを一覧で返す */
  myReferences: UserReferenceConnection;
  /** 特定の NFT を返す */
  nft: NftBase;
  /** NFT の一覧を返す */
  nfts: NftConnection;
  /** NFT の数を返す */
  nftsCount: NftsCountBase;
  /** 指定されたオファーを返す */
  offer: OfferBase;
  /** オファーの一覧を返す */
  offers: OfferConnection;
  /** 重み付けの数値が大きい順に特集一覧を返す */
  pickedUpFeatures: Array<ArticleBase>;
  /** 指定された質問を返す */
  question: QuestionBase;
  /** 質問カテゴリーの一覧を返す */
  questionCategories: Array<QuestionCategoryBase>;
  /** 質問の一覧を返す */
  questions: QuestionConnection;
  /** 指定されたリプライを返す */
  reply: AnswerBase;
  /** like検索して該当の会社を返す */
  searchCompany: CompanyConnection;
  /** like検索して該当のユーザーを返す */
  searchUser: UserConnection;
  /** キーワードを検索してスキルを返す */
  skills: SkillConnection;
  /** キーワードを検索してトークンを返す */
  tokens: TokenConnection;
  /** ログイン名で指定されたユーザーを返す */
  user?: Maybe<UserBase>;
  /** ユーザー記事の一覧を返す */
  userArticles: ArticleConnection;
  /** 指定したユーザーのオファー一覧を返す */
  userOffers: OfferConnection;
  /** ユーザーの質問一覧を返す */
  userQuestions: QuestionConnection;
  /** 招待リンクの検証 */
  validInvitationToken: InvitationBase;
};


export type QueryAngelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<UserOrderBase>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


export type QueryArticleArgs = {
  slug: Scalars['ID'];
};


export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryBlockchainsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<CompanyOrderBase>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCompaniesWithJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  angelUsername?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  companyLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  jobLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  marketIds?: InputMaybe<Array<Scalars['ID']>>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  tokenGrant?: InputMaybe<Array<Scalars['Boolean']>>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition>>;
  vcSlug?: InputMaybe<Scalars['ID']>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm>>;
};


export type QueryCompanyArgs = {
  slug: Scalars['ID'];
};


export type QueryCompanyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['ID']>;
};


export type QueryCompanyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryFollowersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


export type QueryFollowingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
};


export type QueryJobArgs = {
  slug: Scalars['ID'];
};


export type QueryJobApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobFootprintsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryJobSeekersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobHuntingStatus?: InputMaybe<Array<UserProfileJobHuntingStatus>>;
  last?: InputMaybe<Scalars['Int']>;
  primaryJobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  yearsOfExperience?: InputMaybe<Array<UserProfileYearsOfExperience>>;
};


export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  tokenGrant?: InputMaybe<Array<Scalars['Boolean']>>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition>>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm>>;
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMessageThreadArgs = {
  slug: Scalars['ID'];
};


export type QueryMyArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyCompanyArgs = {
  slug: Scalars['ID'];
};


export type QueryMyCompanyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
};


export type QueryMyJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMyReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryNftArgs = {
  mintAddress: Scalars['String'];
};


export type QueryNftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOfferArgs = {
  slug: Scalars['ID'];
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  first?: InputMaybe<Scalars['Int']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  jobType?: InputMaybe<Array<OfferJobTypeBase>>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['BigInt']>;
  workingForm?: InputMaybe<Array<OfferWorkingFormBase>>;
};


export type QueryQuestionArgs = {
  slug: Scalars['ID'];
};


export type QueryQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<QuestionOrderBase>;
  query?: InputMaybe<Scalars['String']>;
  questionCategories?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryReplyArgs = {
  id: Scalars['ID'];
};


export type QuerySearchCompanyArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUserArgs = {
  username: Scalars['ID'];
};


export type QueryUserArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
};


export type QueryUserOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
};


export type QueryUserQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
};


export type QueryValidInvitationTokenArgs = {
  token: Scalars['String'];
};

export type QuestionBase = {
  __typename?: 'Question';
  amount?: Maybe<Scalars['String']>;
  answers?: Maybe<AnswerConnection>;
  answersCount?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  choices?: Maybe<Array<ChoiceBase>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  isVotable?: Maybe<Scalars['Boolean']>;
  isVotedInBy?: Maybe<Scalars['Boolean']>;
  mostVotedChoices?: Maybe<Array<ChoiceBase>>;
  ogImage?: Maybe<Scalars['String']>;
  pollDeadline?: Maybe<Scalars['ISO8601DateTime']>;
  questionCategory?: Maybe<QuestionCategoryBase>;
  questionType?: Maybe<QuestionTypeBase>;
  questioner?: Maybe<UserBase>;
  slug?: Maybe<Scalars['ID']>;
  status?: Maybe<QuestionStatusBase>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  votesCount?: Maybe<Scalars['Int']>;
};


export type QuestionAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QuestionCategoryBase = {
  __typename?: 'QuestionCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for Question. */
export type QuestionConnection = {
  __typename?: 'QuestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QuestionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<QuestionBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type QuestionEdge = {
  __typename?: 'QuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<QuestionBase>;
};

/** 質問作成用の属性 */
export type QuestionInputBase = {
  /** 質問内容 */
  body?: InputMaybe<Scalars['String']>;
  /** 質問の OG イメージ */
  ogImage?: InputMaybe<Scalars['String']>;
  /** 投票締切時間 */
  pollDeadline?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** 質問カテゴリーのID */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
  /** 質問タイプ */
  questionType?: InputMaybe<QuestionTypeBase>;
  /** 質問のスラッグ */
  slug?: InputMaybe<Scalars['ID']>;
  /** 質問ステータス */
  status?: InputMaybe<QuestionStatusBase>;
  /** 質問のタイトル */
  title: Scalars['String'];
};

/** 質問の並び順 */
export type QuestionOrderBase = {
  /** 昇順・降順 */
  direction: OrderDirection;
  /** ソートする質問のフィールド */
  questionOrderField: QuestionOrderFieldBase;
};

export enum QuestionOrderFieldBase {
  ANSWERS_COUNT = 'ANSWERS_COUNT',
  CREATED_AT = 'CREATED_AT'
}

export enum QuestionStatusBase {
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export enum QuestionTypeBase {
  POLL = 'POLL',
  QUESTION = 'QUESTION'
}

/** Autogenerated input type of RemoveCompanyMember */
export type RemoveCompanyMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveCompanyReference */
export type RemoveCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveExperience */
export type RemoveExperienceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveInvestment */
export type RemoveInvestmentInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveInvestor */
export type RemoveInvestorInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveMyJobBookmark */
export type RemoveMyJobBookmarkInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['ID'];
};

/** Autogenerated input type of RemoveProduct */
export type RemoveProductInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of RemoveUserReference */
export type RemoveUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RoundBase = {
  __typename?: 'Round';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type SkillBase = {
  __typename?: 'Skill';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['ID'];
};

/** The connection type for Skill. */
export type SkillConnection = {
  __typename?: 'SkillConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SkillEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SkillBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SkillEdge = {
  __typename?: 'SkillEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SkillBase>;
};

/** スキル作成用の属性 */
export type SkillInputBase = {
  /** スキル名 */
  name: Scalars['String'];
};

/** Autogenerated input type of ToggleArticleLikedState */
export type ToggleArticleLikedStateInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of ToggleFollowCompany */
export type ToggleFollowCompanyInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of ToggleFollowUser */
export type ToggleFollowUserInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  username: Scalars['ID'];
};

export type TokenBase = {
  __typename?: 'Token';
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

/** The connection type for Token. */
export type TokenConnection = {
  __typename?: 'TokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TokenEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TokenBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TokenEdge = {
  __typename?: 'TokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TokenBase>;
};

/** トークン作成・更新用の属性 */
export type TokenInputBase = {
  /** トークンのロゴのURL */
  logo?: InputMaybe<Scalars['String']>;
  /** トークンの名前 */
  name: Scalars['String'];
};

export type TokenTransactionBase = {
  __typename?: 'TokenTransaction';
  amount: Scalars['String'];
  category?: Maybe<TokenTransactionCategoryBase>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  reciever?: Maybe<UserBase>;
  sender?: Maybe<UserBase>;
  signature?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum TokenTransactionCategoryBase {
  ARTICLE = 'ARTICLE',
  FORUM = 'FORUM',
  PROFILE = 'PROFILE',
  QUESTION = 'QUESTION'
}

/** トークントランザクションの属性 */
export type TokenTransactionInputBase = {
  /** 送信量 */
  amount: Scalars['String'];
  /** トランザクションのカテゴリ */
  category: TokenTransactionCategoryBase;
  /** 受信ユーザーのID */
  recieverId: Scalars['ID'];
  /** トランザクションID */
  signature: Scalars['String'];
};

export type TokenTransactionNotificationBase = {
  __typename?: 'TokenTransactionNotification';
  id: Scalars['ID'];
  tokenTransaction: TokenTransactionBase;
};

export type TopicBase = {
  __typename?: 'Topic';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCompanyArticle */
export type UpdateCompanyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInputBase = {
  attributes: CompanyInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateCompanyMember */
export type UpdateCompanyMemberInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  role: CompanyMemberRole;
};

/** Autogenerated input type of UpdateCompanyNotificationSettings */
export type UpdateCompanyNotificationSettingsInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  notificationIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of UpdateCompanyReference */
export type UpdateCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateExperience */
export type UpdateExperienceInputBase = {
  attributes: ExperienceInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateInvestment */
export type UpdateInvestmentInputBase = {
  attributes: InvestmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateInvestor */
export type UpdateInvestorInputBase = {
  attributes: InvestorInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateJob */
export type UpdateJobInputBase = {
  attributes: JobInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMe */
export type UpdateMeInputBase = {
  attributes: UserInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMyAnswer */
export type UpdateMyAnswerInputBase = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMyArticle */
export type UpdateMyArticleInputBase = {
  attributes: ArticleInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMyCompanyReference */
export type UpdateMyCompanyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: CompanyReferenceStatus;
};

/** Autogenerated input type of UpdateMyOffer */
export type UpdateMyOfferInputBase = {
  attributes: OfferInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMyProfile */
export type UpdateMyProfileInputBase = {
  attributes: UserProfileInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMyQuestion */
export type UpdateMyQuestionInputBase = {
  attributes: QuestionInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateMyReference */
export type UpdateMyReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status: UserReferenceStatus;
};

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInputBase = {
  attributes: ProductInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserAttachment */
export type UpdateUserAttachmentInputBase = {
  attributes: UserAttachmentInputBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserNotificationSettings */
export type UpdateUserNotificationSettingsInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationIds: Array<Scalars['ID']>;
  username: Scalars['ID'];
};

/** Autogenerated input type of UpdateUserReference */
export type UpdateUserReferenceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  id: Scalars['ID'];
};

export type UserBase = {
  __typename?: 'User';
  experiences?: Maybe<Array<ExperienceBase>>;
  followersCount?: Maybe<Scalars['Int']>;
  followingCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  investments?: Maybe<Array<InvestmentBase>>;
  isFollower?: Maybe<Scalars['Boolean']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notificationSettings?: Maybe<Array<UserNotificationBase>>;
  profile?: Maybe<UserProfileBase>;
  questions?: Maybe<QuestionConnection>;
  status?: Maybe<UserStatus>;
  userAttachments?: Maybe<Array<UserAttachmentBase>>;
  userReferences?: Maybe<UserReferenceConnection>;
  username: Scalars['String'];
};


export type UserQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserUserReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserAttachmentBase = {
  __typename?: 'UserAttachment';
  categoryName: UserAttachmentCategoryNameBase;
  description?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum UserAttachmentCategoryNameBase {
  OTHERS = 'OTHERS',
  PORTFOLIO = 'PORTFOLIO',
  RESUME = 'RESUME'
}

/** ユーザーの添付資料作成・更新用の属性 */
export type UserAttachmentInputBase = {
  /** カテゴリー名 */
  categoryName: UserAttachmentCategoryNameBase;
  /** 資料の説明 */
  description?: InputMaybe<Scalars['String']>;
  /** 添付ファイルのURL */
  file?: InputMaybe<Scalars['String']>;
  /** 添付ファイル名 */
  filename?: InputMaybe<Scalars['String']>;
  /** プロダクトの名前 */
  name?: InputMaybe<Scalars['String']>;
  /** 資料のURL */
  url?: InputMaybe<Scalars['String']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserBase>;
};

/** ユーザー更新用の属性 */
export type UserInputBase = {
  /** メールアドレス */
  email: Scalars['String'];
  /** 本名 */
  name: Scalars['String'];
  /** サービス上でのユーザー名 */
  username: Scalars['String'];
};

export type UserNotificationBase = {
  __typename?: 'UserNotification';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** ユーザーの並び順 */
export type UserOrderBase = {
  /** 昇順・降順 */
  direction: OrderDirection;
  /** ソートするユーザーのフィールド */
  userOrderField: UserOrderField;
};

export enum UserOrderField {
  ANGEL_SCORE = 'ANGEL_SCORE',
  CREATED_AT = 'CREATED_AT',
  GENERAL_SCORE = 'GENERAL_SCORE',
  JOB_SEEKER_SCORE = 'JOB_SEEKER_SCORE'
}

export type UserProfileBase = {
  __typename?: 'UserProfile';
  allowMessageRequestsFrom?: Maybe<UserProfileAllowMessageRequestsFrom>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['ISO8601Date']>;
  birthdayAccessScope?: Maybe<UserProfileBirthdayAccessScopeBase>;
  currencyUnit?: Maybe<CurrencyUnit>;
  delayOfEmailNotificationsForAnswers?: Maybe<UserProfileDelayOfEmailNotificationsForAnswersBase>;
  delayOfEmailNotificationsForFollower?: Maybe<UserProfileDelayOfEmailNotificationsForFollower>;
  delayOfEmailNotificationsForMessages?: Maybe<UserProfileDelayOfEmailNotificationsForMessages>;
  delayOfEmailNotificationsForTokenTransactions?: Maybe<UserProfileDelayOfEmailNotificationsForTokenTransactionsBase>;
  denyNewContact?: Maybe<Scalars['Boolean']>;
  desiredCareerPath?: Maybe<UserProfileDesiredCareerPathBase>;
  desiredCommunicationStyle?: Maybe<UserProfileDesiredCommunicationStyleBase>;
  desiredDecisionCulture?: Maybe<UserProfileDesiredDecisionCultureBase>;
  desiredEvaluationCulture?: Maybe<UserProfileDesiredEvaluationCultureBase>;
  desiredManagementCulture?: Maybe<UserProfileDesiredManagementCultureBase>;
  desiredOrientationCulture?: Maybe<UserProfileDesiredOrientationCultureBase>;
  desiredProgressionStyle?: Maybe<UserProfileDesiredProgressionStyleBase>;
  desiredRoleOnTeam?: Maybe<UserProfileDesiredRoleOnTeamBase>;
  desiredTakingOnWorkStyle?: Maybe<UserProfileDesiredTakingOnWorkStyleBase>;
  desiredThingsInNextJob?: Maybe<Scalars['String']>;
  desiredTrainingCulture?: Maybe<UserProfileDesiredTrainingCultureBase>;
  desiredWorkStyle?: Maybe<UserProfileDesiredWorkStyleBase>;
  desiredWorkplaceCulture?: Maybe<UserProfileDesiredWorkplaceCultureBase>;
  discordUrl?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  hasInvestmentsWithJobs?: Maybe<Scalars['Boolean']>;
  headerImage?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  investmentTargetMarkets?: Maybe<Array<MarketBase>>;
  investmentTargetRounds?: Maybe<Array<RoundBase>>;
  isAngel?: Maybe<Scalars['Boolean']>;
  isCofounderDesired?: Maybe<Scalars['Boolean']>;
  isContractorDesired?: Maybe<Scalars['Boolean']>;
  isFulltimeEmployeeDesired?: Maybe<Scalars['Boolean']>;
  isInternDesired?: Maybe<Scalars['Boolean']>;
  isInvestor?: Maybe<Scalars['Boolean']>;
  isJobSeeker: Scalars['Boolean'];
  isJobSeekerMailMagazineAccepted?: Maybe<Scalars['Boolean']>;
  isVerifiedAccount?: Maybe<Scalars['Boolean']>;
  jobCategories?: Maybe<Array<JobCategoryBase>>;
  jobHuntingStatus?: Maybe<UserProfileJobHuntingStatus>;
  jobTitle?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<LocationBase>>;
  maxInvestmentAmount?: Maybe<Scalars['BigInt']>;
  minInvestmentAmount?: Maybe<Scalars['BigInt']>;
  openseaUrl?: Maybe<Scalars['String']>;
  primaryJobCategory?: Maybe<JobCategoryBase>;
  receiveEmailNotificationsForAnswers?: Maybe<Scalars['Boolean']>;
  receiveEmailNotificationsForFollower?: Maybe<Scalars['Boolean']>;
  receiveEmailNotificationsForMessages?: Maybe<Scalars['Boolean']>;
  receiveEmailNotificationsForTokenTransactions?: Maybe<Scalars['Boolean']>;
  skills?: Maybe<Array<SkillBase>>;
  solanaAddress?: Maybe<Scalars['String']>;
  telegramUrl?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<TokenBase>>;
  twitterUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  yearsOfExperience?: Maybe<UserProfileYearsOfExperience>;
};

export enum UserProfileAllowMessageRequestsFrom {
  EVERYONE = 'EVERYONE',
  FOLLOWEE = 'FOLLOWEE'
}

export enum UserProfileBirthdayAccessScopeBase {
  ANYONE = 'ANYONE',
  PRIVATE = 'PRIVATE'
}

export enum UserProfileDelayOfEmailNotificationsForAnswersBase {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDelayOfEmailNotificationsForFollower {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDelayOfEmailNotificationsForMessages {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDelayOfEmailNotificationsForTokenTransactionsBase {
  IN_1_HOUR = 'IN_1_HOUR',
  IN_15_MINUTES = 'IN_15_MINUTES',
  IN_30_MINUTES = 'IN_30_MINUTES',
  SOON = 'SOON'
}

export enum UserProfileDesiredCareerPathBase {
  AS_GENERALIST = 'AS_GENERALIST',
  AS_SPECIALIST = 'AS_SPECIALIST',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredCommunicationStyleBase {
  GOOD_LISTENER = 'GOOD_LISTENER',
  GOOD_TALKER = 'GOOD_TALKER',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredDecisionCultureBase {
  EMOTIONAL = 'EMOTIONAL',
  RATIONAL = 'RATIONAL',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredEvaluationCultureBase {
  PERFORMANCE = 'PERFORMANCE',
  SENIORITY = 'SENIORITY',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredManagementCultureBase {
  EMPOWERMENT = 'EMPOWERMENT',
  MANAGEMENT = 'MANAGEMENT',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredOrientationCultureBase {
  INNOVATIVE = 'INNOVATIVE',
  STABLE = 'STABLE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredProgressionStyleBase {
  ALONE = 'ALONE',
  UNKNOWN = 'UNKNOWN',
  WITH_TEAM = 'WITH_TEAM'
}

export enum UserProfileDesiredRoleOnTeamBase {
  AS_LEADER = 'AS_LEADER',
  AS_SUPPORTER = 'AS_SUPPORTER',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredTakingOnWorkStyleBase {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredTrainingCultureBase {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredWorkStyleBase {
  MACRO_PERSPECTIVE = 'MACRO_PERSPECTIVE',
  MICRO_PERSPECTIVE = 'MICRO_PERSPECTIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileDesiredWorkplaceCultureBase {
  BUSINESS_LIKE = 'BUSINESS_LIKE',
  COZY = 'COZY',
  UNKNOWN = 'UNKNOWN'
}

/** ユーザープロフィール更新用の属性 */
export type UserProfileInputBase = {
  /** DMの公開範囲 */
  allowMessageRequestsFrom?: InputMaybe<UserProfileAllowMessageRequestsFrom>;
  /** アバター画像 */
  avatar?: InputMaybe<Scalars['String']>;
  /** 紹介文 */
  bio?: InputMaybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** 生年月日の公開範囲 */
  birthdayAccessScope?: InputMaybe<UserProfileBirthdayAccessScopeBase>;
  /** 貨幣単位 */
  currencyUnit?: InputMaybe<CurrencyUnit>;
  /** リプライのメール通知タイミング */
  delayOfEmailNotificationsForAnswers?: InputMaybe<UserProfileDelayOfEmailNotificationsForAnswersBase>;
  /** フォロワーのメール通知タイミング */
  delayOfEmailNotificationsForFollower?: InputMaybe<UserProfileDelayOfEmailNotificationsForFollower>;
  /** メッセージのメール通知タイミング */
  delayOfEmailNotificationsForMessages?: InputMaybe<UserProfileDelayOfEmailNotificationsForMessages>;
  /** 投げ銭のメール通知タイミング */
  delayOfEmailNotificationsForTokenTransactions?: InputMaybe<UserProfileDelayOfEmailNotificationsForTokenTransactionsBase>;
  /** メッセージを受け付けるか */
  denyNewContact?: InputMaybe<Scalars['Boolean']>;
  /** 希望するキャリアパス */
  desiredCareerPath?: InputMaybe<UserProfileDesiredCareerPathBase>;
  /** 希望するコミュニケーションスタイル */
  desiredCommunicationStyle?: InputMaybe<UserProfileDesiredCommunicationStyleBase>;
  /** 希望する意思決定風土 */
  desiredDecisionCulture?: InputMaybe<UserProfileDesiredDecisionCultureBase>;
  /** 希望する評価風土 */
  desiredEvaluationCulture?: InputMaybe<UserProfileDesiredEvaluationCultureBase>;
  /** 希望する管理風土 */
  desiredManagementCulture?: InputMaybe<UserProfileDesiredManagementCultureBase>;
  /** 希望する志向風土 */
  desiredOrientationCulture?: InputMaybe<UserProfileDesiredOrientationCultureBase>;
  /** 希望する進行スタイル */
  desiredProgressionStyle?: InputMaybe<UserProfileDesiredProgressionStyleBase>;
  /** 希望するチームにおける役割 */
  desiredRoleOnTeam?: InputMaybe<UserProfileDesiredRoleOnTeamBase>;
  /** 希望する請負スタイル */
  desiredTakingOnWorkStyle?: InputMaybe<UserProfileDesiredTakingOnWorkStyleBase>;
  /** 次の仕事に期待すること */
  desiredThingsInNextJob?: InputMaybe<Scalars['String']>;
  /** 希望する育成風土 */
  desiredTrainingCulture?: InputMaybe<UserProfileDesiredTrainingCultureBase>;
  /** 希望する仕事スタイル */
  desiredWorkStyle?: InputMaybe<UserProfileDesiredWorkStyleBase>;
  /** 希望する職場風土 */
  desiredWorkplaceCulture?: InputMaybe<UserProfileDesiredWorkplaceCultureBase>;
  /** DiscordのURL */
  discordUrl?: InputMaybe<Scalars['String']>;
  /** FacebookのURL */
  facebookUrl?: InputMaybe<Scalars['String']>;
  /** GithubのURL */
  githubUrl?: InputMaybe<Scalars['String']>;
  /** ヘッダー画像 */
  headerImage?: InputMaybe<Scalars['String']>;
  /** InstagramのURL */
  instagramUrl?: InputMaybe<Scalars['String']>;
  /** 投資対象領域のID配列 */
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 投資対象ラウンドのID配列 */
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']>>;
  /** エンジェル投資家か */
  isAngel?: InputMaybe<Scalars['Boolean']>;
  /** 共同創業者希望 */
  isCofounderDesired?: InputMaybe<Scalars['Boolean']>;
  /** 外注・副業希望 */
  isContractorDesired?: InputMaybe<Scalars['Boolean']>;
  /** 正社員希望 */
  isFulltimeEmployeeDesired?: InputMaybe<Scalars['Boolean']>;
  /** インターン希望 */
  isInternDesired?: InputMaybe<Scalars['Boolean']>;
  /** 投資家か */
  isInvestor?: InputMaybe<Scalars['Boolean']>;
  /** 求職者であるか */
  isJobSeeker?: InputMaybe<Scalars['Boolean']>;
  /** 求職者向けメールマガジンの配信を許可するか */
  isJobSeekerMailMagazineAccepted?: InputMaybe<Scalars['Boolean']>;
  /** 職種のID配列 */
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 求職ステータス */
  jobHuntingStatus?: InputMaybe<UserProfileJobHuntingStatus>;
  /** 職業名 */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** LinkedInのURL */
  linkedinUrl?: InputMaybe<Scalars['String']>;
  /** 地域のID配列 */
  locationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** 最大投資金額 */
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** 最小投資金額 */
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  /** OpenSeaのURL */
  openseaUrl?: InputMaybe<Scalars['String']>;
  /** 主な職種 */
  primaryJobCategoryId?: InputMaybe<Scalars['ID']>;
  /** リプライのメール通知設定 */
  receiveEmailNotificationsForAnswers?: InputMaybe<Scalars['Boolean']>;
  /** フォロワーのメール通知設定 */
  receiveEmailNotificationsForFollower?: InputMaybe<Scalars['Boolean']>;
  /** メッセージのメール通知設定 */
  receiveEmailNotificationsForMessages?: InputMaybe<Scalars['Boolean']>;
  /** 投げ銭のメール通知設定 */
  receiveEmailNotificationsForTokenTransactions?: InputMaybe<Scalars['Boolean']>;
  /** スキルのID配列 */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Solana のアドレス */
  solanaAddress?: InputMaybe<Scalars['String']>;
  /** TelegramのURL */
  telegramUrl?: InputMaybe<Scalars['String']>;
  /** トークンのID配列 */
  tokenIds?: InputMaybe<Array<Scalars['ID']>>;
  /** TwitterのURL */
  twitterUrl?: InputMaybe<Scalars['String']>;
  /** WebサイトのURL */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** 経験年数 */
  yearsOfExperience?: InputMaybe<UserProfileYearsOfExperience>;
};

export enum UserProfileJobHuntingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INACTIVE_BUT_OPEN_TO_OFFERS = 'INACTIVE_BUT_OPEN_TO_OFFERS',
  UNKNOWN = 'UNKNOWN'
}

export enum UserProfileYearsOfExperience {
  EIGHT_YEARS_OR_MORE = 'EIGHT_YEARS_OR_MORE',
  FIVE_YEARS_OR_MORE = 'FIVE_YEARS_OR_MORE',
  FOUR_YEARS_OR_MORE = 'FOUR_YEARS_OR_MORE',
  LESS_THAN_1_YEAR = 'LESS_THAN_1_YEAR',
  NINE_YEARS_OR_MORE = 'NINE_YEARS_OR_MORE',
  ONE_YEAR_OR_MORE = 'ONE_YEAR_OR_MORE',
  SEVEN_YEARS_OR_MORE = 'SEVEN_YEARS_OR_MORE',
  SIX_YEARS_OR_MORE = 'SIX_YEARS_OR_MORE',
  TEN_YEARS_OR_MORE = 'TEN_YEARS_OR_MORE',
  THREE_YEARS_OR_MORE = 'THREE_YEARS_OR_MORE',
  TWO_YEARS_OR_MORE = 'TWO_YEARS_OR_MORE'
}

export type UserReferenceBase = {
  __typename?: 'UserReference';
  comment: Scalars['String'];
  commenter?: Maybe<UserBase>;
  id: Scalars['ID'];
  status: UserReferenceStatus;
};

/** The connection type for UserReference. */
export type UserReferenceConnection = {
  __typename?: 'UserReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserReferenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserReferenceBase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserReferenceEdge = {
  __typename?: 'UserReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserReferenceBase>;
};

export enum UserReferenceStatus {
  HIDDEN = 'HIDDEN',
  SHOWN = 'SHOWN'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  FREEZE = 'FREEZE',
  INACTIVE = 'INACTIVE',
  LEAVE = 'LEAVE'
}

/** Autogenerated input type of VoteForChoice */
export type VoteForChoiceInputBase = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AnswerFieldsFragmentBase = { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type ReplyFieldsFragmentBase = { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type ParentReplyFieldsFragmentBase = { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type AnswerWithoutChildRepliesFieldsFragmentBase = { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type MinAnswerFieldsFragmentBase = { __typename?: 'Answer', id?: string | null | undefined, slug?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type BlockchainFieldsFragmentBase = { __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined };

export type ChoiceFieldsFragmentBase = { __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CompanyWithJobsFragmentBase = { __typename?: 'Company', jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type HighlightedJobListingsFragmentBase = { __typename?: 'Company', highlightedJobListings?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined };

export type MinCompanyFieldFragmentBase = { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined };

export type CompanyReferenceFieldsFragmentBase = { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type RecievedInvestmentFieldsFragmentBase = { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined };

export type MinJobApplicationFieldsFragmentBase = { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } };

export type JobCategoryFieldsFragmentBase = { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string };

export type JobTagFieldsFragmentBase = { __typename?: 'JobTag', id: string, name: string, slug: string };

export type JobFieldsFragmentBase = { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> };

export type LocationFieldsFragmentBase = { __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string };

export type MarketFieldsFragmentBase = { __typename?: 'Market', id: string, name: string, slug?: string | null | undefined };

export type MessageAttachmentFieldsFragmentBase = { __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string };

export type MinMessageThreadFieldsFragmentBase = { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined };

export type MessageFieldsFragmentBase = { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined };

export type NotificationFieldsFragmentBase = { __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, answerNotification?: { __typename?: 'AnswerNotification', id: string, answer: { __typename?: 'Answer', id?: string | null | undefined, slug?: string | null | undefined, body?: string | null | undefined, status?: AnswerStatusBase | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, rootQuestion?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined } | null | undefined } } | null | undefined, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, tokenTransactionNotification?: { __typename?: 'TokenTransactionNotification', id: string, tokenTransaction: { __typename?: 'TokenTransaction', amount: string, sender?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } } | null | undefined };

export type OfferFieldsFragmentBase = { __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined };

export type ProductFieldsFragmentBase = { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined };

export type QuestionCategoryFieldsFragmentBase = { __typename?: 'QuestionCategory', id: string, name: string, slug: string };

export type MinQuestionWithoutAnswersFieldsFragmentBase = { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type QuestionFieldsFragmentBase = { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, isVotable?: boolean | null | undefined, isVotedInBy?: boolean | null | undefined, ogImage?: string | null | undefined, pollDeadline?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, votesCount?: number | null | undefined, answers?: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, choices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, mostVotedChoices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined };

export type RoundFieldsFragmentBase = { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined };

export type SkillFieldsFragmentBase = { __typename?: 'Skill', id: string, name: string, slug: string };

export type TokenFieldsFragmentBase = { __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined };

export type UserAttachmentFieldsFragmentBase = { __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined };

export type UserReferenceFieldsFragmentBase = { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined };

export type MinUserFieldsFragmentBase = { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined };

export type MinUserWithSolanaAddressFieldsFragmentBase = { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined };

export type AddAngelInvestmentInvitationMutationVariables = Exact<{
  input: AddAngelInvestmentInvitationInputBase;
}>;


export type AddAngelInvestmentInvitationMutation = { __typename?: 'Mutation', addAngelInvestmentInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddAngelInvitationMutationVariables = Exact<{
  input: AddAngelInvitationInputBase;
}>;


export type AddAngelInvitationMutation = { __typename?: 'Mutation', addAngelInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddCompanyInvestmentMutationVariables = Exact<{
  input: AddCompanyInvestmentInputBase;
}>;


export type AddCompanyInvestmentMutation = { __typename?: 'Mutation', addCompanyInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type AddCompanyMemberMutationVariables = Exact<{
  input: AddCompanyMemberInputBase;
}>;


export type AddCompanyMemberMutation = { __typename?: 'Mutation', addCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type AddCompanyReferenceMutationVariables = Exact<{
  input: AddCompanyReferenceInputBase;
}>;


export type AddCompanyReferenceMutation = { __typename?: 'Mutation', addCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddExperienceMutationVariables = Exact<{
  input: AddExperienceInputBase;
}>;


export type AddExperienceMutation = { __typename?: 'Mutation', addExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } } | null | undefined };

export type AddFootprintToJobMutationVariables = Exact<{
  input: AddFootprintToJobInputBase;
}>;


export type AddFootprintToJobMutation = { __typename?: 'Mutation', addFootprintToJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type AddInvestorMutationVariables = Exact<{
  input: AddInvestorInputBase;
}>;


export type AddInvestorMutation = { __typename?: 'Mutation', addInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', jobTitle?: string | null | undefined, bio?: string | null | undefined, avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined } | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', name?: string | null | undefined, logo?: string | null | undefined, slug: string, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type AddMemberInvitationMutationVariables = Exact<{
  input: AddMemberInvitationInputBase;
}>;


export type AddMemberInvitationMutation = { __typename?: 'Mutation', addMemberInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddMyInvestmentMutationVariables = Exact<{
  input: AddMyInvestmentInputBase;
}>;


export type AddMyInvestmentMutation = { __typename?: 'Mutation', addMyInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type AddMyJobBookmarkMutationVariables = Exact<{
  input: AddMyJobBookmarkInputBase;
}>;


export type AddMyJobBookmarkMutation = { __typename?: 'Mutation', addMyJobBookmark?: { __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddProductMutationVariables = Exact<{
  input: AddProductInputBase;
}>;


export type AddProductMutation = { __typename?: 'Mutation', addProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type AddTokenMutationVariables = Exact<{
  input: AddTokenInputBase;
}>;


export type AddTokenMutation = { __typename?: 'Mutation', addToken?: { __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined } | null | undefined };

export type AddTokenTransactionMutationVariables = Exact<{
  input: AddTokenTransactionInputBase;
}>;


export type AddTokenTransactionMutation = { __typename?: 'Mutation', addTokenTransaction?: { __typename?: 'TokenTransaction', amount: string, signature?: string | null | undefined, reciever?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string } | null | undefined, sender?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string } | null | undefined } | null | undefined };

export type AddUserAttachmentMutationVariables = Exact<{
  input: AddUserAttachmentInputBase;
}>;


export type AddUserAttachmentMutation = { __typename?: 'Mutation', addUserAttachment?: { __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type AddUserInvitationMutationVariables = Exact<{
  input: AddUserInvitationInputBase;
}>;


export type AddUserInvitationMutation = { __typename?: 'Mutation', addUserInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddUserReferenceMutationVariables = Exact<{
  input: AddUserReferenceInputBase;
}>;


export type AddUserReferenceMutation = { __typename?: 'Mutation', addUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type AddVcInvestmentInvitationMutationVariables = Exact<{
  input: AddVcInvestmentInvitationInputBase;
}>;


export type AddVcInvestmentInvitationMutation = { __typename?: 'Mutation', addVcInvestmentInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type AddVcInvitationMutationVariables = Exact<{
  input: AddVcInvitationInputBase;
}>;


export type AddVcInvitationMutation = { __typename?: 'Mutation', addVcInvitation?: { __typename?: 'InvitationLink', url: string } | null | undefined };

export type ApplyForJobMutationVariables = Exact<{
  input: ApplyForJobInputBase;
}>;


export type ApplyForJobMutation = { __typename?: 'Mutation', applyForJob?: { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } } | null | undefined };

export type ChangeSoldOutMutationVariables = Exact<{
  input: ChangeSoldOutInputBase;
}>;


export type ChangeSoldOutMutation = { __typename?: 'Mutation', changeSoldOut?: { __typename?: 'Listing', id?: string | null | undefined, isSold?: boolean | null | undefined, listingAddress?: string | null | undefined, listingAmount?: string | null | undefined, listingAddressSol?: string | null | undefined, listingAmountSol?: string | null | undefined } | null | undefined };

export type CreateArticleAttachmentMutationVariables = Exact<{
  input: CreateArticleAttachmentInputBase;
}>;


export type CreateArticleAttachmentMutation = { __typename?: 'Mutation', createArticleAttachment?: { __typename?: 'ArticleAttachment', id: string, image: string } | null | undefined };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInputBase;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type CreateCompanyArticleMutationVariables = Exact<{
  input: CreateCompanyArticleInputBase;
}>;


export type CreateCompanyArticleMutation = { __typename?: 'Mutation', createCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type CreateJobMutationVariables = Exact<{
  input: CreateJobInputBase;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type CreateJobAttachmentMutationVariables = Exact<{
  input: CreateJobAttachmentInputBase;
}>;


export type CreateJobAttachmentMutation = { __typename?: 'Mutation', createJobAttachment?: { __typename?: 'JobAttachment', id: string, image: string } | null | undefined };

export type CreateMessageThreadMutationVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  input: CreateMessageThreadInputBase;
}>;


export type CreateMessageThreadMutation = { __typename?: 'Mutation', createMessageThread?: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }> | null | undefined } | null | undefined };

export type CreateMyAnswerMutationVariables = Exact<{
  input: CreateMyAnswerInputBase;
}>;


export type CreateMyAnswerMutation = { __typename?: 'Mutation', createMyAnswer?: { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateMyArticleMutationVariables = Exact<{
  input: CreateMyArticleInputBase;
}>;


export type CreateMyArticleMutation = { __typename?: 'Mutation', createMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type CreateMyCompanyMutationVariables = Exact<{
  input: CreateMyCompanyInputBase;
}>;


export type CreateMyCompanyMutation = { __typename?: 'Mutation', createMyCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', role: CompanyMemberRole, company?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type CreateMyOfferMutationVariables = Exact<{
  input: CreateMyOfferInputBase;
}>;


export type CreateMyOfferMutation = { __typename?: 'Mutation', createMyOffer?: { __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateMyQuestionMutationVariables = Exact<{
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  input: CreateMyQuestionInputBase;
}>;


export type CreateMyQuestionMutation = { __typename?: 'Mutation', createMyQuestion?: { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, isVotable?: boolean | null | undefined, isVotedInBy?: boolean | null | undefined, ogImage?: string | null | undefined, pollDeadline?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, votesCount?: number | null | undefined, answers?: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, choices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, mostVotedChoices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateMyReplyMutationVariables = Exact<{
  input: CreateMyReplyInputBase;
}>;


export type CreateMyReplyMutation = { __typename?: 'Mutation', createMyReply?: { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateSkillMutationVariables = Exact<{
  input: CreateSkillInputBase;
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill?: { __typename?: 'Skill', id: string, name: string, slug: string } | null | undefined };

export type DeleteArticleMutationVariables = Exact<{
  input: DeleteArticleInputBase;
}>;


export type DeleteArticleMutation = { __typename?: 'Mutation', deleteArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type DeleteCompanyArticleMutationVariables = Exact<{
  input: DeleteCompanyArticleInputBase;
}>;


export type DeleteCompanyArticleMutation = { __typename?: 'Mutation', deleteCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type DeleteJobMutationVariables = Exact<{
  input: DeleteJobInputBase;
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type DeleteMyAnswerMutationVariables = Exact<{
  input: DeleteMyAnswerInputBase;
}>;


export type DeleteMyAnswerMutation = { __typename?: 'Mutation', deleteMyAnswer?: { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteMyArticleMutationVariables = Exact<{
  input: DeleteMyArticleInputBase;
}>;


export type DeleteMyArticleMutation = { __typename?: 'Mutation', deleteMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type DeleteMyOfferMutationVariables = Exact<{
  input: DeleteMyOfferInputBase;
}>;


export type DeleteMyOfferMutation = { __typename?: 'Mutation', deleteMyOffer?: { __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteMyQuestionMutationVariables = Exact<{
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  input: DeleteMyQuestionInputBase;
}>;


export type DeleteMyQuestionMutation = { __typename?: 'Mutation', deleteMyQuestion?: { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, isVotable?: boolean | null | undefined, isVotedInBy?: boolean | null | undefined, ogImage?: string | null | undefined, pollDeadline?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, votesCount?: number | null | undefined, answers?: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, choices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, mostVotedChoices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteUserAttachmentMutationVariables = Exact<{
  input: DeleteUserAttachmentInputBase;
}>;


export type DeleteUserAttachmentMutation = { __typename?: 'Mutation', deleteUserAttachment?: { __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type DuplicateJobMutationVariables = Exact<{
  input: DuplicateJobInputBase;
}>;


export type DuplicateJobMutation = { __typename?: 'Mutation', duplicateJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type MarkAllMessagesAsReadMutationVariables = Exact<{
  input: MarkAllMessagesAsReadInputBase;
}>;


export type MarkAllMessagesAsReadMutation = { __typename?: 'Mutation', markAllMessagesAsRead?: { __typename?: 'MarkAllMessagesAsReadPayload', clientMutationId?: string | null | undefined } | null | undefined };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  input: MarkNotificationsAsReadInputBase;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead?: { __typename?: 'MarkNotificationsAsReadPayload', clientMutationId?: string | null | undefined, hasUnreadNotifications?: boolean | null | undefined, notifications?: Array<{ __typename?: 'Notification', category: NotificationCategory, createdAt: string, id: string, isRead: boolean, updatedAt: string, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string } } } | null | undefined }> | null | undefined } | null | undefined };

export type RemoveCompanyMemberMutationVariables = Exact<{
  input: RemoveCompanyMemberInputBase;
}>;


export type RemoveCompanyMemberMutation = { __typename?: 'Mutation', removeCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type RemoveCompanyReferenceMutationVariables = Exact<{
  input: RemoveCompanyReferenceInputBase;
}>;


export type RemoveCompanyReferenceMutation = { __typename?: 'Mutation', removeCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RemoveExperienceMutationVariables = Exact<{
  input: RemoveExperienceInputBase;
}>;


export type RemoveExperienceMutation = { __typename?: 'Mutation', removeExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined } } | null | undefined };

export type RemoveInvestmentMutationVariables = Exact<{
  input: RemoveInvestmentInputBase;
}>;


export type RemoveInvestmentMutation = { __typename?: 'Mutation', removeInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type RemoveInvestorMutationVariables = Exact<{
  input: RemoveInvestorInputBase;
}>;


export type RemoveInvestorMutation = { __typename?: 'Mutation', removeInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined } | null | undefined };

export type RemoveMyJobBookmarkMutationVariables = Exact<{
  input: RemoveMyJobBookmarkInputBase;
}>;


export type RemoveMyJobBookmarkMutation = { __typename?: 'Mutation', removeMyJobBookmark?: { __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type RemoveProductMutationVariables = Exact<{
  input: RemoveProductInputBase;
}>;


export type RemoveProductMutation = { __typename?: 'Mutation', removeProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type RemoveUserReferenceMutationVariables = Exact<{
  input: RemoveUserReferenceInputBase;
}>;


export type RemoveUserReferenceMutation = { __typename?: 'Mutation', removeUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ToggleArticleLikedStateMutationVariables = Exact<{
  input: ToggleArticleLikedStateInputBase;
}>;


export type ToggleArticleLikedStateMutation = { __typename?: 'Mutation', toggleArticleLikedState?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined };

export type ToggleFollowCompanyMutationVariables = Exact<{
  input: ToggleFollowCompanyInputBase;
}>;


export type ToggleFollowCompanyMutation = { __typename?: 'Mutation', toggleFollowCompany?: { __typename?: 'Company', slug: string, followersCount?: number | null | undefined, isFollowing?: boolean | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type ToggleFollowUserMutationVariables = Exact<{
  input: ToggleFollowUserInputBase;
}>;


export type ToggleFollowUserMutation = { __typename?: 'Mutation', toggleFollowUser?: { __typename?: 'User', username: string, name: string, followersCount?: number | null | undefined, followingCount?: number | null | undefined, isFollowing?: boolean | null | undefined, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInputBase;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, headerImage?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, openseaUrl?: string | null | undefined, slug: string, status?: string | null | undefined, telegramUrl?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateCompanyArticleMutationVariables = Exact<{
  input: UpdateCompanyArticleInputBase;
}>;


export type UpdateCompanyArticleMutation = { __typename?: 'Mutation', updateCompanyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type UpdateCompanyMemberMutationVariables = Exact<{
  input: UpdateCompanyMemberInputBase;
}>;


export type UpdateCompanyMemberMutation = { __typename?: 'Mutation', updateCompanyMember?: { __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } | null | undefined };

export type UpdateCompanyNotificationSettingsMutationVariables = Exact<{
  input: UpdateCompanyNotificationSettingsInputBase;
}>;


export type UpdateCompanyNotificationSettingsMutation = { __typename?: 'Mutation', updateCompanyNotificationSettings?: { __typename?: 'Company', slug: string, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateCompanyReferenceMutationVariables = Exact<{
  input: UpdateCompanyReferenceInputBase;
}>;


export type UpdateCompanyReferenceMutation = { __typename?: 'Mutation', updateCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateExperienceMutationVariables = Exact<{
  input: UpdateExperienceInputBase;
}>;


export type UpdateExperienceMutation = { __typename?: 'Mutation', updateExperience?: { __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined } } | null | undefined };

export type UpdateInvestmentMutationVariables = Exact<{
  input: UpdateInvestmentInputBase;
}>;


export type UpdateInvestmentMutation = { __typename?: 'Mutation', updateInvestment?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdateInvestorMutationVariables = Exact<{
  input: UpdateInvestorInputBase;
}>;


export type UpdateInvestorMutation = { __typename?: 'Mutation', updateInvestor?: { __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', jobTitle?: string | null | undefined, bio?: string | null | undefined, avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateJobMutationVariables = Exact<{
  input: UpdateJobInputBase;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob?: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInputBase;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'Me', username: string, name: string, email: string } | null | undefined };

export type UpdateMyAnswerMutationVariables = Exact<{
  input: UpdateMyAnswerInputBase;
}>;


export type UpdateMyAnswerMutation = { __typename?: 'Mutation', updateMyAnswer?: { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMyArticleMutationVariables = Exact<{
  input: UpdateMyArticleInputBase;
}>;


export type UpdateMyArticleMutation = { __typename?: 'Mutation', updateMyArticle?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, slug: string } | null | undefined } | null | undefined };

export type UpdateMyCompanyReferenceMutationVariables = Exact<{
  input: UpdateMyCompanyReferenceInputBase;
}>;


export type UpdateMyCompanyReferenceMutation = { __typename?: 'Mutation', updateMyCompanyReference?: { __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMyOfferMutationVariables = Exact<{
  input: UpdateMyOfferInputBase;
}>;


export type UpdateMyOfferMutation = { __typename?: 'Mutation', updateMyOffer?: { __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInputBase;
}>;


export type UpdateMyProfileMutation = { __typename?: 'Mutation', updateMyProfile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, delayOfEmailNotificationsForAnswers?: UserProfileDelayOfEmailNotificationsForAnswersBase | null | undefined, delayOfEmailNotificationsForFollower?: UserProfileDelayOfEmailNotificationsForFollower | null | undefined, delayOfEmailNotificationsForMessages?: UserProfileDelayOfEmailNotificationsForMessages | null | undefined, delayOfEmailNotificationsForTokenTransactions?: UserProfileDelayOfEmailNotificationsForTokenTransactionsBase | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, openseaUrl?: string | null | undefined, receiveEmailNotificationsForAnswers?: boolean | null | undefined, receiveEmailNotificationsForFollower?: boolean | null | undefined, receiveEmailNotificationsForMessages?: boolean | null | undefined, receiveEmailNotificationsForTokenTransactions?: boolean | null | undefined, solanaAddress?: string | null | undefined, telegramUrl?: string | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdateMyQuestionMutationVariables = Exact<{
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  input: UpdateMyQuestionInputBase;
}>;


export type UpdateMyQuestionMutation = { __typename?: 'Mutation', updateMyQuestion?: { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, isVotable?: boolean | null | undefined, isVotedInBy?: boolean | null | undefined, ogImage?: string | null | undefined, pollDeadline?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, votesCount?: number | null | undefined, answers?: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, choices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, mostVotedChoices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateMyReferenceMutationVariables = Exact<{
  input: UpdateMyReferenceInputBase;
}>;


export type UpdateMyReferenceMutation = { __typename?: 'Mutation', updateMyReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInputBase;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct?: { __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type UpdateUserAttachmentMutationVariables = Exact<{
  input: UpdateUserAttachmentInputBase;
}>;


export type UpdateUserAttachmentMutation = { __typename?: 'Mutation', updateUserAttachment?: { __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined } | null | undefined };

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  input: UpdateUserNotificationSettingsInputBase;
}>;


export type UpdateUserNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings?: { __typename?: 'User', name: string, username: string, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type UpdateUserReferenceMutationVariables = Exact<{
  input: UpdateUserReferenceInputBase;
}>;


export type UpdateUserReferenceMutation = { __typename?: 'Mutation', updateUserReference?: { __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type VoteForChoiceMutationVariables = Exact<{
  input: VoteForChoiceInputBase;
}>;


export type VoteForChoiceMutation = { __typename?: 'Mutation', voteForChoice?: { __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type FetchAngelsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  orderBy?: InputMaybe<UserOrderBase>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchAngelsQuery = { __typename?: 'Query', angels: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, hasInvestmentsWithJobs?: boolean | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchAnswersQueryVariables = Exact<{
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchAnswersQuery = { __typename?: 'Query', answers: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchArticleQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchArticleQuery = { __typename?: 'Query', article?: { __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined };

export type FetchArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type FetchArticlesQuery = { __typename?: 'Query', articles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined, fundraisingManualFields?: { __typename?: 'FundraisingManual', id: string, step: number, subcategory: FundraisingManualSubcategory } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchBlockchainsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchBlockchainsQuery = { __typename?: 'Query', blockchains: { __typename?: 'BlockchainConnection', nodes?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined } | null | undefined> | null | undefined } };

export type FetchMessageThreadsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMessageThreadsQuery = { __typename?: 'Query', messageThreads: Array<{ __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, jobApplication?: { __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined } } | null | undefined }> };

export type FetchMessageThreadQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMessageThreadQuery = { __typename?: 'Query', messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } };

export type FetchCompaniesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  companySize?: InputMaybe<CompanySize>;
  roundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  marketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  orderBy?: InputMaybe<CompanyOrderBase>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchCompaniesQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, followersCount?: number | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, hasInvestmentsWithJobs?: boolean | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompaniesWithJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
  angelUsername?: InputMaybe<Scalars['ID']>;
  companyLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  companySize?: InputMaybe<CompanySize>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  tokenGrant?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  investmentTargetMarketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  investmentTargetRoundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isVc?: InputMaybe<Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  marketIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  maxInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minInvestmentAmount?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  roundIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition> | JobTypeOfPosition>;
  vcSlug?: InputMaybe<Scalars['ID']>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm> | JobWorkingForm>;
}>;


export type FetchCompaniesWithJobsQuery = { __typename?: 'Query', companiesWithJobs: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined }> | null | undefined, highlightedJobListings?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompanyQueryVariables = Exact<{
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
  afterReferences?: InputMaybe<Scalars['String']>;
  beforeReferences?: InputMaybe<Scalars['String']>;
  firstReferences?: InputMaybe<Scalars['Int']>;
  lastReferences?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, followersCount?: number | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isFollowing?: boolean | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, openseaUrl?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, telegramUrl?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', isFollower?: boolean | null | undefined, id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, companyReferences?: { __typename?: 'CompanyReferenceConnection', nodes?: Array<{ __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchCompanyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchCompanyArticlesQuery = { __typename?: 'Query', companyArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCompanyForViewerQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchCompanyForViewerQuery = { __typename?: 'Query', company?: { __typename?: 'Company', isFollowing?: boolean | null | undefined, slug: string, companyMembers?: Array<{ __typename?: 'CompanyMember', id?: string | null | undefined, user?: { __typename?: 'User', isFollower?: boolean | null | undefined, id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, notificationSettings?: Array<{ __typename?: 'CompanyNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type FetchCompanyJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  companySlug: Scalars['ID'];
}>;


export type FetchCompanyJobsQuery = { __typename?: 'Query', companyJobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> };

export type FetchFeaturedAngelsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedAngelsQuery = { __typename?: 'Query', featuredAngels: Array<{ __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined }> };

export type FetchFeaturedCompaniesWithJobsQueryVariables = Exact<{
  afterJobs?: InputMaybe<Scalars['String']>;
  beforeJobs?: InputMaybe<Scalars['String']>;
  firstJobs?: InputMaybe<Scalars['Int']>;
  lastJobs?: InputMaybe<Scalars['Int']>;
}>;


export type FetchFeaturedCompaniesWithJobsQuery = { __typename?: 'Query', featuredCompaniesWithJobs: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined } | null | undefined }> | null | undefined, jobs?: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined }> };

export type FetchFeaturedJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedJobsQuery = { __typename?: 'Query', featuredJobs: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }> };

export type FetchFeaturedStartupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedStartupsQuery = { __typename?: 'Query', featuredStartups: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFeaturedStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedStoriesQuery = { __typename?: 'Query', featuredStories: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, isLiked?: boolean | null | undefined, likedUsersCount?: number | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFeaturedVentureCapitalsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchFeaturedVentureCapitalsQuery = { __typename?: 'Query', featuredVentureCapitals: Array<{ __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string } | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchFollowersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityType: FollowableEntityEntityType;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchFollowersQuery = { __typename?: 'Query', followers: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', isFollowing?: boolean | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isJobSeeker: boolean, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchFollowingQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
}>;


export type FetchFollowingQuery = { __typename?: 'Query', following: { __typename?: 'FollowableEntityConnection', nodes?: Array<{ __typename?: 'FollowableEntity', category: FollowableEntityCategory, description?: string | null | undefined, entityType: FollowableEntityEntityType, image?: string | null | undefined, isFollowing?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, name: string, shortDescription?: string | null | undefined, slug: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchJobQuery = { __typename?: 'Query', job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } };

export type FetchJobApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after1?: InputMaybe<Scalars['String']>;
  before1?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first1?: InputMaybe<Scalars['Int']>;
  last1?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobApplicationsQuery = { __typename?: 'Query', jobApplications: { __typename?: 'JobApplicationConnection', nodes?: Array<{ __typename?: 'JobApplication', id: string, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, messageThread: { __typename?: 'MessageThread', id?: string | null | undefined, messageThreadType: MessageThreadType, name?: string | null | undefined, slug: string, messages?: { __typename?: 'MessageConnection', edges?: Array<{ __typename?: 'MessageEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, readers?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }, messageAttachments?: Array<{ __typename?: 'MessageAttachment', file: string, id: string, filename: string, mimeType: string }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, users?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined }> | null | undefined }, user: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobBookmarksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobBookmarksQuery = { __typename?: 'Query', jobBookmarks: { __typename?: 'JobBookmarkConnection', nodes?: Array<{ __typename?: 'JobBookmark', createdAt?: string | null | undefined, id?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobCategoriesQuery = { __typename?: 'Query', jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> };

export type FetchJobFootprintsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companySlug: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  jobSlug?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchJobFootprintsQuery = { __typename?: 'Query', jobFootprints: { __typename?: 'JobFootprintConnection', nodes?: Array<{ __typename?: 'JobFootprint', createdAt?: string | null | undefined, id: string, referer?: string | null | undefined, job?: { __typename?: 'Job', createdAt: string, id: string, slug: string, status: JobStatus, thumbnail: string, title: string, typeOfPosition: JobTypeOfPosition, updatedAt: string, body: string, currencyUnit: CurrencyUnit, workExperience: JobWorkExperience, workingForm: JobWorkingForm, equityGrant: boolean, tokenGrant: boolean, maxMonthlySalary: string, minMonthlySalary: string, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobSeekersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobHuntingStatus?: InputMaybe<Array<UserProfileJobHuntingStatus> | UserProfileJobHuntingStatus>;
  primaryJobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  yearsOfExperience?: InputMaybe<Array<UserProfileYearsOfExperience> | UserProfileYearsOfExperience>;
}>;


export type FetchJobSeekersQuery = { __typename?: 'Query', jobSeekers: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, isJobSeeker: boolean, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchJobTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchJobTagsQuery = { __typename?: 'Query', jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }> };

export type FetchJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  tokenGrant?: InputMaybe<Array<Scalars['Boolean']> | Scalars['Boolean']>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  maxMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  minMonthlySalary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  typeOfPosition?: InputMaybe<Array<JobTypeOfPosition> | JobTypeOfPosition>;
  workExperience?: InputMaybe<JobWorkExperience>;
  workingForm?: InputMaybe<Array<JobWorkingForm> | JobWorkingForm>;
}>;


export type FetchJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchLocationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchLocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', nodes?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string } | null | undefined> | null | undefined } };

export type FetchMarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMarketsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> };

export type FetchMeQueryVariables = Exact<{
  articlesAfter?: InputMaybe<Scalars['String']>;
  articlesBefore?: InputMaybe<Scalars['String']>;
  articlesFirst?: InputMaybe<Scalars['Int']>;
  articlesLast?: InputMaybe<Scalars['Int']>;
  notificationsAfter?: InputMaybe<Scalars['String']>;
  notificationsBefore?: InputMaybe<Scalars['String']>;
  notificationsFirst?: InputMaybe<Scalars['Int']>;
  notificationsLast?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', id?: string | null | undefined, email: string, invitationOf?: InvitationOfBase | null | undefined, isFirstSignIn?: boolean | null | undefined, name: string, username: string, hasUnreadNotifications?: boolean | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', role: CompanyMemberRole, id?: string | null | undefined, company?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, headerImage?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, jobApplicationsCount?: number | null | undefined, jobBookmarksCount?: number | null | undefined, jobFootprintsCount?: number | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, openseaUrl?: string | null | undefined, slug: string, status?: string | null | undefined, telegramUrl?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, experiences?: Array<{ __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, delayOfEmailNotificationsForAnswers?: UserProfileDelayOfEmailNotificationsForAnswersBase | null | undefined, delayOfEmailNotificationsForMessages?: UserProfileDelayOfEmailNotificationsForMessages | null | undefined, delayOfEmailNotificationsForFollower?: UserProfileDelayOfEmailNotificationsForFollower | null | undefined, delayOfEmailNotificationsForTokenTransactions?: UserProfileDelayOfEmailNotificationsForTokenTransactionsBase | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, openseaUrl?: string | null | undefined, receiveEmailNotificationsForAnswers?: boolean | null | undefined, receiveEmailNotificationsForMessages?: boolean | null | undefined, receiveEmailNotificationsForFollower?: boolean | null | undefined, receiveEmailNotificationsForTokenTransactions?: boolean | null | undefined, solanaAddress?: string | null | undefined, telegramUrl?: string | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, userAttachments?: Array<{ __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, notifications?: { __typename?: 'NotificationConnection', edges?: Array<{ __typename?: 'NotificationEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, answerNotification?: { __typename?: 'AnswerNotification', id: string, answer: { __typename?: 'Answer', id?: string | null | undefined, slug?: string | null | undefined, body?: string | null | undefined, status?: AnswerStatusBase | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, rootQuestion?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined } | null | undefined } } | null | undefined, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, tokenTransactionNotification?: { __typename?: 'TokenTransactionNotification', id: string, tokenTransaction: { __typename?: 'TokenTransaction', amount: string, sender?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchMyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyArticlesQuery = { __typename?: 'Query', myArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyCompanyQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyQuery = { __typename?: 'Query', myCompany?: { __typename?: 'MyCompany', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, jobApplicationsCount?: number | null | undefined, jobBookmarksCount?: number | null | undefined, jobFootprintsCount?: number | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, companyMembers?: Array<{ __typename?: 'MyCompanyMember', id?: string | null | undefined, role: CompanyMemberRole, invitedByUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined }> | null | undefined, receivedInvestments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, angel?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', bio?: string | null | undefined, avatar?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, twitterUrl?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, companyInvestedFrom?: { __typename?: 'Company', aboutUs?: string | null | undefined, id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, url?: string | null | undefined } | null | undefined, round?: { __typename?: 'Round', id: string, slug?: string | null | undefined, name: string } | null | undefined, investorComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined, products?: Array<{ __typename?: 'Product', description?: string | null | undefined, id: string, image?: string | null | undefined, name?: string | null | undefined, url?: string | null | undefined, blockchains?: Array<{ __typename?: 'Blockchain', id: string, name: string, slug?: string | null | undefined }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined };

export type FetchMyCompanyArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyArticlesQuery = { __typename?: 'Query', myCompany?: { __typename?: 'MyCompany', articles?: { __typename?: 'ArticleConnection', edges?: Array<{ __typename?: 'ArticleEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchMyCompanyReferencesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchMyCompanyReferencesQuery = { __typename?: 'Query', myCompanyReferences: { __typename?: 'CompanyReferenceConnection', nodes?: Array<{ __typename?: 'CompanyReference', comment: string, id: string, status: CompanyReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyJobBookmarksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyJobBookmarksQuery = { __typename?: 'Query', myJobBookmarks: { __typename?: 'JobBookmarkConnection', nodes?: Array<{ __typename?: 'JobBookmark', id?: string | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, job: { __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> }, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyJobsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  companySlug: Scalars['ID'];
}>;


export type FetchMyJobsQuery = { __typename?: 'Query', myJobs: { __typename?: 'JobConnection', nodes?: Array<{ __typename?: 'Job', address?: string | null | undefined, body: string, createdAt: string, currencyUnit: CurrencyUnit, equityGrant: boolean, id: string, maxMonthlySalary: string, minMonthlySalary: string, slug: string, status: JobStatus, thumbnail: string, title: string, tokenGrant: boolean, typeOfPosition: JobTypeOfPosition, updatedAt: string, workExperience: JobWorkExperience, workingForm: JobWorkingForm, company?: { __typename?: 'Company', aboutUs?: string | null | undefined, companySize?: CompanySize | null | undefined, conceptPitch?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, excludeFromSearch?: boolean | null | undefined, facebookUrl?: string | null | undefined, id?: string | null | undefined, instagramUrl?: string | null | undefined, isVc?: boolean | null | undefined, linkedinUrl?: string | null | undefined, logo?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, totalFundingAmount?: string | null | undefined, twitterUrl?: string | null | undefined, url?: string | null | undefined, youtubeUrl?: string | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, markets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, round?: { __typename?: 'Round', id: string, name: string, slug?: string | null | undefined } | null | undefined } | null | undefined, jobCategories: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }>, jobTags: Array<{ __typename?: 'JobTag', id: string, name: string, slug: string }>, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, primaryRecruitingContact?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined, skills: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyOffersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyOffersQuery = { __typename?: 'Query', myOffers: { __typename?: 'OfferConnection', nodes?: Array<{ __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchMyReferencesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchMyReferencesQuery = { __typename?: 'Query', myReferences: { __typename?: 'UserReferenceConnection', nodes?: Array<{ __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchNftQueryVariables = Exact<{
  mintAddress: Scalars['String'];
}>;


export type FetchNftQuery = { __typename?: 'Query', nft: { __typename?: 'Nft', description?: string | null | undefined, id?: string | null | undefined, image?: string | null | undefined, mintAddress?: string | null | undefined, name?: string | null | undefined, listing?: { __typename?: 'Listing', id?: string | null | undefined, isSold?: boolean | null | undefined, listingAddress?: string | null | undefined, listingAmount?: string | null | undefined, listingAddressSol?: string | null | undefined, listingAmountSol?: string | null | undefined } | null | undefined, nftAttributes?: Array<{ __typename?: 'NftAttribute', value?: string | null | undefined, nftAttributeTrait?: { __typename?: 'NftAttributeTrait', traitType?: string | null | undefined } | null | undefined }> | null | undefined } };

export type FetchNftsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchNftsQuery = { __typename?: 'Query', nfts: { __typename?: 'NftConnection', nodes?: Array<{ __typename?: 'Nft', image?: string | null | undefined, mintAddress?: string | null | undefined, name?: string | null | undefined, listing?: { __typename?: 'Listing', isSold?: boolean | null | undefined, listingAddress?: string | null | undefined, listingAmount?: string | null | undefined, listingAddressSol?: string | null | undefined, listingAmountSol?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchNftsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchNftsCountQuery = { __typename?: 'Query', nftsCount: { __typename?: 'NftsCount', count?: number | null | undefined } };

export type FetchNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type FetchNotificationsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', email: string, name: string, username: string, notifications?: { __typename?: 'NotificationConnection', nodes?: Array<{ __typename?: 'Notification', id: string, category: NotificationCategory, isRead: boolean, createdAt: string, updatedAt: string, answerNotification?: { __typename?: 'AnswerNotification', id: string, answer: { __typename?: 'Answer', id?: string | null | undefined, slug?: string | null | undefined, body?: string | null | undefined, status?: AnswerStatusBase | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined, rootQuestion?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined } | null | undefined } } | null | undefined, jobSeekingStatusUpdatedNotification?: { __typename?: 'JobSeekingStatusUpdatedNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, newJobOpeningNotification?: { __typename?: 'NewJobOpeningNotification', id: string, company: { __typename?: 'Company', name?: string | null | undefined, slug: string } } | null | undefined, newMessageNotification?: { __typename?: 'NewMessageNotification', id: string, message: { __typename?: 'Message', id: string, body: string, createdAt: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newRecruitingMessageNotification?: { __typename?: 'NewRecruitingMessageNotification', id: string, company: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, slug: string }, message: { __typename?: 'Message', body: string, createdAt: string, id: string, updatedAt: string, user: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, messageThread?: { __typename?: 'MessageThread', slug: string, messageThreadType: MessageThreadType } | null | undefined } } | null | undefined, newUserFollowerNotification?: { __typename?: 'NewUserFollowerNotification', id: string, user: { __typename?: 'User', name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } } | null | undefined, tokenTransactionNotification?: { __typename?: 'TokenTransactionNotification', id: string, tokenTransaction: { __typename?: 'TokenTransaction', amount: string, sender?: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined } | null | undefined } } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchOfferQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type FetchOfferQuery = { __typename?: 'Query', offer: { __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } };

export type FetchOffersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  currencyUnit?: InputMaybe<CurrencyUnit>;
  jobCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  locationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  salary?: InputMaybe<Scalars['BigInt']>;
  query?: InputMaybe<Scalars['String']>;
  jobType?: InputMaybe<Array<OfferJobTypeBase> | OfferJobTypeBase>;
  workingForm?: InputMaybe<Array<OfferWorkingFormBase> | OfferWorkingFormBase>;
}>;


export type FetchOffersQuery = { __typename?: 'Query', offers: { __typename?: 'OfferConnection', nodes?: Array<{ __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchPickedUpFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPickedUpFeaturesQuery = { __typename?: 'Query', pickedUpFeatures: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, ogImage?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, opinionsUser?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined }> };

export type FetchQuestionQueryVariables = Exact<{
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  slug: Scalars['ID'];
}>;


export type FetchQuestionQuery = { __typename?: 'Query', question: { __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, isVotable?: boolean | null | undefined, isVotedInBy?: boolean | null | undefined, ogImage?: string | null | undefined, pollDeadline?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, votesCount?: number | null | undefined, answers?: { __typename?: 'AnswerConnection', nodes?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, choices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, mostVotedChoices?: Array<{ __typename?: 'Choice', id: string, name: string, votes: number, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined }> | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } };

export type FetchQuestionCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchQuestionCategoriesQuery = { __typename?: 'Query', questionCategories: Array<{ __typename?: 'QuestionCategory', id: string, name: string, slug: string }> };

export type FetchQuestionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<QuestionOrderBase>;
  questionCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchQuestionsQuery = { __typename?: 'Query', questions: { __typename?: 'QuestionConnection', nodes?: Array<{ __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchReplyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchReplyQuery = { __typename?: 'Query', reply: { __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, childReplies?: Array<{ __typename?: 'Answer', amount?: string | null | undefined, body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, repliesCount?: number | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined, parentReply?: { __typename?: 'Answer', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: AnswerStatusBase | null | undefined, updatedAt?: string | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, question?: { __typename?: 'Question', body?: string | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, respondent?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } };

export type FetchSkillsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchSkillsQuery = { __typename?: 'Query', skills: { __typename?: 'SkillConnection', nodes?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string } | null | undefined> | null | undefined } };

export type FetchTokensQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type FetchTokensQuery = { __typename?: 'Query', tokens: { __typename?: 'TokenConnection', nodes?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined } | null | undefined> | null | undefined } };

export type FetchUserQueryVariables = Exact<{
  afterQuestions?: InputMaybe<Scalars['String']>;
  beforeQuestions?: InputMaybe<Scalars['String']>;
  firstQuestions?: InputMaybe<Scalars['Int']>;
  lastQuestions?: InputMaybe<Scalars['Int']>;
  afterReferences?: InputMaybe<Scalars['String']>;
  beforeReferences?: InputMaybe<Scalars['String']>;
  firstReferences?: InputMaybe<Scalars['Int']>;
  lastReferences?: InputMaybe<Scalars['Int']>;
  afterAnswers?: InputMaybe<Scalars['String']>;
  beforeAnswers?: InputMaybe<Scalars['String']>;
  firstAnswers?: InputMaybe<Scalars['Int']>;
  lastAnswers?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
}>;


export type FetchUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', followersCount?: number | null | undefined, followingCount?: number | null | undefined, id?: string | null | undefined, isFollower?: boolean | null | undefined, isFollowing?: boolean | null | undefined, name: string, username: string, experiences?: Array<{ __typename?: 'Experience', current: boolean, description?: string | null | undefined, endedAt?: string | null | undefined, id: string, startedAt?: string | null | undefined, status: string, title?: string | null | undefined, addedByUser: { __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, isJobSeeker: boolean } | null | undefined }, company: { __typename?: 'Company', id?: string | null | undefined, isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } }> | null | undefined, investments?: Array<{ __typename?: 'Investment', id: string, investedAt?: string | null | undefined, isLeadInvestor?: boolean | null | undefined, referenceUrl?: string | null | undefined, company?: { __typename?: 'Company', isVc?: boolean | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, status?: string | null | undefined, url?: string | null | undefined } | null | undefined, startupComment?: { __typename?: 'InvestmentComment', comment: string, commenterType: CommenterTypeBase, commenter: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string } } | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined }> | null | undefined, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, birthday?: any | null | undefined, birthdayAccessScope?: UserProfileBirthdayAccessScopeBase | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, denyNewContact?: boolean | null | undefined, desiredCareerPath?: UserProfileDesiredCareerPathBase | null | undefined, desiredCommunicationStyle?: UserProfileDesiredCommunicationStyleBase | null | undefined, desiredDecisionCulture?: UserProfileDesiredDecisionCultureBase | null | undefined, desiredEvaluationCulture?: UserProfileDesiredEvaluationCultureBase | null | undefined, desiredManagementCulture?: UserProfileDesiredManagementCultureBase | null | undefined, desiredThingsInNextJob?: string | null | undefined, desiredOrientationCulture?: UserProfileDesiredOrientationCultureBase | null | undefined, desiredProgressionStyle?: UserProfileDesiredProgressionStyleBase | null | undefined, desiredRoleOnTeam?: UserProfileDesiredRoleOnTeamBase | null | undefined, desiredTakingOnWorkStyle?: UserProfileDesiredTakingOnWorkStyleBase | null | undefined, desiredTrainingCulture?: UserProfileDesiredTrainingCultureBase | null | undefined, desiredWorkStyle?: UserProfileDesiredWorkStyleBase | null | undefined, desiredWorkplaceCulture?: UserProfileDesiredWorkplaceCultureBase | null | undefined, discordUrl?: string | null | undefined, facebookUrl?: string | null | undefined, githubUrl?: string | null | undefined, headerImage?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isCofounderDesired?: boolean | null | undefined, isContractorDesired?: boolean | null | undefined, isFulltimeEmployeeDesired?: boolean | null | undefined, isInternDesired?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isJobSeeker: boolean, isJobSeekerMailMagazineAccepted?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, openseaUrl?: string | null | undefined, solanaAddress?: string | null | undefined, telegramUrl?: string | null | undefined, twitterUrl?: string | null | undefined, websiteUrl?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, jobCategories?: Array<{ __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string, slug: string }> | null | undefined, tokens?: Array<{ __typename?: 'Token', id: string, logo?: string | null | undefined, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined, questions?: { __typename?: 'QuestionConnection', nodes?: Array<{ __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined, userAttachments?: Array<{ __typename?: 'UserAttachment', categoryName: UserAttachmentCategoryNameBase, description?: string | null | undefined, file?: string | null | undefined, filename?: string | null | undefined, id: string, name?: string | null | undefined, url?: string | null | undefined }> | null | undefined, userReferences?: { __typename?: 'UserReferenceConnection', nodes?: Array<{ __typename?: 'UserReference', comment: string, id: string, status: UserReferenceStatus, commenter?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type FetchUserArticlesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
}>;


export type FetchUserArticlesQuery = { __typename?: 'Query', userArticles: { __typename?: 'ArticleConnection', nodes?: Array<{ __typename?: 'Article', content?: string | null | undefined, createdAt: string, description?: string | null | undefined, id?: string | null | undefined, ogImage?: string | null | undefined, originalArticleUrl?: string | null | undefined, originalSiteName?: string | null | undefined, slug: string, status: ArticleStatus, thumbnail?: string | null | undefined, title: string, updatedAt: string, category?: { __typename?: 'Category', id: string, name: string, slug?: string | null | undefined } | null | undefined, company?: { __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string } | null | undefined, topics?: Array<{ __typename?: 'Topic', id: string, name: string, slug?: string | null | undefined }> | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchUserForViewerQueryVariables = Exact<{
  username: Scalars['ID'];
}>;


export type FetchUserForViewerQuery = { __typename?: 'Query', user?: { __typename?: 'User', isFollower?: boolean | null | undefined, isFollowing?: boolean | null | undefined, name: string, username: string, notificationSettings?: Array<{ __typename?: 'UserNotification', id?: string | null | undefined, name?: string | null | undefined, slug: string }> | null | undefined } | null | undefined };

export type FetchUserOffersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username: Scalars['ID'];
}>;


export type FetchUserOffersQuery = { __typename?: 'Query', userOffers: { __typename?: 'OfferConnection', nodes?: Array<{ __typename?: 'Offer', body: string, createdAt: string, currencyUnit: CurrencyUnit, id: string, jobType: OfferJobTypeBase, salary: string, slug: string, status: OfferStatusBase, thumbnail: string, title: string, updatedAt: string, workingForm: OfferWorkingFormBase, jobCategory: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string }, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined, user?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, desiredThingsInNextJob?: string | null | undefined, yearsOfExperience?: UserProfileYearsOfExperience | null | undefined, primaryJobCategory?: { __typename?: 'JobCategory', id: string, jobCategoryType: JobCategoryType, name: string, slug: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type FetchUserQuestionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['ID']>;
}>;


export type FetchUserQuestionsQuery = { __typename?: 'Query', userQuestions: { __typename?: 'QuestionConnection', nodes?: Array<{ __typename?: 'Question', amount?: string | null | undefined, answersCount?: number | null | undefined, createdAt?: string | null | undefined, id?: string | null | undefined, questionType?: QuestionTypeBase | null | undefined, slug?: string | null | undefined, status?: QuestionStatusBase | null | undefined, title?: string | null | undefined, updatedAt?: string | null | undefined, questionCategory?: { __typename?: 'QuestionCategory', id: string, name: string, slug: string } | null | undefined, questioner?: { __typename?: 'User', id?: string | null | undefined, name: string, status?: UserStatus | null | undefined, username: string, profile?: { __typename?: 'UserProfile', allowMessageRequestsFrom?: UserProfileAllowMessageRequestsFrom | null | undefined, avatar?: string | null | undefined, bio?: string | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, isJobSeeker: boolean, jobHuntingStatus?: UserProfileJobHuntingStatus | null | undefined, denyNewContact?: boolean | null | undefined, solanaAddress?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type SearchCompanyQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
}>;


export type SearchCompanyQuery = { __typename?: 'Query', searchCompany: { __typename?: 'CompanyConnection', nodes?: Array<{ __typename?: 'Company', id?: string | null | undefined, logo?: string | null | undefined, name?: string | null | undefined, slug: string, url?: string | null | undefined } | null | undefined> | null | undefined } };

export type SearchUserQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchUserQuery = { __typename?: 'Query', searchUser: { __typename?: 'UserConnection', edges?: Array<{ __typename?: 'UserEdge', cursor: string } | null | undefined> | null | undefined, nodes?: Array<{ __typename?: 'User', id?: string | null | undefined, name: string, username: string, profile?: { __typename?: 'UserProfile', avatar?: string | null | undefined, bio?: string | null | undefined, denyNewContact?: boolean | null | undefined, facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, isAngel?: boolean | null | undefined, isInvestor?: boolean | null | undefined, isVerifiedAccount?: boolean | null | undefined, jobTitle?: string | null | undefined, linkedinUrl?: string | null | undefined, twitterUrl?: string | null | undefined, currencyUnit?: CurrencyUnit | null | undefined, maxInvestmentAmount?: string | null | undefined, minInvestmentAmount?: string | null | undefined, isJobSeeker: boolean, investmentTargetMarkets?: Array<{ __typename?: 'Market', id: string, name: string, slug?: string | null | undefined }> | null | undefined, investmentTargetRounds?: Array<{ __typename?: 'Round', id: string, name: string, slug?: string | null | undefined }> | null | undefined, locations?: Array<{ __typename?: 'Location', id: string, locationType: LocationCategory, name: string, shortDescription: string, slug: string }> | null | undefined } | null | undefined } | null | undefined> | null | undefined, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null | undefined } } };

export type ValidInvitationTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidInvitationTokenQuery = { __typename?: 'Query', validInvitationToken: { __typename?: 'Invitation', invitationOf: InvitationOfBase, isValid: boolean } };

export const MinUserWithSolanaAddressFieldsFragmentDocBase = gql`
    fragment minUserWithSolanaAddressFields on User {
  id
  name
  profile {
    allowMessageRequestsFrom
    avatar
    bio
    isVerifiedAccount
    jobTitle
    isJobSeeker
    jobHuntingStatus
    denyNewContact
    solanaAddress
  }
  status
  username
}
    `;
export const ParentReplyFieldsFragmentDocBase = gql`
    fragment parentReplyFields on Answer {
  body
  createdAt
  id
  respondent {
    ...minUserWithSolanaAddressFields
  }
  slug
  status
  updatedAt
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const ReplyFieldsFragmentDocBase = gql`
    fragment replyFields on Answer {
  amount
  body
  createdAt
  id
  repliesCount
  parentReply {
    ...parentReplyFields
  }
  respondent {
    ...minUserWithSolanaAddressFields
  }
  slug
  status
  updatedAt
}
    ${ParentReplyFieldsFragmentDocBase}
${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const QuestionCategoryFieldsFragmentDocBase = gql`
    fragment questionCategoryFields on QuestionCategory {
  id
  name
  slug
}
    `;
export const MinUserFieldsFragmentDocBase = gql`
    fragment minUserFields on User {
  id
  name
  profile {
    allowMessageRequestsFrom
    avatar
    bio
    isVerifiedAccount
    jobTitle
    isJobSeeker
    jobHuntingStatus
    denyNewContact
  }
  status
  username
}
    `;
export const AnswerFieldsFragmentDocBase = gql`
    fragment answerFields on Answer {
  amount
  body
  childReplies {
    ...replyFields
  }
  createdAt
  id
  repliesCount
  parentReply {
    ...parentReplyFields
  }
  question {
    body
    createdAt
    id
    questionCategory {
      ...questionCategoryFields
    }
    slug
    status
    title
    updatedAt
    questioner {
      ...minUserFields
    }
  }
  respondent {
    ...minUserWithSolanaAddressFields
  }
  slug
  status
  updatedAt
}
    ${ReplyFieldsFragmentDocBase}
${ParentReplyFieldsFragmentDocBase}
${QuestionCategoryFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const MinAnswerFieldsFragmentDocBase = gql`
    fragment minAnswerFields on Answer {
  id
  respondent {
    ...minUserWithSolanaAddressFields
  }
  slug
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const LocationFieldsFragmentDocBase = gql`
    fragment locationFields on Location {
  id
  locationType
  name
  shortDescription
  slug
}
    `;
export const MarketFieldsFragmentDocBase = gql`
    fragment marketFields on Market {
  id
  name
  slug
}
    `;
export const RoundFieldsFragmentDocBase = gql`
    fragment roundFields on Round {
  id
  name
  slug
}
    `;
export const MinCompanyFieldFragmentDocBase = gql`
    fragment minCompanyField on Company {
  aboutUs
  companySize
  conceptPitch
  currencyUnit
  denyNewContact
  excludeFromSearch
  facebookUrl
  id
  instagramUrl
  isVc
  linkedinUrl
  locations {
    ...locationFields
  }
  logo
  markets {
    ...marketFields
  }
  maxInvestmentAmount
  minInvestmentAmount
  name
  round {
    ...roundFields
  }
  slug
  status
  totalFundingAmount
  twitterUrl
  url
  youtubeUrl
}
    ${LocationFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}`;
export const JobCategoryFieldsFragmentDocBase = gql`
    fragment jobCategoryFields on JobCategory {
  id
  jobCategoryType
  name
  slug
}
    `;
export const JobTagFieldsFragmentDocBase = gql`
    fragment jobTagFields on JobTag {
  id
  name
  slug
}
    `;
export const SkillFieldsFragmentDocBase = gql`
    fragment skillFields on Skill {
  id
  name
  slug
}
    `;
export const JobFieldsFragmentDocBase = gql`
    fragment jobFields on Job {
  address
  body
  company {
    ...minCompanyField
  }
  createdAt
  currencyUnit
  equityGrant
  id
  jobCategories {
    ...jobCategoryFields
  }
  jobTags {
    ...jobTagFields
  }
  locations {
    ...locationFields
  }
  maxMonthlySalary
  minMonthlySalary
  primaryJobCategory {
    ...jobCategoryFields
  }
  primaryRecruitingContact {
    ...minUserFields
  }
  skills {
    ...skillFields
  }
  slug
  status
  thumbnail
  title
  tokenGrant
  typeOfPosition
  updatedAt
  workExperience
  workingForm
}
    ${MinCompanyFieldFragmentDocBase}
${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}`;
export const CompanyWithJobsFragmentDocBase = gql`
    fragment companyWithJobs on Company {
  jobs(after: $afterJobs, before: $beforeJobs, first: $firstJobs, last: $lastJobs) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const HighlightedJobListingsFragmentDocBase = gql`
    fragment highlightedJobListings on Company {
  highlightedJobListings(
    after: $afterJobs
    before: $beforeJobs
    first: $firstJobs
    last: $lastJobs
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const CompanyReferenceFieldsFragmentDocBase = gql`
    fragment companyReferenceFields on CompanyReference {
  comment
  commenter {
    ...minUserFields
  }
  id
  status
}
    ${MinUserFieldsFragmentDocBase}`;
export const RecievedInvestmentFieldsFragmentDocBase = gql`
    fragment recievedInvestmentFields on Investment {
  angel {
    id
    name
    profile {
      bio
      avatar
      isVerifiedAccount
      twitterUrl
      isJobSeeker
    }
    username
  }
  company {
    aboutUs
    companySize
    conceptPitch
    id
    isVc
    logo
    name
    slug
    status
    totalFundingAmount
    url
  }
  companyInvestedFrom {
    aboutUs
    id
    logo
    name
    slug
    status
    investments {
      id
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        slug
        name
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
  }
  id
  investedAt
  isLeadInvestor
  referenceUrl
  startupComment {
    comment
    commenter {
      id
      name
      status
      username
    }
    commenterType
  }
  investorComment {
    comment
    commenter {
      id
      name
      status
      username
    }
    commenterType
  }
}
    `;
export const MinMessageThreadFieldsFragmentDocBase = gql`
    fragment minMessageThreadFields on MessageThread {
  id
  messageThreadType
  name
  slug
  users {
    ...minUserFields
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const MinJobApplicationFieldsFragmentDocBase = gql`
    fragment minJobApplicationFields on JobApplication {
  id
  job {
    ...jobFields
  }
  user {
    ...minUserFields
  }
  messageThread {
    ...minMessageThreadFields
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinMessageThreadFieldsFragmentDocBase}`;
export const MessageAttachmentFieldsFragmentDocBase = gql`
    fragment messageAttachmentFields on MessageAttachment {
  file
  id
  filename
  mimeType
}
    `;
export const MessageFieldsFragmentDocBase = gql`
    fragment messageFields on Message {
  body
  createdAt
  id
  updatedAt
  readers {
    ...minUserFields
  }
  user {
    ...minUserFields
  }
  messageAttachments {
    ...messageAttachmentFields
  }
}
    ${MinUserFieldsFragmentDocBase}
${MessageAttachmentFieldsFragmentDocBase}`;
export const NotificationFieldsFragmentDocBase = gql`
    fragment notificationFields on Notification {
  answerNotification {
    answer {
      id
      respondent {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
      rootQuestion {
        body
        createdAt
        id
        questionCategory {
          ...questionCategoryFields
        }
        slug
        status
        title
        updatedAt
      }
      slug
      body
      status
      createdAt
      updatedAt
    }
    id
  }
  id
  category
  isRead
  jobSeekingStatusUpdatedNotification {
    id
    user {
      name
      username
      profile {
        avatar
        isJobSeeker
      }
    }
  }
  newJobOpeningNotification {
    company {
      name
      slug
    }
    id
  }
  newMessageNotification {
    id
    message {
      id
      body
      createdAt
      updatedAt
      user {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
      messageThread {
        slug
        messageThreadType
      }
    }
  }
  newRecruitingMessageNotification {
    company {
      id
      logo
      slug
    }
    id
    message {
      body
      createdAt
      id
      updatedAt
      user {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
      messageThread {
        slug
        messageThreadType
      }
    }
  }
  newUserFollowerNotification {
    id
    user {
      name
      username
      profile {
        avatar
        isJobSeeker
      }
    }
  }
  tokenTransactionNotification {
    id
    tokenTransaction {
      amount
      sender {
        id
        name
        username
        profile {
          avatar
          isJobSeeker
        }
      }
    }
  }
  createdAt
  updatedAt
}
    ${QuestionCategoryFieldsFragmentDocBase}`;
export const OfferFieldsFragmentDocBase = gql`
    fragment offerFields on Offer {
  body
  createdAt
  currencyUnit
  id
  jobCategory {
    ...jobCategoryFields
  }
  jobType
  locations {
    ...locationFields
  }
  salary
  slug
  status
  thumbnail
  title
  updatedAt
  user {
    id
    name
    profile {
      allowMessageRequestsFrom
      avatar
      bio
      isVerifiedAccount
      jobTitle
      isJobSeeker
      jobHuntingStatus
      denyNewContact
      desiredThingsInNextJob
      primaryJobCategory {
        id
        jobCategoryType
        name
        slug
      }
      yearsOfExperience
    }
    status
    username
  }
  workingForm
}
    ${JobCategoryFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}`;
export const BlockchainFieldsFragmentDocBase = gql`
    fragment blockchainFields on Blockchain {
  id
  name
  slug
}
    `;
export const TokenFieldsFragmentDocBase = gql`
    fragment tokenFields on Token {
  id
  logo
  name
  slug
}
    `;
export const ProductFieldsFragmentDocBase = gql`
    fragment productFields on Product {
  blockchains {
    ...blockchainFields
  }
  description
  id
  image
  name
  tokens {
    ...tokenFields
  }
  url
}
    ${BlockchainFieldsFragmentDocBase}
${TokenFieldsFragmentDocBase}`;
export const MinQuestionWithoutAnswersFieldsFragmentDocBase = gql`
    fragment minQuestionWithoutAnswersFields on Question {
  amount
  answersCount
  createdAt
  id
  questionCategory {
    ...questionCategoryFields
  }
  questioner {
    ...minUserWithSolanaAddressFields
  }
  questionType
  slug
  status
  title
  updatedAt
}
    ${QuestionCategoryFieldsFragmentDocBase}
${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const AnswerWithoutChildRepliesFieldsFragmentDocBase = gql`
    fragment answerWithoutChildRepliesFields on Answer {
  amount
  body
  createdAt
  id
  repliesCount
  respondent {
    ...minUserWithSolanaAddressFields
  }
  slug
  status
  updatedAt
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const ChoiceFieldsFragmentDocBase = gql`
    fragment choiceFields on Choice {
  id
  name
  question {
    body
    createdAt
    id
    questionCategory {
      ...questionCategoryFields
    }
    slug
    status
    title
    updatedAt
    questioner {
      ...minUserFields
    }
  }
  votes
}
    ${QuestionCategoryFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const QuestionFieldsFragmentDocBase = gql`
    fragment questionFields on Question {
  amount
  answers(
    after: $afterAnswers
    before: $beforeAnswers
    first: $firstAnswers
    last: $lastAnswers
  ) {
    nodes {
      ...answerWithoutChildRepliesFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
  answersCount
  body
  choices {
    ...choiceFields
  }
  createdAt
  id
  isVotable
  isVotedInBy
  mostVotedChoices {
    ...choiceFields
  }
  ogImage
  pollDeadline
  questionCategory {
    ...questionCategoryFields
  }
  questioner {
    ...minUserWithSolanaAddressFields
  }
  questionType
  slug
  status
  title
  updatedAt
  votesCount
}
    ${AnswerWithoutChildRepliesFieldsFragmentDocBase}
${ChoiceFieldsFragmentDocBase}
${QuestionCategoryFieldsFragmentDocBase}
${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const UserAttachmentFieldsFragmentDocBase = gql`
    fragment userAttachmentFields on UserAttachment {
  categoryName
  description
  file
  filename
  id
  name
  url
}
    `;
export const UserReferenceFieldsFragmentDocBase = gql`
    fragment userReferenceFields on UserReference {
  comment
  commenter {
    ...minUserFields
  }
  id
  status
}
    ${MinUserFieldsFragmentDocBase}`;
export const AddAngelInvestmentInvitationDocument = gql`
    mutation addAngelInvestmentInvitation($input: AddAngelInvestmentInvitationInput!) {
  addAngelInvestmentInvitation(input: $input) {
    url
  }
}
    `;
export const AddAngelInvitationDocument = gql`
    mutation addAngelInvitation($input: AddAngelInvitationInput!) {
  addAngelInvitation(input: $input) {
    url
  }
}
    `;
export const AddCompanyInvestmentDocument = gql`
    mutation addCompanyInvestment($input: AddCompanyInvestmentInput!) {
  addCompanyInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const AddCompanyMemberDocument = gql`
    mutation addCompanyMember($input: AddCompanyMemberInput!) {
  addCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const AddCompanyReferenceDocument = gql`
    mutation addCompanyReference($input: AddCompanyReferenceInput!) {
  addCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const AddExperienceDocument = gql`
    mutation addExperience($input: AddExperienceInput!) {
  addExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const AddFootprintToJobDocument = gql`
    mutation addFootprintToJob($input: AddFootprintToJobInput!) {
  addFootprintToJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const AddInvestorDocument = gql`
    mutation addInvestor($input: AddInvestorInput!) {
  addInvestor(input: $input) {
    company {
      aboutUs
      companyMembers {
        id
        user {
          id
          name
          profile {
            jobTitle
            bio
            avatar
            isJobSeeker
          }
          username
        }
      }
      companySize
      conceptPitch
      denyNewContact
      facebookUrl
      id
      instagramUrl
      isVc
      linkedinUrl
      logo
      name
      slug
      totalFundingAmount
      twitterUrl
      url
    }
    angel {
      id
      name
      status
      username
      profile {
        avatar
        twitterUrl
        isJobSeeker
      }
    }
    companyInvestedFrom {
      name
      logo
      slug
      url
    }
    id
    investedAt
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const AddMemberInvitationDocument = gql`
    mutation addMemberInvitation($input: AddMemberInvitationInput!) {
  addMemberInvitation(input: $input) {
    url
  }
}
    `;
export const AddMyInvestmentDocument = gql`
    mutation addMyInvestment($input: AddMyInvestmentInput!) {
  addMyInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    tokens {
      ...tokenFields
    }
  }
}
    ${TokenFieldsFragmentDocBase}`;
export const AddMyJobBookmarkDocument = gql`
    mutation addMyJobBookmark($input: AddMyJobBookmarkInput!) {
  addMyJobBookmark(input: $input) {
    id
    job {
      ...jobFields
    }
    user {
      ...minUserFields
    }
    createdAt
    updatedAt
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const AddProductDocument = gql`
    mutation addProduct($input: AddProductInput!) {
  addProduct(input: $input) {
    blockchains {
      ...blockchainFields
    }
    description
    id
    image
    name
    tokens {
      ...tokenFields
    }
    url
  }
}
    ${BlockchainFieldsFragmentDocBase}
${TokenFieldsFragmentDocBase}`;
export const AddTokenDocument = gql`
    mutation addToken($input: AddTokenInput!) {
  addToken(input: $input) {
    id
    logo
    name
    slug
  }
}
    `;
export const AddTokenTransactionDocument = gql`
    mutation addTokenTransaction($input: AddTokenTransactionInput!) {
  addTokenTransaction(input: $input) {
    amount
    reciever {
      id
      name
      username
    }
    sender {
      id
      name
      username
    }
    signature
  }
}
    `;
export const AddUserAttachmentDocument = gql`
    mutation addUserAttachment($input: AddUserAttachmentInput!) {
  addUserAttachment(input: $input) {
    ...userAttachmentFields
  }
}
    ${UserAttachmentFieldsFragmentDocBase}`;
export const AddUserInvitationDocument = gql`
    mutation addUserInvitation($input: AddUserInvitationInput!) {
  addUserInvitation(input: $input) {
    url
  }
}
    `;
export const AddUserReferenceDocument = gql`
    mutation addUserReference($input: AddUserReferenceInput!) {
  addUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const AddVcInvestmentInvitationDocument = gql`
    mutation addVcInvestmentInvitation($input: AddVcInvestmentInvitationInput!) {
  addVcInvestmentInvitation(input: $input) {
    url
  }
}
    `;
export const AddVcInvitationDocument = gql`
    mutation addVcInvitation($input: AddVcInvitationInput!) {
  addVcInvitation(input: $input) {
    url
  }
}
    `;
export const ApplyForJobDocument = gql`
    mutation applyForJob($input: ApplyForJobInput!) {
  applyForJob(input: $input) {
    ...minJobApplicationFields
  }
}
    ${MinJobApplicationFieldsFragmentDocBase}`;
export const ChangeSoldOutDocument = gql`
    mutation changeSoldOut($input: ChangeSoldOutInput!) {
  changeSoldOut(input: $input) {
    id
    isSold
    listingAddress
    listingAmount
    listingAddressSol
    listingAmountSol
  }
}
    `;
export const CreateArticleAttachmentDocument = gql`
    mutation createArticleAttachment($input: CreateArticleAttachmentInput!) {
  createArticleAttachment(input: $input) {
    id
    image
  }
}
    `;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
    aboutUs
    companySize
    conceptPitch
    denyNewContact
    facebookUrl
    instagramUrl
    isVc
    linkedinUrl
    logo
    name
    slug
    status
    totalFundingAmount
    twitterUrl
    url
  }
}
    `;
export const CreateCompanyArticleDocument = gql`
    mutation createCompanyArticle($input: CreateCompanyArticleInput!) {
  createCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const CreateJobDocument = gql`
    mutation createJob($input: CreateJobInput!) {
  createJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const CreateJobAttachmentDocument = gql`
    mutation createJobAttachment($input: CreateJobAttachmentInput!) {
  createJobAttachment(input: $input) {
    id
    image
  }
}
    `;
export const CreateMessageThreadDocument = gql`
    mutation createMessageThread($after: String, $before: String, $first: Int, $last: Int, $input: CreateMessageThreadInput!) {
  createMessageThread(input: $input) {
    id
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        body
        createdAt
        id
        updatedAt
        readers {
          id
          name
          profile {
            avatar
            jobTitle
            isJobSeeker
          }
          username
        }
        user {
          id
          name
          profile {
            avatar
            jobTitle
            isJobSeeker
          }
          username
        }
        messageAttachments {
          file
          id
          filename
          mimeType
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    messageThreadType
    name
    slug
    users {
      id
      name
      profile {
        avatar
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const CreateMyAnswerDocument = gql`
    mutation createMyAnswer($input: CreateMyAnswerInput!) {
  createMyAnswer(input: $input) {
    ...answerFields
  }
}
    ${AnswerFieldsFragmentDocBase}`;
export const CreateMyArticleDocument = gql`
    mutation createMyArticle($input: CreateMyArticleInput!) {
  createMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const CreateMyCompanyDocument = gql`
    mutation createMyCompany($input: CreateMyCompanyInput!) {
  createMyCompany(input: $input) {
    aboutUs
    companySize
    companyMembers {
      company {
        aboutUs
        companyMembers {
          id
          invitedByUser {
            ...minUserFields
          }
          role
          user {
            ...minUserFields
          }
        }
        receivedInvestments {
          ...recievedInvestmentFields
        }
        companySize
        conceptPitch
        denyNewContact
        facebookUrl
        id
        instagramUrl
        investmentTargetMarkets {
          ...marketFields
        }
        investmentTargetRounds {
          ...roundFields
        }
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            denyNewContact
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
        }
        isVc
        linkedinUrl
        locations {
          ...locationFields
        }
        logo
        maxInvestmentAmount
        minInvestmentAmount
        name
        round {
          ...roundFields
        }
        products {
          ...productFields
        }
        slug
        status
        totalFundingAmount
        twitterUrl
        url
        markets {
          ...marketFields
        }
      }
      invitedByUser {
        ...minUserFields
      }
      role
    }
    conceptPitch
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    isVc
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      ...roundFields
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      ...marketFields
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${RecievedInvestmentFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}`;
export const CreateMyOfferDocument = gql`
    mutation createMyOffer($input: CreateMyOfferInput!) {
  createMyOffer(input: $input) {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const CreateMyQuestionDocument = gql`
    mutation createMyQuestion($afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $input: CreateMyQuestionInput!) {
  createMyQuestion(input: $input) {
    ...questionFields
  }
}
    ${QuestionFieldsFragmentDocBase}`;
export const CreateMyReplyDocument = gql`
    mutation createMyReply($input: CreateMyReplyInput!) {
  createMyReply(input: $input) {
    ...answerFields
  }
}
    ${AnswerFieldsFragmentDocBase}`;
export const CreateSkillDocument = gql`
    mutation createSkill($input: CreateSkillInput!) {
  createSkill(input: $input) {
    ...skillFields
  }
}
    ${SkillFieldsFragmentDocBase}`;
export const DeleteArticleDocument = gql`
    mutation deleteArticle($input: DeleteArticleInput!) {
  deleteArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const DeleteCompanyArticleDocument = gql`
    mutation deleteCompanyArticle($input: DeleteCompanyArticleInput!) {
  deleteCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const DeleteJobDocument = gql`
    mutation deleteJob($input: DeleteJobInput!) {
  deleteJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const DeleteMyAnswerDocument = gql`
    mutation deleteMyAnswer($input: DeleteMyAnswerInput!) {
  deleteMyAnswer(input: $input) {
    ...answerFields
  }
}
    ${AnswerFieldsFragmentDocBase}`;
export const DeleteMyArticleDocument = gql`
    mutation deleteMyArticle($input: DeleteMyArticleInput!) {
  deleteMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const DeleteMyOfferDocument = gql`
    mutation deleteMyOffer($input: DeleteMyOfferInput!) {
  deleteMyOffer(input: $input) {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const DeleteMyQuestionDocument = gql`
    mutation deleteMyQuestion($afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $input: DeleteMyQuestionInput!) {
  deleteMyQuestion(input: $input) {
    ...questionFields
  }
}
    ${QuestionFieldsFragmentDocBase}`;
export const DeleteUserAttachmentDocument = gql`
    mutation deleteUserAttachment($input: DeleteUserAttachmentInput!) {
  deleteUserAttachment(input: $input) {
    ...userAttachmentFields
  }
}
    ${UserAttachmentFieldsFragmentDocBase}`;
export const DuplicateJobDocument = gql`
    mutation duplicateJob($input: DuplicateJobInput!) {
  duplicateJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const MarkAllMessagesAsReadDocument = gql`
    mutation markAllMessagesAsRead($input: MarkAllMessagesAsReadInput!) {
  markAllMessagesAsRead(input: $input) {
    clientMutationId
  }
}
    `;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
  markNotificationsAsRead(input: $input) {
    clientMutationId
    hasUnreadNotifications
    notifications {
      category
      createdAt
      id
      isRead
      newMessageNotification {
        id
        message {
          body
          createdAt
          id
          updatedAt
          user {
            id
            name
            username
          }
        }
      }
      updatedAt
    }
  }
}
    `;
export const RemoveCompanyMemberDocument = gql`
    mutation removeCompanyMember($input: RemoveCompanyMemberInput!) {
  removeCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const RemoveCompanyReferenceDocument = gql`
    mutation removeCompanyReference($input: RemoveCompanyReferenceInput!) {
  removeCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const RemoveExperienceDocument = gql`
    mutation removeExperience($input: RemoveExperienceInput!) {
  removeExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        bio
        denyNewContact
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      round {
        id
        name
      }
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const RemoveInvestmentDocument = gql`
    mutation removeInvestment($input: RemoveInvestmentInput!) {
  removeInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const RemoveInvestorDocument = gql`
    mutation removeInvestor($input: RemoveInvestorInput!) {
  removeInvestor(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
  }
}
    `;
export const RemoveMyJobBookmarkDocument = gql`
    mutation removeMyJobBookmark($input: RemoveMyJobBookmarkInput!) {
  removeMyJobBookmark(input: $input) {
    id
    job {
      ...jobFields
    }
    user {
      ...minUserFields
    }
    createdAt
    updatedAt
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const RemoveProductDocument = gql`
    mutation removeProduct($input: RemoveProductInput!) {
  removeProduct(input: $input) {
    description
    id
    image
    name
    url
  }
}
    `;
export const RemoveUserReferenceDocument = gql`
    mutation removeUserReference($input: RemoveUserReferenceInput!) {
  removeUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const ToggleArticleLikedStateDocument = gql`
    mutation toggleArticleLikedState($input: ToggleArticleLikedStateInput!) {
  toggleArticleLikedState(input: $input) {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    isLiked
    likedUsersCount
    ogImage
    slug
    status
    thumbnail
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    fundraisingManualFields {
      id
      step
      subcategory
    }
    updatedAt
  }
}
    `;
export const ToggleFollowCompanyDocument = gql`
    mutation toggleFollowCompany($input: ToggleFollowCompanyInput!) {
  toggleFollowCompany(input: $input) {
    slug
    followersCount
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const ToggleFollowUserDocument = gql`
    mutation toggleFollowUser($input: ToggleFollowUserInput!) {
  toggleFollowUser(input: $input) {
    username
    name
    followersCount
    followingCount
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    discordUrl
    facebookUrl
    headerImage
    id
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    markets {
      id
      name
      slug
    }
    maxInvestmentAmount
    minInvestmentAmount
    name
    openseaUrl
    round {
      id
      name
      slug
    }
    slug
    status
    telegramUrl
    totalFundingAmount
    twitterUrl
    url
  }
}
    `;
export const UpdateCompanyArticleDocument = gql`
    mutation updateCompanyArticle($input: UpdateCompanyArticleInput!) {
  updateCompanyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const UpdateCompanyMemberDocument = gql`
    mutation updateCompanyMember($input: UpdateCompanyMemberInput!) {
  updateCompanyMember(input: $input) {
    id
    invitedByUser {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
    role
    user {
      id
      name
      profile {
        avatar
        bio
        jobTitle
        isJobSeeker
      }
      username
    }
  }
}
    `;
export const UpdateCompanyNotificationSettingsDocument = gql`
    mutation updateCompanyNotificationSettings($input: UpdateCompanyNotificationSettingsInput!) {
  updateCompanyNotificationSettings(input: $input) {
    slug
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateCompanyReferenceDocument = gql`
    mutation updateCompanyReference($input: UpdateCompanyReferenceInput!) {
  updateCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const UpdateExperienceDocument = gql`
    mutation updateExperience($input: UpdateExperienceInput!) {
  updateExperience(input: $input) {
    addedByUser {
      name
      profile {
        avatar
        bio
        denyNewContact
        isAngel
        isInvestor
        jobTitle
        isJobSeeker
      }
      username
    }
    company {
      id
      isVc
      logo
      name
      round {
        id
        name
      }
      slug
      status
      url
    }
    current
    description
    endedAt
    id
    startedAt
    status
    title
  }
}
    `;
export const UpdateInvestmentDocument = gql`
    mutation updateInvestment($input: UpdateInvestmentInput!) {
  updateInvestment(input: $input) {
    company {
      aboutUs
      companySize
      conceptPitch
      denyNewContact
      id
      isVc
      logo
      name
      round {
        id
        name
        slug
      }
      slug
      status
      totalFundingAmount
      url
    }
    id
    investedAt
    investorComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
    tokens {
      ...tokenFields
    }
  }
}
    ${TokenFieldsFragmentDocBase}`;
export const UpdateInvestorDocument = gql`
    mutation updateInvestor($input: UpdateInvestorInput!) {
  updateInvestor(input: $input) {
    company {
      aboutUs
      companyMembers {
        id
        user {
          id
          name
          profile {
            jobTitle
            bio
            avatar
            isJobSeeker
          }
          username
        }
      }
      companySize
      conceptPitch
      denyNewContact
      facebookUrl
      id
      instagramUrl
      isVc
      linkedinUrl
      logo
      name
      slug
      totalFundingAmount
      twitterUrl
      url
    }
    id
    investedAt
    startupComment {
      comment
      commenter {
        id
        name
        status
        username
      }
      commenterType
    }
    isLeadInvestor
    referenceUrl
    round {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateJobDocument = gql`
    mutation updateJob($input: UpdateJobInput!) {
  updateJob(input: $input) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateMeInput!) {
  updateMe(input: $input) {
    username
    name
    email
  }
}
    `;
export const UpdateMyAnswerDocument = gql`
    mutation updateMyAnswer($input: UpdateMyAnswerInput!) {
  updateMyAnswer(input: $input) {
    ...answerFields
  }
}
    ${AnswerFieldsFragmentDocBase}`;
export const UpdateMyArticleDocument = gql`
    mutation updateMyArticle($input: UpdateMyArticleInput!) {
  updateMyArticle(input: $input) {
    category {
      id
      name
      slug
    }
    content
    createdAt
    description
    id
    ogImage
    originalArticleUrl
    originalSiteName
    slug
    status
    thumbnail
    title
    topics {
      id
      name
      slug
    }
    updatedAt
    company {
      id
      slug
    }
  }
}
    `;
export const UpdateMyCompanyReferenceDocument = gql`
    mutation updateMyCompanyReference($input: UpdateMyCompanyReferenceInput!) {
  updateMyCompanyReference(input: $input) {
    ...companyReferenceFields
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const UpdateMyOfferDocument = gql`
    mutation updateMyOffer($input: UpdateMyOfferInput!) {
  updateMyOffer(input: $input) {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const UpdateMyProfileDocument = gql`
    mutation updateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    allowMessageRequestsFrom
    avatar
    bio
    birthday
    birthdayAccessScope
    currencyUnit
    delayOfEmailNotificationsForAnswers
    delayOfEmailNotificationsForFollower
    delayOfEmailNotificationsForMessages
    delayOfEmailNotificationsForTokenTransactions
    denyNewContact
    desiredCareerPath
    desiredCommunicationStyle
    desiredDecisionCulture
    desiredEvaluationCulture
    desiredManagementCulture
    desiredThingsInNextJob
    desiredOrientationCulture
    desiredProgressionStyle
    desiredRoleOnTeam
    desiredTakingOnWorkStyle
    desiredTrainingCulture
    desiredWorkStyle
    desiredWorkplaceCulture
    discordUrl
    facebookUrl
    githubUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isAngel
    isCofounderDesired
    isContractorDesired
    isFulltimeEmployeeDesired
    isInternDesired
    isInvestor
    isJobSeeker
    isJobSeekerMailMagazineAccepted
    isVerifiedAccount
    jobCategories {
      id
      jobCategoryType
      name
      slug
    }
    jobHuntingStatus
    jobTitle
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    maxInvestmentAmount
    minInvestmentAmount
    openseaUrl
    primaryJobCategory {
      id
      jobCategoryType
      name
      slug
    }
    receiveEmailNotificationsForAnswers
    receiveEmailNotificationsForFollower
    receiveEmailNotificationsForMessages
    receiveEmailNotificationsForTokenTransactions
    skills {
      id
      name
      slug
    }
    solanaAddress
    telegramUrl
    tokens {
      ...tokenFields
    }
    twitterUrl
    websiteUrl
    yearsOfExperience
  }
}
    ${TokenFieldsFragmentDocBase}`;
export const UpdateMyQuestionDocument = gql`
    mutation updateMyQuestion($afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $input: UpdateMyQuestionInput!) {
  updateMyQuestion(input: $input) {
    ...questionFields
  }
}
    ${QuestionFieldsFragmentDocBase}`;
export const UpdateMyReferenceDocument = gql`
    mutation updateMyReference($input: UpdateMyReferenceInput!) {
  updateMyReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    blockchains {
      ...blockchainFields
    }
    description
    id
    image
    name
    tokens {
      ...tokenFields
    }
    url
  }
}
    ${BlockchainFieldsFragmentDocBase}
${TokenFieldsFragmentDocBase}`;
export const UpdateUserAttachmentDocument = gql`
    mutation updateUserAttachment($input: UpdateUserAttachmentInput!) {
  updateUserAttachment(input: $input) {
    ...userAttachmentFields
  }
}
    ${UserAttachmentFieldsFragmentDocBase}`;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation updateUserNotificationSettings($input: UpdateUserNotificationSettingsInput!) {
  updateUserNotificationSettings(input: $input) {
    name
    username
    notificationSettings {
      id
      name
      slug
    }
  }
}
    `;
export const UpdateUserReferenceDocument = gql`
    mutation updateUserReference($input: UpdateUserReferenceInput!) {
  updateUserReference(input: $input) {
    ...userReferenceFields
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const VoteForChoiceDocument = gql`
    mutation voteForChoice($input: VoteForChoiceInput!) {
  voteForChoice(input: $input) {
    ...choiceFields
  }
}
    ${ChoiceFieldsFragmentDocBase}`;
export const FetchAngelsDocument = gql`
    query fetchAngels($after: String, $before: String, $first: Int, $last: Int, $maxInvestmentAmount: BigInt, $minInvestmentAmount: BigInt, $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $locationIds: [ID!], $currencyUnit: CurrencyUnit, $orderBy: UserOrder, $query: String) {
  angels(
    after: $after
    before: $before
    first: $first
    last: $last
    maxInvestmentAmount: $maxInvestmentAmount
    minInvestmentAmount: $minInvestmentAmount
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    locationIds: $locationIds
    currencyUnit: $currencyUnit
    orderBy: $orderBy
    query: $query
  ) {
    nodes {
      name
      profile {
        avatar
        bio
        denyNewContact
        facebookUrl
        instagramUrl
        isAngel
        isInvestor
        isVerifiedAccount
        jobTitle
        linkedinUrl
        twitterUrl
        currencyUnit
        investmentTargetMarkets {
          id
          name
          slug
        }
        investmentTargetRounds {
          id
          name
          slug
        }
        locations {
          id
          locationType
          name
          shortDescription
          slug
        }
        maxInvestmentAmount
        minInvestmentAmount
        isJobSeeker
        hasInvestmentsWithJobs
      }
      username
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchAnswersDocument = gql`
    query fetchAnswers($afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $slug: ID!) {
  answers(
    after: $afterAnswers
    before: $beforeAnswers
    first: $firstAnswers
    last: $lastAnswers
    slug: $slug
  ) {
    nodes {
      ...answerWithoutChildRepliesFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${AnswerWithoutChildRepliesFieldsFragmentDocBase}`;
export const FetchArticleDocument = gql`
    query fetchArticle($slug: ID!) {
  article(slug: $slug) {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    id
    isLiked
    likedUsersCount
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserWithSolanaAddressFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    fundraisingManualFields {
      id
      step
      subcategory
    }
    updatedAt
  }
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const FetchArticlesDocument = gql`
    query fetchArticles($after: String, $before: String, $first: Int, $last: Int, $categories: [String!]) {
  articles(
    after: $after
    before: $before
    first: $first
    last: $last
    categories: $categories
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      isLiked
      likedUsersCount
      ogImage
      opinionsUser {
        ...minUserWithSolanaAddressFields
      }
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      fundraisingManualFields {
        id
        step
        subcategory
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const FetchBlockchainsDocument = gql`
    query fetchBlockchains($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  blockchains(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      ...blockchainFields
    }
  }
}
    ${BlockchainFieldsFragmentDocBase}`;
export const FetchMessageThreadsDocument = gql`
    query fetchMessageThreads($after: String, $before: String, $first: Int, $last: Int) {
  messageThreads {
    id
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        ...messageFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    messageThreadType
    name
    slug
    users {
      ...minUserFields
    }
    jobApplication {
      ...minJobApplicationFields
    }
  }
}
    ${MessageFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${MinJobApplicationFieldsFragmentDocBase}`;
export const FetchMessageThreadDocument = gql`
    query fetchMessageThread($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  messageThread(slug: $slug) {
    id
    slug
    messages(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        ...messageFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${MessageFieldsFragmentDocBase}`;
export const FetchCompaniesDocument = gql`
    query fetchCompanies($after: String, $before: String, $first: Int, $last: Int, $maxInvestmentAmount: BigInt, $minInvestmentAmount: BigInt, $companySize: CompanySize, $roundIds: [ID!], $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $locationIds: [ID!], $isVc: Boolean, $marketIds: [ID!], $currencyUnit: CurrencyUnit, $orderBy: CompanyOrder, $query: String) {
  companies(
    after: $after
    before: $before
    first: $first
    maxInvestmentAmount: $maxInvestmentAmount
    minInvestmentAmount: $minInvestmentAmount
    companySize: $companySize
    roundIds: $roundIds
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    isVc: $isVc
    last: $last
    locationIds: $locationIds
    marketIds: $marketIds
    currencyUnit: $currencyUnit
    orderBy: $orderBy
    query: $query
  ) {
    nodes {
      id
      aboutUs
      companySize
      conceptPitch
      currencyUnit
      denyNewContact
      facebookUrl
      followersCount
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isVc
      linkedinUrl
      locations {
        ...locationFields
      }
      logo
      maxInvestmentAmount
      minInvestmentAmount
      name
      round {
        ...roundFields
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
      youtubeUrl
      markets {
        ...marketFields
      }
      hasInvestmentsWithJobs
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}`;
export const FetchCompaniesWithJobsDocument = gql`
    query fetchCompaniesWithJobs($after: String, $before: String, $first: Int, $last: Int, $afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int, $angelUsername: ID, $companyLocationIds: [ID!], $companySize: CompanySize, $currencyUnit: CurrencyUnit, $tokenGrant: [Boolean!], $investmentTargetMarketIds: [ID!], $investmentTargetRoundIds: [ID!], $isVc: Boolean, $jobCategoryIds: [ID!], $jobLocationIds: [ID!], $marketIds: [ID!], $maxInvestmentAmount: BigInt, $maxMonthlySalary: BigInt, $minInvestmentAmount: BigInt, $minMonthlySalary: BigInt, $query: String, $roundIds: [ID!], $skillIds: [ID!], $typeOfPosition: [JobTypeOfPosition!], $vcSlug: ID, $workExperience: JobWorkExperience, $workingForm: [JobWorkingForm!]) {
  companiesWithJobs(
    after: $after
    angelUsername: $angelUsername
    before: $before
    companyLocationIds: $companyLocationIds
    companySize: $companySize
    currencyUnit: $currencyUnit
    tokenGrant: $tokenGrant
    first: $first
    investmentTargetMarketIds: $investmentTargetMarketIds
    investmentTargetRoundIds: $investmentTargetRoundIds
    isVc: $isVc
    jobCategoryIds: $jobCategoryIds
    jobLocationIds: $jobLocationIds
    last: $last
    marketIds: $marketIds
    maxInvestmentAmount: $maxInvestmentAmount
    maxMonthlySalary: $maxMonthlySalary
    minInvestmentAmount: $minInvestmentAmount
    minMonthlySalary: $minMonthlySalary
    query: $query
    roundIds: $roundIds
    skillIds: $skillIds
    typeOfPosition: $typeOfPosition
    vcSlug: $vcSlug
    workExperience: $workExperience
    workingForm: $workingForm
  ) {
    nodes {
      id
      aboutUs
      companySize
      conceptPitch
      currencyUnit
      denyNewContact
      facebookUrl
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isVc
      linkedinUrl
      locations {
        ...locationFields
      }
      logo
      maxInvestmentAmount
      minInvestmentAmount
      name
      round {
        ...roundFields
      }
      slug
      status
      totalFundingAmount
      twitterUrl
      url
      youtubeUrl
      markets {
        ...marketFields
      }
      receivedInvestments {
        angel {
          ...minUserFields
        }
        companyInvestedFrom {
          aboutUs
          id
          logo
          name
          slug
          status
        }
        id
      }
      ...highlightedJobListings
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}
${HighlightedJobListingsFragmentDocBase}`;
export const FetchCompanyDocument = gql`
    query fetchCompany($afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int, $afterReferences: String, $beforeReferences: String, $firstReferences: Int, $lastReferences: Int, $slug: ID!) {
  company(slug: $slug) {
    aboutUs
    blockchains {
      id
      name
      slug
    }
    companyMembers {
      id
      user {
        ...minUserFields
        isFollower
      }
    }
    companyReferences(
      after: $afterReferences
      before: $beforeReferences
      first: $firstReferences
      last: $lastReferences
    ) {
      nodes {
        ...companyReferenceFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    discordUrl
    facebookUrl
    followersCount
    headerImage
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    investments {
      company {
        ...minCompanyField
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        ...roundFields
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    isFollowing
    isVc
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    notificationSettings {
      id
      name
      slug
    }
    openseaUrl
    products {
      ...productFields
    }
    round {
      ...roundFields
    }
    slug
    status
    totalFundingAmount
    telegramUrl
    twitterUrl
    url
    youtubeUrl
    markets {
      ...marketFields
    }
    receivedInvestments {
      angel {
        ...minUserFields
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
      }
      id
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    ...companyWithJobs
  }
}
    ${MinUserFieldsFragmentDocBase}
${CompanyReferenceFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${MinCompanyFieldFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}
${CompanyWithJobsFragmentDocBase}`;
export const FetchCompanyArticlesDocument = gql`
    query fetchCompanyArticles($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  companyArticles(
    after: $after
    before: $before
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchCompanyForViewerDocument = gql`
    query fetchCompanyForViewer($slug: ID!) {
  company(slug: $slug) {
    companyMembers {
      id
      user {
        ...minUserFields
        isFollower
      }
    }
    isFollowing
    notificationSettings {
      id
      name
      slug
    }
    slug
  }
}
    ${MinUserFieldsFragmentDocBase}`;
export const FetchCompanyJobsDocument = gql`
    query fetchCompanyJobs($after: String, $before: String, $first: Int, $last: Int, $companySlug: ID!) {
  companyJobs(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    last: $last
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchCountriesDocument = gql`
    query fetchCountries {
  countries {
    ...locationFields
  }
}
    ${LocationFieldsFragmentDocBase}`;
export const FetchFeaturedAngelsDocument = gql`
    query fetchFeaturedAngels {
  featuredAngels {
    name
    profile {
      avatar
      bio
      denyNewContact
      facebookUrl
      instagramUrl
      isAngel
      isInvestor
      isVerifiedAccount
      jobTitle
      linkedinUrl
      twitterUrl
      currencyUnit
      investmentTargetMarkets {
        id
        name
        slug
      }
      investmentTargetRounds {
        id
        name
        slug
      }
      locations {
        id
        locationType
        name
        shortDescription
        slug
      }
      maxInvestmentAmount
      minInvestmentAmount
      isJobSeeker
    }
    username
  }
}
    `;
export const FetchFeaturedCompaniesWithJobsDocument = gql`
    query fetchFeaturedCompaniesWithJobs($afterJobs: String, $beforeJobs: String, $firstJobs: Int, $lastJobs: Int) {
  featuredCompaniesWithJobs {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
    receivedInvestments {
      angel {
        ...minUserFields
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
      }
      id
    }
    ...companyWithJobs
  }
}
    ${MinUserFieldsFragmentDocBase}
${CompanyWithJobsFragmentDocBase}`;
export const FetchFeaturedJobsDocument = gql`
    query fetchFeaturedJobs {
  featuredJobs {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchFeaturedStartupsDocument = gql`
    query fetchFeaturedStartups {
  featuredStartups {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
  }
}
    `;
export const FetchFeaturedStoriesDocument = gql`
    query fetchFeaturedStories {
  featuredStories {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    isLiked
    likedUsersCount
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserWithSolanaAddressFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    updatedAt
  }
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const FetchFeaturedVentureCapitalsDocument = gql`
    query fetchFeaturedVentureCapitals {
  featuredVentureCapitals {
    aboutUs
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    instagramUrl
    investmentTargetMarkets {
      id
      name
      slug
    }
    investmentTargetRounds {
      id
      name
      slug
    }
    isVc
    linkedinUrl
    locations {
      id
      locationType
      name
      shortDescription
      slug
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      id
      name
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    markets {
      id
      name
      slug
    }
  }
}
    `;
export const FetchFollowersDocument = gql`
    query fetchFollowers($after: String, $before: String, $entityType: FollowableEntityEntityType!, $first: Int, $last: Int, $slug: ID!) {
  followers(
    after: $after
    before: $before
    entityType: $entityType
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      isFollowing
      name
      username
      profile {
        avatar
        bio
        isJobSeeker
        isVerifiedAccount
        jobTitle
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchFollowingDocument = gql`
    query fetchFollowing($after: String, $before: String, $first: Int, $last: Int, $username: ID!) {
  following(
    after: $after
    before: $before
    first: $first
    last: $last
    username: $username
  ) {
    nodes {
      category
      description
      entityType
      image
      isFollowing
      isVerifiedAccount
      name
      shortDescription
      slug
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchJobDocument = gql`
    query fetchJob($slug: ID!) {
  job(slug: $slug) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchJobApplicationsDocument = gql`
    query fetchJobApplications($after: String, $before: String, $first: Int, $last: Int, $after1: String, $before1: String, $companySlug: ID!, $first1: Int, $last1: Int) {
  jobApplications(
    after: $after1
    before: $before1
    companySlug: $companySlug
    first: $first1
    last: $last1
  ) {
    nodes {
      id
      job {
        ...jobFields
      }
      messageThread {
        id
        messageThreadType
        messages(after: $after, before: $before, first: $first, last: $last) {
          edges {
            cursor
          }
          nodes {
            ...messageFields
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
        name
        slug
        users {
          ...minUserFields
        }
      }
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}
${MessageFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobBookmarksDocument = gql`
    query fetchJobBookmarks($after: String, $before: String, $companySlug: ID, $first: Int, $jobSlug: ID, $last: Int) {
  jobBookmarks(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    jobSlug: $jobSlug
    last: $last
  ) {
    nodes {
      createdAt
      id
      job {
        body
        createdAt
        currencyUnit
        equityGrant
        id
        jobCategories {
          ...jobCategoryFields
        }
        jobTags {
          ...jobTagFields
        }
        maxMonthlySalary
        minMonthlySalary
        skills {
          ...skillFields
        }
        slug
        status
        thumbnail
        title
        tokenGrant
        typeOfPosition
        updatedAt
        workExperience
        workingForm
      }
      updatedAt
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobCategoriesDocument = gql`
    query fetchJobCategories {
  jobCategories {
    ...jobCategoryFields
  }
}
    ${JobCategoryFieldsFragmentDocBase}`;
export const FetchJobFootprintsDocument = gql`
    query fetchJobFootprints($after: String, $before: String, $companySlug: ID!, $first: Int, $jobSlug: ID, $last: Int) {
  jobFootprints(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    jobSlug: $jobSlug
    last: $last
  ) {
    nodes {
      createdAt
      id
      job {
        createdAt
        id
        slug
        status
        thumbnail
        title
        typeOfPosition
        updatedAt
        body
        currencyUnit
        workExperience
        workingForm
        equityGrant
        tokenGrant
        maxMonthlySalary
        minMonthlySalary
        jobCategories {
          ...jobCategoryFields
        }
        jobTags {
          ...jobTagFields
        }
        skills {
          ...skillFields
        }
      }
      referer
      user {
        ...minUserFields
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobCategoryFieldsFragmentDocBase}
${JobTagFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchJobSeekersDocument = gql`
    query fetchJobSeekers($after: String, $before: String, $first: Int, $jobHuntingStatus: [UserProfileJobHuntingStatus!], $primaryJobCategoryIds: [ID!], $query: String, $yearsOfExperience: [UserProfileYearsOfExperience!]) {
  jobSeekers(
    after: $after
    before: $before
    first: $first
    jobHuntingStatus: $jobHuntingStatus
    primaryJobCategoryIds: $primaryJobCategoryIds
    query: $query
    yearsOfExperience: $yearsOfExperience
  ) {
    nodes {
      id
      name
      profile {
        avatar
        bio
        isJobSeeker
        isVerifiedAccount
        jobHuntingStatus
        primaryJobCategory {
          id
          jobCategoryType
          name
          slug
        }
        yearsOfExperience
      }
      username
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchJobTagsDocument = gql`
    query fetchJobTags {
  jobTags {
    ...jobTagFields
  }
}
    ${JobTagFieldsFragmentDocBase}`;
export const FetchJobsDocument = gql`
    query fetchJobs($after: String, $before: String, $first: Int, $last: Int, $currencyUnit: CurrencyUnit, $tokenGrant: [Boolean!], $jobCategoryIds: [ID!], $locationIds: [ID!], $maxMonthlySalary: BigInt, $minMonthlySalary: BigInt, $query: String, $skillIds: [ID!], $typeOfPosition: [JobTypeOfPosition!], $workExperience: JobWorkExperience, $workingForm: [JobWorkingForm!]) {
  jobs(
    after: $after
    before: $before
    currencyUnit: $currencyUnit
    tokenGrant: $tokenGrant
    first: $first
    jobCategoryIds: $jobCategoryIds
    last: $last
    locationIds: $locationIds
    maxMonthlySalary: $maxMonthlySalary
    minMonthlySalary: $minMonthlySalary
    query: $query
    skillIds: $skillIds
    typeOfPosition: $typeOfPosition
    workExperience: $workExperience
    workingForm: $workingForm
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchLocationsDocument = gql`
    query fetchLocations($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  locations(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      id
      locationType
      name
      shortDescription
      slug
    }
  }
}
    `;
export const FetchMarketsDocument = gql`
    query fetchMarkets {
  markets {
    id
    name
    slug
  }
}
    `;
export const FetchMeDocument = gql`
    query fetchMe($articlesAfter: String, $articlesBefore: String, $articlesFirst: Int, $articlesLast: Int, $notificationsAfter: String, $notificationsBefore: String, $notificationsFirst: Int, $notificationsLast: Int) {
  me {
    id
    companyMembers {
      company {
        aboutUs
        articles(
          after: $articlesAfter
          before: $articlesBefore
          first: $articlesFirst
          last: $articlesLast
        ) {
          edges {
            cursor
          }
          nodes {
            content
            createdAt
            description
            id
            ogImage
            originalArticleUrl
            originalSiteName
            slug
            status
            thumbnail
            title
            updatedAt
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
        companyMembers {
          id
          invitedByUser {
            ...minUserFields
          }
          role
          user {
            ...minUserFields
          }
        }
        receivedInvestments {
          ...recievedInvestmentFields
        }
        companySize
        conceptPitch
        currencyUnit
        denyNewContact
        discordUrl
        facebookUrl
        headerImage
        id
        instagramUrl
        investmentTargetMarkets {
          ...marketFields
        }
        investmentTargetRounds {
          ...roundFields
        }
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
          investorComment {
            comment
            commenter {
              id
              name
              status
              username
            }
            commenterType
          }
        }
        isVc
        jobApplicationsCount
        jobBookmarksCount
        jobFootprintsCount
        linkedinUrl
        locations {
          ...locationFields
        }
        logo
        maxInvestmentAmount
        minInvestmentAmount
        name
        openseaUrl
        round {
          ...roundFields
        }
        products {
          ...productFields
        }
        slug
        status
        telegramUrl
        totalFundingAmount
        twitterUrl
        url
        youtubeUrl
        markets {
          ...marketFields
        }
      }
      invitedByUser {
        ...minUserFields
      }
      role
      id
    }
    email
    experiences {
      addedByUser {
        id
        name
        profile {
          avatar
          isJobSeeker
        }
        username
      }
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      current
      description
      endedAt
      id
      startedAt
      status
      title
    }
    id
    investments {
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        name
        slug
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      tokens {
        ...tokenFields
      }
    }
    invitationOf
    isFirstSignIn
    name
    profile {
      allowMessageRequestsFrom
      avatar
      bio
      birthday
      birthdayAccessScope
      currencyUnit
      delayOfEmailNotificationsForAnswers
      delayOfEmailNotificationsForMessages
      delayOfEmailNotificationsForFollower
      delayOfEmailNotificationsForTokenTransactions
      denyNewContact
      desiredCareerPath
      desiredCommunicationStyle
      desiredDecisionCulture
      desiredEvaluationCulture
      desiredManagementCulture
      desiredThingsInNextJob
      desiredOrientationCulture
      desiredProgressionStyle
      desiredRoleOnTeam
      desiredTakingOnWorkStyle
      desiredTrainingCulture
      desiredWorkStyle
      desiredWorkplaceCulture
      discordUrl
      facebookUrl
      githubUrl
      headerImage
      instagramUrl
      investmentTargetMarkets {
        ...marketFields
      }
      investmentTargetRounds {
        ...roundFields
      }
      isAngel
      isCofounderDesired
      isContractorDesired
      isFulltimeEmployeeDesired
      isInternDesired
      isInvestor
      isJobSeeker
      isJobSeekerMailMagazineAccepted
      isVerifiedAccount
      jobCategories {
        ...jobCategoryFields
      }
      jobHuntingStatus
      jobTitle
      linkedinUrl
      locations {
        ...locationFields
      }
      maxInvestmentAmount
      minInvestmentAmount
      openseaUrl
      primaryJobCategory {
        ...jobCategoryFields
      }
      receiveEmailNotificationsForAnswers
      receiveEmailNotificationsForMessages
      receiveEmailNotificationsForFollower
      receiveEmailNotificationsForTokenTransactions
      skills {
        ...skillFields
      }
      solanaAddress
      telegramUrl
      tokens {
        ...tokenFields
      }
      twitterUrl
      websiteUrl
      yearsOfExperience
    }
    userAttachments {
      ...userAttachmentFields
    }
    username
    hasUnreadNotifications
    notifications(
      after: $notificationsAfter
      before: $notificationsBefore
      first: $notificationsFirst
      last: $notificationsLast
    ) {
      edges {
        cursor
      }
      nodes {
        ...notificationFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${RecievedInvestmentFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}
${TokenFieldsFragmentDocBase}
${JobCategoryFieldsFragmentDocBase}
${SkillFieldsFragmentDocBase}
${UserAttachmentFieldsFragmentDocBase}
${NotificationFieldsFragmentDocBase}`;
export const FetchMyArticlesDocument = gql`
    query fetchMyArticles($after: String, $before: String, $first: Int, $last: Int) {
  myArticles(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchMyCompanyDocument = gql`
    query fetchMyCompany($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompany(slug: $slug) {
    aboutUs
    articles(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        content
        createdAt
        description
        id
        ogImage
        originalArticleUrl
        originalSiteName
        slug
        status
        thumbnail
        title
        updatedAt
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    companyMembers {
      id
      invitedByUser {
        ...minUserFields
      }
      role
      user {
        ...minUserFields
      }
    }
    receivedInvestments {
      angel {
        id
        name
        profile {
          bio
          avatar
          isVerifiedAccount
          twitterUrl
          isJobSeeker
        }
        username
      }
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      companyInvestedFrom {
        aboutUs
        id
        logo
        name
        slug
        status
        investments {
          id
          company {
            aboutUs
            companySize
            conceptPitch
            id
            isVc
            logo
            name
            slug
            status
            totalFundingAmount
            url
          }
          investedAt
          isLeadInvestor
          referenceUrl
          round {
            id
            slug
            name
          }
          investorComment {
            comment
            commenter {
              id
              name
              status
              username
            }
            commenterType
          }
        }
      }
      id
      investedAt
      isLeadInvestor
      referenceUrl
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    companySize
    conceptPitch
    currencyUnit
    denyNewContact
    facebookUrl
    id
    instagramUrl
    investmentTargetMarkets {
      ...marketFields
    }
    investmentTargetRounds {
      ...roundFields
    }
    investments {
      id
      company {
        aboutUs
        companySize
        conceptPitch
        id
        isVc
        logo
        name
        slug
        status
        totalFundingAmount
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      round {
        id
        slug
        name
      }
      investorComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
    }
    isVc
    jobApplicationsCount
    jobBookmarksCount
    jobFootprintsCount
    linkedinUrl
    locations {
      ...locationFields
    }
    logo
    maxInvestmentAmount
    minInvestmentAmount
    name
    round {
      ...roundFields
    }
    products {
      ...productFields
    }
    slug
    status
    totalFundingAmount
    twitterUrl
    url
    youtubeUrl
    markets {
      ...marketFields
    }
  }
}
    ${MinUserFieldsFragmentDocBase}
${MarketFieldsFragmentDocBase}
${RoundFieldsFragmentDocBase}
${LocationFieldsFragmentDocBase}
${ProductFieldsFragmentDocBase}`;
export const FetchMyCompanyArticlesDocument = gql`
    query fetchMyCompanyArticles($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompany(slug: $slug) {
    articles(after: $after, before: $before, first: $first, last: $last) {
      edges {
        cursor
      }
      nodes {
        content
        createdAt
        description
        id
        ogImage
        originalArticleUrl
        originalSiteName
        slug
        status
        thumbnail
        title
        updatedAt
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    `;
export const FetchMyCompanyReferencesDocument = gql`
    query fetchMyCompanyReferences($after: String, $before: String, $first: Int, $last: Int, $slug: ID!) {
  myCompanyReferences(
    after: $after
    before: $before
    first: $first
    last: $last
    slug: $slug
  ) {
    nodes {
      ...companyReferenceFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CompanyReferenceFieldsFragmentDocBase}`;
export const FetchMyJobBookmarksDocument = gql`
    query fetchMyJobBookmarks($after: String, $before: String, $first: Int, $last: Int) {
  myJobBookmarks(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      id
      job {
        ...jobFields
      }
      user {
        ...minUserFields
      }
      createdAt
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}
${MinUserFieldsFragmentDocBase}`;
export const FetchMyJobsDocument = gql`
    query fetchMyJobs($after: String, $before: String, $first: Int, $last: Int, $companySlug: ID!) {
  myJobs(
    after: $after
    before: $before
    companySlug: $companySlug
    first: $first
    last: $last
  ) {
    nodes {
      ...jobFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${JobFieldsFragmentDocBase}`;
export const FetchMyOffersDocument = gql`
    query fetchMyOffers($after: String, $before: String, $first: Int, $last: Int) {
  myOffers(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      ...offerFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const FetchMyReferencesDocument = gql`
    query fetchMyReferences($after: String, $before: String, $first: Int, $last: Int) {
  myReferences(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      ...userReferenceFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${UserReferenceFieldsFragmentDocBase}`;
export const FetchNftDocument = gql`
    query fetchNft($mintAddress: String!) {
  nft(mintAddress: $mintAddress) {
    description
    id
    image
    listing {
      id
      isSold
      listingAddress
      listingAmount
      listingAddressSol
      listingAmountSol
    }
    mintAddress
    name
    nftAttributes {
      nftAttributeTrait {
        traitType
      }
      value
    }
  }
}
    `;
export const FetchNftsDocument = gql`
    query fetchNfts($after: String, $before: String, $first: Int, $last: Int) {
  nfts(after: $after, before: $before, first: $first, last: $last) {
    nodes {
      image
      listing {
        isSold
        listingAddress
        listingAmount
        listingAddressSol
        listingAmountSol
      }
      mintAddress
      name
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchNftsCountDocument = gql`
    query fetchNftsCount {
  nftsCount {
    count
  }
}
    `;
export const FetchNotificationsDocument = gql`
    query fetchNotifications($after: String, $before: String, $first: Int, $last: Int) {
  me {
    email
    name
    username
    notifications(after: $after, before: $before, first: $first, last: $last) {
      nodes {
        ...notificationFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${NotificationFieldsFragmentDocBase}`;
export const FetchOfferDocument = gql`
    query fetchOffer($slug: ID!) {
  offer(slug: $slug) {
    ...offerFields
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const FetchOffersDocument = gql`
    query fetchOffers($after: String, $before: String, $first: Int, $last: Int, $currencyUnit: CurrencyUnit, $jobCategoryIds: [ID!], $locationIds: [ID!], $salary: BigInt, $query: String, $jobType: [OfferJobType!], $workingForm: [OfferWorkingForm!]) {
  offers(
    after: $after
    before: $before
    currencyUnit: $currencyUnit
    first: $first
    jobCategoryIds: $jobCategoryIds
    last: $last
    locationIds: $locationIds
    salary: $salary
    query: $query
    jobType: $jobType
    workingForm: $workingForm
  ) {
    nodes {
      ...offerFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const FetchPickedUpFeaturesDocument = gql`
    query fetchPickedUpFeatures {
  pickedUpFeatures {
    category {
      id
      name
      slug
    }
    company {
      id
      logo
      name
      slug
    }
    content
    createdAt
    description
    ogImage
    slug
    status
    thumbnail
    opinionsUser {
      ...minUserWithSolanaAddressFields
    }
    originalArticleUrl
    originalSiteName
    title
    topics {
      id
      name
      slug
    }
    updatedAt
  }
}
    ${MinUserWithSolanaAddressFieldsFragmentDocBase}`;
export const FetchQuestionDocument = gql`
    query fetchQuestion($afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $slug: ID!) {
  question(slug: $slug) {
    ...questionFields
  }
}
    ${QuestionFieldsFragmentDocBase}`;
export const FetchQuestionCategoriesDocument = gql`
    query fetchQuestionCategories {
  questionCategories {
    ...questionCategoryFields
  }
}
    ${QuestionCategoryFieldsFragmentDocBase}`;
export const FetchQuestionsDocument = gql`
    query fetchQuestions($after: String, $before: String, $first: Int, $last: Int, $orderBy: QuestionOrder, $questionCategories: [String!], $query: String) {
  questions(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    questionCategories: $questionCategories
    query: $query
  ) {
    nodes {
      ...minQuestionWithoutAnswersFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinQuestionWithoutAnswersFieldsFragmentDocBase}`;
export const FetchReplyDocument = gql`
    query fetchReply($id: ID!) {
  reply(id: $id) {
    ...answerFields
  }
}
    ${AnswerFieldsFragmentDocBase}`;
export const FetchSkillsDocument = gql`
    query fetchSkills($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  skills(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      ...skillFields
    }
  }
}
    ${SkillFieldsFragmentDocBase}`;
export const FetchTokensDocument = gql`
    query fetchTokens($after: String, $before: String, $first: Int, $last: Int, $query: String) {
  tokens(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      ...tokenFields
    }
  }
}
    ${TokenFieldsFragmentDocBase}`;
export const FetchUserDocument = gql`
    query fetchUser($afterQuestions: String, $beforeQuestions: String, $firstQuestions: Int, $lastQuestions: Int, $afterReferences: String, $beforeReferences: String, $firstReferences: Int, $lastReferences: Int, $afterAnswers: String, $beforeAnswers: String, $firstAnswers: Int, $lastAnswers: Int, $username: ID!) {
  user(username: $username) {
    experiences {
      addedByUser {
        id
        name
        profile {
          avatar
          isJobSeeker
        }
        username
      }
      company {
        id
        isVc
        logo
        name
        slug
        status
        url
      }
      current
      description
      endedAt
      id
      startedAt
      status
      title
    }
    followersCount
    followingCount
    id
    investments {
      id
      company {
        isVc
        logo
        name
        slug
        status
        url
      }
      investedAt
      isLeadInvestor
      referenceUrl
      startupComment {
        comment
        commenter {
          id
          name
          status
          username
        }
        commenterType
      }
      tokens {
        ...tokenFields
      }
    }
    isFollower
    isFollowing
    name
    notificationSettings {
      id
      name
      slug
    }
    profile {
      allowMessageRequestsFrom
      avatar
      bio
      birthday
      birthdayAccessScope
      currencyUnit
      denyNewContact
      desiredCareerPath
      desiredCommunicationStyle
      desiredDecisionCulture
      desiredEvaluationCulture
      desiredManagementCulture
      desiredThingsInNextJob
      desiredOrientationCulture
      desiredProgressionStyle
      desiredRoleOnTeam
      desiredTakingOnWorkStyle
      desiredTrainingCulture
      desiredWorkStyle
      desiredWorkplaceCulture
      discordUrl
      facebookUrl
      githubUrl
      headerImage
      instagramUrl
      investmentTargetMarkets {
        id
        name
        slug
      }
      investmentTargetRounds {
        id
        name
        slug
      }
      isAngel
      isCofounderDesired
      isContractorDesired
      isFulltimeEmployeeDesired
      isInternDesired
      isInvestor
      isJobSeeker
      isJobSeekerMailMagazineAccepted
      isVerifiedAccount
      jobCategories {
        id
        jobCategoryType
        name
        slug
      }
      jobHuntingStatus
      jobTitle
      linkedinUrl
      locations {
        id
        locationType
        name
        shortDescription
        slug
      }
      maxInvestmentAmount
      minInvestmentAmount
      openseaUrl
      primaryJobCategory {
        id
        jobCategoryType
        name
        slug
      }
      skills {
        id
        name
        slug
      }
      solanaAddress
      telegramUrl
      tokens {
        ...tokenFields
      }
      twitterUrl
      websiteUrl
      yearsOfExperience
    }
    questions(
      after: $afterQuestions
      before: $beforeQuestions
      first: $firstQuestions
      last: $lastQuestions
    ) {
      nodes {
        ...minQuestionWithoutAnswersFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    userAttachments {
      ...userAttachmentFields
    }
    username
    userReferences(
      after: $afterReferences
      before: $beforeReferences
      first: $firstReferences
      last: $lastReferences
    ) {
      nodes {
        ...userReferenceFields
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${TokenFieldsFragmentDocBase}
${MinQuestionWithoutAnswersFieldsFragmentDocBase}
${UserAttachmentFieldsFragmentDocBase}
${UserReferenceFieldsFragmentDocBase}`;
export const FetchUserArticlesDocument = gql`
    query fetchUserArticles($after: String, $before: String, $first: Int, $last: Int, $username: ID) {
  userArticles(
    after: $after
    before: $before
    first: $first
    last: $last
    username: $username
  ) {
    nodes {
      category {
        id
        name
        slug
      }
      company {
        id
        logo
        name
        slug
      }
      content
      createdAt
      description
      id
      ogImage
      originalArticleUrl
      originalSiteName
      slug
      status
      thumbnail
      title
      topics {
        id
        name
        slug
      }
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const FetchUserForViewerDocument = gql`
    query fetchUserForViewer($username: ID!) {
  user(username: $username) {
    isFollower
    isFollowing
    name
    notificationSettings {
      id
      name
      slug
    }
    username
  }
}
    `;
export const FetchUserOffersDocument = gql`
    query fetchUserOffers($after: String, $before: String, $first: Int, $last: Int, $username: ID!) {
  userOffers(
    after: $after
    before: $before
    username: $username
    first: $first
    last: $last
  ) {
    nodes {
      ...offerFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${OfferFieldsFragmentDocBase}`;
export const FetchUserQuestionsDocument = gql`
    query fetchUserQuestions($after: String, $before: String, $first: Int, $last: Int, $username: ID) {
  userQuestions(
    after: $after
    before: $before
    first: $first
    last: $last
    username: $username
  ) {
    nodes {
      ...minQuestionWithoutAnswersFields
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${MinQuestionWithoutAnswersFieldsFragmentDocBase}`;
export const SearchCompanyDocument = gql`
    query searchCompany($after: String, $before: String, $first: Int, $last: Int, $query: String!) {
  searchCompany(
    after: $after
    before: $before
    first: $first
    last: $last
    query: $query
  ) {
    nodes {
      id
      logo
      name
      slug
      url
    }
  }
}
    `;
export const SearchUserDocument = gql`
    query searchUser($query: String!) {
  searchUser(query: $query) {
    edges {
      cursor
    }
    nodes {
      id
      name
      profile {
        avatar
        bio
        denyNewContact
        facebookUrl
        instagramUrl
        isAngel
        isInvestor
        isVerifiedAccount
        jobTitle
        linkedinUrl
        twitterUrl
        currencyUnit
        investmentTargetMarkets {
          id
          name
          slug
        }
        investmentTargetRounds {
          id
          name
          slug
        }
        locations {
          id
          locationType
          name
          shortDescription
          slug
        }
        maxInvestmentAmount
        minInvestmentAmount
        isJobSeeker
      }
      username
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;
export const ValidInvitationTokenDocument = gql`
    query validInvitationToken($token: String!) {
  validInvitationToken(token: $token) {
    invitationOf
    isValid
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addAngelInvestmentInvitation(variables: AddAngelInvestmentInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddAngelInvestmentInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAngelInvestmentInvitationMutation>(AddAngelInvestmentInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addAngelInvestmentInvitation');
    },
    addAngelInvitation(variables: AddAngelInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddAngelInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAngelInvitationMutation>(AddAngelInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addAngelInvitation');
    },
    addCompanyInvestment(variables: AddCompanyInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyInvestmentMutation>(AddCompanyInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyInvestment');
    },
    addCompanyMember(variables: AddCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyMemberMutation>(AddCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyMember');
    },
    addCompanyReference(variables: AddCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCompanyReferenceMutation>(AddCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCompanyReference');
    },
    addExperience(variables: AddExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddExperienceMutation>(AddExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addExperience');
    },
    addFootprintToJob(variables: AddFootprintToJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddFootprintToJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddFootprintToJobMutation>(AddFootprintToJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addFootprintToJob');
    },
    addInvestor(variables: AddInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddInvestorMutation>(AddInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addInvestor');
    },
    addMemberInvitation(variables: AddMemberInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMemberInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMemberInvitationMutation>(AddMemberInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMemberInvitation');
    },
    addMyInvestment(variables: AddMyInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMyInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMyInvestmentMutation>(AddMyInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMyInvestment');
    },
    addMyJobBookmark(variables: AddMyJobBookmarkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddMyJobBookmarkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddMyJobBookmarkMutation>(AddMyJobBookmarkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addMyJobBookmark');
    },
    addProduct(variables: AddProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddProductMutation>(AddProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addProduct');
    },
    addToken(variables: AddTokenMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddTokenMutation>(AddTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addToken');
    },
    addTokenTransaction(variables: AddTokenTransactionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddTokenTransactionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddTokenTransactionMutation>(AddTokenTransactionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addTokenTransaction');
    },
    addUserAttachment(variables: AddUserAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUserAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserAttachmentMutation>(AddUserAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserAttachment');
    },
    addUserInvitation(variables: AddUserInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUserInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserInvitationMutation>(AddUserInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserInvitation');
    },
    addUserReference(variables: AddUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserReferenceMutation>(AddUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserReference');
    },
    addVcInvestmentInvitation(variables: AddVcInvestmentInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVcInvestmentInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVcInvestmentInvitationMutation>(AddVcInvestmentInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVcInvestmentInvitation');
    },
    addVcInvitation(variables: AddVcInvitationMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddVcInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddVcInvitationMutation>(AddVcInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addVcInvitation');
    },
    applyForJob(variables: ApplyForJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ApplyForJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyForJobMutation>(ApplyForJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyForJob');
    },
    changeSoldOut(variables: ChangeSoldOutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ChangeSoldOutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangeSoldOutMutation>(ChangeSoldOutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'changeSoldOut');
    },
    createArticleAttachment(variables: CreateArticleAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateArticleAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateArticleAttachmentMutation>(CreateArticleAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createArticleAttachment');
    },
    createCompany(variables: CreateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyMutation>(CreateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompany');
    },
    createCompanyArticle(variables: CreateCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCompanyArticleMutation>(CreateCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCompanyArticle');
    },
    createJob(variables: CreateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobMutation>(CreateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJob');
    },
    createJobAttachment(variables: CreateJobAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateJobAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateJobAttachmentMutation>(CreateJobAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createJobAttachment');
    },
    createMessageThread(variables: CreateMessageThreadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMessageThreadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMessageThreadMutation>(CreateMessageThreadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMessageThread');
    },
    createMyAnswer(variables: CreateMyAnswerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyAnswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyAnswerMutation>(CreateMyAnswerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyAnswer');
    },
    createMyArticle(variables: CreateMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyArticleMutation>(CreateMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyArticle');
    },
    createMyCompany(variables: CreateMyCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyCompanyMutation>(CreateMyCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyCompany');
    },
    createMyOffer(variables: CreateMyOfferMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyOfferMutation>(CreateMyOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyOffer');
    },
    createMyQuestion(variables: CreateMyQuestionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyQuestionMutation>(CreateMyQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyQuestion');
    },
    createMyReply(variables: CreateMyReplyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateMyReplyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMyReplyMutation>(CreateMyReplyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMyReply');
    },
    createSkill(variables: CreateSkillMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSkillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSkillMutation>(CreateSkillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSkill');
    },
    deleteArticle(variables: DeleteArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteArticleMutation>(DeleteArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteArticle');
    },
    deleteCompanyArticle(variables: DeleteCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCompanyArticleMutation>(DeleteCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCompanyArticle');
    },
    deleteJob(variables: DeleteJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteJobMutation>(DeleteJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteJob');
    },
    deleteMyAnswer(variables: DeleteMyAnswerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMyAnswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMyAnswerMutation>(DeleteMyAnswerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMyAnswer');
    },
    deleteMyArticle(variables: DeleteMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMyArticleMutation>(DeleteMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMyArticle');
    },
    deleteMyOffer(variables: DeleteMyOfferMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMyOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMyOfferMutation>(DeleteMyOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMyOffer');
    },
    deleteMyQuestion(variables: DeleteMyQuestionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteMyQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMyQuestionMutation>(DeleteMyQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMyQuestion');
    },
    deleteUserAttachment(variables: DeleteUserAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteUserAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserAttachmentMutation>(DeleteUserAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUserAttachment');
    },
    duplicateJob(variables: DuplicateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DuplicateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateJobMutation>(DuplicateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateJob');
    },
    markAllMessagesAsRead(variables: MarkAllMessagesAsReadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MarkAllMessagesAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllMessagesAsReadMutation>(MarkAllMessagesAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAllMessagesAsRead');
    },
    markNotificationsAsRead(variables: MarkNotificationsAsReadMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MarkNotificationsAsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationsAsReadMutation>(MarkNotificationsAsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markNotificationsAsRead');
    },
    removeCompanyMember(variables: RemoveCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCompanyMemberMutation>(RemoveCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCompanyMember');
    },
    removeCompanyReference(variables: RemoveCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCompanyReferenceMutation>(RemoveCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCompanyReference');
    },
    removeExperience(variables: RemoveExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveExperienceMutation>(RemoveExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeExperience');
    },
    removeInvestment(variables: RemoveInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvestmentMutation>(RemoveInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvestment');
    },
    removeInvestor(variables: RemoveInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvestorMutation>(RemoveInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvestor');
    },
    removeMyJobBookmark(variables: RemoveMyJobBookmarkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveMyJobBookmarkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMyJobBookmarkMutation>(RemoveMyJobBookmarkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeMyJobBookmark');
    },
    removeProduct(variables: RemoveProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveProductMutation>(RemoveProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeProduct');
    },
    removeUserReference(variables: RemoveUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<RemoveUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserReferenceMutation>(RemoveUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserReference');
    },
    toggleArticleLikedState(variables: ToggleArticleLikedStateMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleArticleLikedStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleArticleLikedStateMutation>(ToggleArticleLikedStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleArticleLikedState');
    },
    toggleFollowCompany(variables: ToggleFollowCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleFollowCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleFollowCompanyMutation>(ToggleFollowCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleFollowCompany');
    },
    toggleFollowUser(variables: ToggleFollowUserMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ToggleFollowUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ToggleFollowUserMutation>(ToggleFollowUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'toggleFollowUser');
    },
    updateCompany(variables: UpdateCompanyMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMutation>(UpdateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompany');
    },
    updateCompanyArticle(variables: UpdateCompanyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyArticleMutation>(UpdateCompanyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyArticle');
    },
    updateCompanyMember(variables: UpdateCompanyMemberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMemberMutation>(UpdateCompanyMemberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyMember');
    },
    updateCompanyNotificationSettings(variables: UpdateCompanyNotificationSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyNotificationSettingsMutation>(UpdateCompanyNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyNotificationSettings');
    },
    updateCompanyReference(variables: UpdateCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyReferenceMutation>(UpdateCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompanyReference');
    },
    updateExperience(variables: UpdateExperienceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateExperienceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateExperienceMutation>(UpdateExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateExperience');
    },
    updateInvestment(variables: UpdateInvestmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestmentMutation>(UpdateInvestmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestment');
    },
    updateInvestor(variables: UpdateInvestorMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateInvestorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvestorMutation>(UpdateInvestorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvestor');
    },
    updateJob(variables: UpdateJobMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateJobMutation>(UpdateJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateJob');
    },
    updateMe(variables: UpdateMeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMeMutation>(UpdateMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMe');
    },
    updateMyAnswer(variables: UpdateMyAnswerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyAnswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyAnswerMutation>(UpdateMyAnswerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyAnswer');
    },
    updateMyArticle(variables: UpdateMyArticleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyArticleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyArticleMutation>(UpdateMyArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyArticle');
    },
    updateMyCompanyReference(variables: UpdateMyCompanyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyCompanyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyCompanyReferenceMutation>(UpdateMyCompanyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyCompanyReference');
    },
    updateMyOffer(variables: UpdateMyOfferMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyOfferMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyOfferMutation>(UpdateMyOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyOffer');
    },
    updateMyProfile(variables: UpdateMyProfileMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyProfileMutation>(UpdateMyProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyProfile');
    },
    updateMyQuestion(variables: UpdateMyQuestionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyQuestionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyQuestionMutation>(UpdateMyQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyQuestion');
    },
    updateMyReference(variables: UpdateMyReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateMyReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMyReferenceMutation>(UpdateMyReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMyReference');
    },
    updateProduct(variables: UpdateProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductMutation>(UpdateProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProduct');
    },
    updateUserAttachment(variables: UpdateUserAttachmentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserAttachmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserAttachmentMutation>(UpdateUserAttachmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserAttachment');
    },
    updateUserNotificationSettings(variables: UpdateUserNotificationSettingsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserNotificationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserNotificationSettingsMutation>(UpdateUserNotificationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserNotificationSettings');
    },
    updateUserReference(variables: UpdateUserReferenceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUserReferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserReferenceMutation>(UpdateUserReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserReference');
    },
    voteForChoice(variables: VoteForChoiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<VoteForChoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VoteForChoiceMutation>(VoteForChoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'voteForChoice');
    },
    fetchAngels(variables?: FetchAngelsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchAngelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchAngelsQuery>(FetchAngelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchAngels');
    },
    fetchAnswers(variables: FetchAnswersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchAnswersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchAnswersQuery>(FetchAnswersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchAnswers');
    },
    fetchArticle(variables: FetchArticleQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchArticleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchArticleQuery>(FetchArticleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchArticle');
    },
    fetchArticles(variables?: FetchArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchArticlesQuery>(FetchArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchArticles');
    },
    fetchBlockchains(variables?: FetchBlockchainsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchBlockchainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchBlockchainsQuery>(FetchBlockchainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchBlockchains');
    },
    fetchMessageThreads(variables?: FetchMessageThreadsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMessageThreadsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMessageThreadsQuery>(FetchMessageThreadsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMessageThreads');
    },
    fetchMessageThread(variables: FetchMessageThreadQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMessageThreadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMessageThreadQuery>(FetchMessageThreadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMessageThread');
    },
    fetchCompanies(variables?: FetchCompaniesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompaniesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompaniesQuery>(FetchCompaniesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanies');
    },
    fetchCompaniesWithJobs(variables?: FetchCompaniesWithJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompaniesWithJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompaniesWithJobsQuery>(FetchCompaniesWithJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompaniesWithJobs');
    },
    fetchCompany(variables: FetchCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyQuery>(FetchCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompany');
    },
    fetchCompanyArticles(variables: FetchCompanyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyArticlesQuery>(FetchCompanyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyArticles');
    },
    fetchCompanyForViewer(variables: FetchCompanyForViewerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyForViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyForViewerQuery>(FetchCompanyForViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyForViewer');
    },
    fetchCompanyJobs(variables: FetchCompanyJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCompanyJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCompanyJobsQuery>(FetchCompanyJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCompanyJobs');
    },
    fetchCountries(variables?: FetchCountriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchCountriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchCountriesQuery>(FetchCountriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchCountries');
    },
    fetchFeaturedAngels(variables?: FetchFeaturedAngelsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedAngelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedAngelsQuery>(FetchFeaturedAngelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedAngels');
    },
    fetchFeaturedCompaniesWithJobs(variables?: FetchFeaturedCompaniesWithJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedCompaniesWithJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedCompaniesWithJobsQuery>(FetchFeaturedCompaniesWithJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedCompaniesWithJobs');
    },
    fetchFeaturedJobs(variables?: FetchFeaturedJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedJobsQuery>(FetchFeaturedJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedJobs');
    },
    fetchFeaturedStartups(variables?: FetchFeaturedStartupsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedStartupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedStartupsQuery>(FetchFeaturedStartupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedStartups');
    },
    fetchFeaturedStories(variables?: FetchFeaturedStoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedStoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedStoriesQuery>(FetchFeaturedStoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedStories');
    },
    fetchFeaturedVentureCapitals(variables?: FetchFeaturedVentureCapitalsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFeaturedVentureCapitalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFeaturedVentureCapitalsQuery>(FetchFeaturedVentureCapitalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFeaturedVentureCapitals');
    },
    fetchFollowers(variables: FetchFollowersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFollowersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFollowersQuery>(FetchFollowersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFollowers');
    },
    fetchFollowing(variables: FetchFollowingQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchFollowingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchFollowingQuery>(FetchFollowingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchFollowing');
    },
    fetchJob(variables: FetchJobQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobQuery>(FetchJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJob');
    },
    fetchJobApplications(variables: FetchJobApplicationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobApplicationsQuery>(FetchJobApplicationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobApplications');
    },
    fetchJobBookmarks(variables?: FetchJobBookmarksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobBookmarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobBookmarksQuery>(FetchJobBookmarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobBookmarks');
    },
    fetchJobCategories(variables?: FetchJobCategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobCategoriesQuery>(FetchJobCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobCategories');
    },
    fetchJobFootprints(variables: FetchJobFootprintsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobFootprintsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobFootprintsQuery>(FetchJobFootprintsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobFootprints');
    },
    fetchJobSeekers(variables?: FetchJobSeekersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobSeekersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobSeekersQuery>(FetchJobSeekersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobSeekers');
    },
    fetchJobTags(variables?: FetchJobTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobTagsQuery>(FetchJobTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobTags');
    },
    fetchJobs(variables?: FetchJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchJobsQuery>(FetchJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchJobs');
    },
    fetchLocations(variables?: FetchLocationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchLocationsQuery>(FetchLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchLocations');
    },
    fetchMarkets(variables?: FetchMarketsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMarketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMarketsQuery>(FetchMarketsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMarkets');
    },
    fetchMe(variables?: FetchMeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMeQuery>(FetchMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMe');
    },
    fetchMyArticles(variables?: FetchMyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyArticlesQuery>(FetchMyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyArticles');
    },
    fetchMyCompany(variables: FetchMyCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyQuery>(FetchMyCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompany');
    },
    fetchMyCompanyArticles(variables: FetchMyCompanyArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyArticlesQuery>(FetchMyCompanyArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompanyArticles');
    },
    fetchMyCompanyReferences(variables: FetchMyCompanyReferencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyCompanyReferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyCompanyReferencesQuery>(FetchMyCompanyReferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyCompanyReferences');
    },
    fetchMyJobBookmarks(variables?: FetchMyJobBookmarksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyJobBookmarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyJobBookmarksQuery>(FetchMyJobBookmarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyJobBookmarks');
    },
    fetchMyJobs(variables: FetchMyJobsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyJobsQuery>(FetchMyJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyJobs');
    },
    fetchMyOffers(variables?: FetchMyOffersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyOffersQuery>(FetchMyOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyOffers');
    },
    fetchMyReferences(variables?: FetchMyReferencesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchMyReferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMyReferencesQuery>(FetchMyReferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMyReferences');
    },
    fetchNft(variables: FetchNftQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchNftQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchNftQuery>(FetchNftDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchNft');
    },
    fetchNfts(variables?: FetchNftsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchNftsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchNftsQuery>(FetchNftsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchNfts');
    },
    fetchNftsCount(variables?: FetchNftsCountQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchNftsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchNftsCountQuery>(FetchNftsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchNftsCount');
    },
    fetchNotifications(variables?: FetchNotificationsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchNotificationsQuery>(FetchNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchNotifications');
    },
    fetchOffer(variables: FetchOfferQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchOfferQuery>(FetchOfferDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchOffer');
    },
    fetchOffers(variables?: FetchOffersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchOffersQuery>(FetchOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchOffers');
    },
    fetchPickedUpFeatures(variables?: FetchPickedUpFeaturesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchPickedUpFeaturesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchPickedUpFeaturesQuery>(FetchPickedUpFeaturesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchPickedUpFeatures');
    },
    fetchQuestion(variables: FetchQuestionQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchQuestionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchQuestionQuery>(FetchQuestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchQuestion');
    },
    fetchQuestionCategories(variables?: FetchQuestionCategoriesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchQuestionCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchQuestionCategoriesQuery>(FetchQuestionCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchQuestionCategories');
    },
    fetchQuestions(variables?: FetchQuestionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchQuestionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchQuestionsQuery>(FetchQuestionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchQuestions');
    },
    fetchReply(variables: FetchReplyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchReplyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchReplyQuery>(FetchReplyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchReply');
    },
    fetchSkills(variables?: FetchSkillsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchSkillsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchSkillsQuery>(FetchSkillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchSkills');
    },
    fetchTokens(variables?: FetchTokensQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchTokensQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchTokensQuery>(FetchTokensDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchTokens');
    },
    fetchUser(variables: FetchUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserQuery>(FetchUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUser');
    },
    fetchUserArticles(variables?: FetchUserArticlesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserArticlesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserArticlesQuery>(FetchUserArticlesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserArticles');
    },
    fetchUserForViewer(variables: FetchUserForViewerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserForViewerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserForViewerQuery>(FetchUserForViewerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserForViewer');
    },
    fetchUserOffers(variables: FetchUserOffersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserOffersQuery>(FetchUserOffersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserOffers');
    },
    fetchUserQuestions(variables?: FetchUserQuestionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<FetchUserQuestionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchUserQuestionsQuery>(FetchUserQuestionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchUserQuestions');
    },
    searchCompany(variables: SearchCompanyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchCompanyQuery>(SearchCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchCompany');
    },
    searchUser(variables: SearchUserQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SearchUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchUserQuery>(SearchUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchUser');
    },
    validInvitationToken(variables: ValidInvitationTokenQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ValidInvitationTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidInvitationTokenQuery>(ValidInvitationTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'validInvitationToken');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;